var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
import { ref, computed, onMounted, defineComponent, openBlock, createElementBlock, normalizeClass, normalizeStyle, createTextVNode, toDisplayString, renderSlot, h, createCommentVNode, resolveComponent, createBlock, withCtx, createVNode, reactive, watchEffect, createElementVNode, Fragment, renderList, onUnmounted, Transition, watch, nextTick, Teleport, withKeys, withModifiers, mergeProps, toRefs, isRef, toRef, watchPostEffect, provide, inject, TransitionGroup } from "vue";
const version$1 = "1.30.2";
const toCamelCase = (str = "") => str.replace(/-(\w)/g, ($0, $1) => $1.toUpperCase());
const toKebab = (str = "") => str.replace(/([a-z])([A-Z])/g, "$1-$2").toLowerCase();
var elevation = "";
const useKeyboardFocus = (el) => {
  const currentElement = ref(null);
  let eventTarget = null;
  let hasEvents = false;
  let supportsPassiveEvent = { passive: false };
  const checkPassiveEventSupport = () => {
    try {
      const opts = Object.defineProperty({}, "passive", {
        get() {
          supportsPassiveEvent = { passive: true };
        }
      });
      window.addEventListener("ghost", () => {
      }, opts);
    } catch (e) {
      console.error(e);
    }
  };
  const setKeyboardInteraction = (event) => {
    currentElement.value = event.target;
  };
  const setMouseAndTouchInteraction = () => {
    currentElement.value = null;
  };
  const createKeyboardEvents = () => {
    eventTarget.addEventListener("keyup", setKeyboardInteraction);
  };
  const createPointerEvents = () => {
    eventTarget.addEventListener("pointerup", setMouseAndTouchInteraction);
  };
  const createMouseAndTouchEvents = () => {
    eventTarget.addEventListener("mouseup", setMouseAndTouchInteraction);
    if ("ontouchend" in window) {
      eventTarget.addEventListener("touchend", setMouseAndTouchInteraction, supportsPassiveEvent);
    }
  };
  const bindEvents = () => {
    if (window.PointerEvent) {
      createPointerEvents();
    } else {
      createMouseAndTouchEvents();
    }
    createKeyboardEvents();
  };
  const createEvents = () => {
    if (!hasEvents) {
      eventTarget = document.body;
      checkPassiveEventSupport();
      bindEvents();
      hasEvents = true;
    }
  };
  const hasFocus = computed(() => {
    if (el.value && currentElement.value) {
      return el.value === currentElement.value;
    } else {
      return false;
    }
  });
  onMounted(() => {
    createEvents();
  });
  return hasFocus;
};
const sdUuid = () => {
  return Math.random().toString(36).slice(4);
};
var SdIcon_vue_vue_type_style_index_0_lang = "";
var _export_sfc = (sfc, props) => {
  const target = sfc.__vccOpts || sfc;
  for (const [key, val] of props) {
    target[key] = val;
  }
  return target;
};
const _sfc_main$U = defineComponent({
  name: "SdIcon",
  props: {
    name: {
      type: String,
      default: "face"
    },
    size: {
      type: String,
      default: "md"
    },
    color: {
      type: String,
      default: ""
    }
  },
  setup(props) {
    const iconClasses = computed(() => {
      const iconSize = `is--${props.size}`;
      return {
        [iconSize]: !!props.size
      };
    });
    return { iconClasses };
  }
});
function _sfc_render$S(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("i", {
    class: normalizeClass(["sd--icon", _ctx.iconClasses]),
    style: normalizeStyle({ "color": _ctx.color })
  }, [
    createTextVNode(toDisplayString(_ctx.name) + " ", 1),
    renderSlot(_ctx.$slots, "default")
  ], 6);
}
var SdIcon = /* @__PURE__ */ _export_sfc(_sfc_main$U, [["render", _sfc_render$S]]);
var SdButton_vue_vue_type_style_index_0_lang = "";
const _sfc_main$T = defineComponent({
  name: "SdButton",
  components: { SdIcon },
  props: {
    id: {
      type: String,
      default: () => "sd--button--" + sdUuid()
    },
    size: {
      type: String,
      default: "md",
      validator: (value) => ["xs", "sm", "md", "lg", "xl"].indexOf(value) !== -1
    },
    theme: {
      type: String,
      default: "primary"
    },
    flat: {
      type: Boolean,
      default: false
    },
    outline: {
      type: Boolean,
      default: false
    },
    pill: {
      type: Boolean,
      default: false
    },
    rounded: {
      type: Boolean,
      default: false
    },
    block: {
      type: Boolean,
      default: false
    },
    align: {
      type: String,
      default: void 0
    },
    disabled: {
      type: Boolean,
      default: false
    },
    icon: {
      type: String,
      default: void 0
    },
    iconEnd: {
      type: String,
      default: void 0
    },
    iconOnly: {
      type: Boolean,
      default: false
    },
    casing: {
      type: String,
      default: void 0
    },
    type: {
      type: String,
      default: "button"
    },
    href: {
      type: String,
      default: void 0
    },
    active: Boolean,
    exactActive: Boolean,
    class: {
      type: [String, Array],
      default: ""
    },
    focusable: {
      type: Boolean,
      default: true
    }
  },
  setup(props, { slots, attrs }) {
    const root = ref(null);
    const hasSlots = (name) => !!slots[name];
    const hasFocus = useKeyboardFocus(root);
    const rootClasses = computed(() => {
      return {
        "is--disabled": props.disabled,
        "is--pill": props.pill || props.rounded,
        "is--flat": props.flat,
        "is--outline": props.outline,
        "is--icon-only": props.iconOnly,
        "is--block": props.block,
        "is--focused": hasFocus.value && props.focusable,
        "is--active": props.active,
        "is--exact-active": props.exactActive
      };
    });
    const alignmentStyle = computed(() => {
      return {
        "justify-content": props.align,
        "text-transform": props.casing
      };
    });
    const sizeClass = computed(() => {
      return `sd--button--${props.size}`;
    });
    const themeClass = computed(() => {
      return `sd--button__${props.theme}`;
    });
    const elementTag = computed(() => {
      const element = props.href || props.type === "link" ? "a" : "button";
      return element;
    });
    return () => h(elementTag.value, __spreadValues({
      ref: root,
      id: props.id,
      type: !props.href ? props.type : null,
      class: ["sd--button", themeClass.value, rootClasses.value, sizeClass.value, props.class],
      href: props.href,
      disabled: props.disabled,
      style: alignmentStyle.value
    }, attrs), [
      props.icon && h(SdIcon, {
        name: props.icon,
        size: props.size
      }),
      !props.iconOnly && hasSlots("default") && h("div", {
        class: "sd--button__content"
      }, slots),
      props.iconOnly && hasSlots("default") && h(slots["default"]),
      props.iconEnd && h(SdIcon, {
        name: props.iconEnd,
        size: props.size
      })
    ]);
  }
});
var SdButtonGroup_vue_vue_type_style_index_0_lang = "";
const _sfc_main$S = {
  name: "SdButtonGroup",
  props: {
    label: {
      type: String,
      default: void 0
    },
    vertical: {
      type: Boolean,
      default: false
    },
    full: {
      type: Boolean,
      default: false
    },
    elevation: {
      type: Number,
      default: 0
    }
  },
  setup(props) {
    const classes = computed(() => {
      return {
        "is--vertical": props.vertical,
        "is--full": props.full,
        [`elevation--${props.elevation}`]: props.elevation
      };
    });
    return {
      classes
    };
  }
};
const _hoisted_1$D = { key: 0 };
function _sfc_render$R(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("div", {
    class: normalizeClass(["sd--button-group", $setup.classes])
  }, [
    $props.label ? (openBlock(), createElementBlock("label", _hoisted_1$D, toDisplayString($props.label), 1)) : createCommentVNode("", true),
    renderSlot(_ctx.$slots, "default")
  ], 2);
}
var SdButtonGroup = /* @__PURE__ */ _export_sfc(_sfc_main$S, [["render", _sfc_render$R]]);
const _sfc_main$R = defineComponent({
  name: "SdRouterLink",
  components: {
    SdButton: _sfc_main$T
  },
  props: {
    to: {
      type: String,
      default: void 0
    },
    icon: {
      type: String,
      default: ""
    },
    iconOnly: Boolean,
    tabindex: {
      type: [String, Number],
      default: 0
    },
    flat: Boolean,
    outline: Boolean,
    pill: Boolean,
    disabled: Boolean,
    theme: {
      type: String,
      default: void 0
    },
    hash: Boolean
  }
});
function _sfc_render$Q(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_sd_button = resolveComponent("sd-button");
  const _component_router_link = resolveComponent("router-link");
  return openBlock(), createBlock(_component_router_link, {
    to: _ctx.to,
    custom: ""
  }, {
    default: withCtx(({ href, navigate, isActive, isExactActive }) => [
      createVNode(_component_sd_button, {
        onClick: navigate,
        tabindex: _ctx.tabindex,
        href,
        active: !_ctx.hash && isActive,
        theme: _ctx.theme,
        "exact-active": !_ctx.hash && isExactActive,
        outline: _ctx.outline,
        disabled: _ctx.disabled,
        icon: _ctx.icon,
        "icon-only": _ctx.iconOnly,
        flat: _ctx.flat,
        pill: _ctx.pill
      }, {
        default: withCtx(() => [
          renderSlot(_ctx.$slots, "default")
        ]),
        _: 2
      }, 1032, ["onClick", "tabindex", "href", "active", "theme", "exact-active", "outline", "disabled", "icon", "icon-only", "flat", "pill"])
    ]),
    _: 3
  }, 8, ["to"]);
}
var SdRouterLink = /* @__PURE__ */ _export_sfc(_sfc_main$R, [["render", _sfc_render$Q]]);
var defaultInstanceSettings = {
  update: null,
  begin: null,
  loopBegin: null,
  changeBegin: null,
  change: null,
  changeComplete: null,
  loopComplete: null,
  complete: null,
  loop: 1,
  direction: "normal",
  autoplay: true,
  timelineOffset: 0
};
var defaultTweenSettings = {
  duration: 1e3,
  delay: 0,
  endDelay: 0,
  easing: "easeOutElastic(1, .5)",
  round: 0
};
var validTransforms = ["translateX", "translateY", "translateZ", "rotate", "rotateX", "rotateY", "rotateZ", "scale", "scaleX", "scaleY", "scaleZ", "skew", "skewX", "skewY", "perspective", "matrix", "matrix3d"];
var cache = {
  CSS: {},
  springs: {}
};
function minMax$1(val, min2, max2) {
  return Math.min(Math.max(val, min2), max2);
}
function stringContains(str, text) {
  return str.indexOf(text) > -1;
}
function applyArguments(func, args) {
  return func.apply(null, args);
}
var is = {
  arr: function(a) {
    return Array.isArray(a);
  },
  obj: function(a) {
    return stringContains(Object.prototype.toString.call(a), "Object");
  },
  pth: function(a) {
    return is.obj(a) && a.hasOwnProperty("totalLength");
  },
  svg: function(a) {
    return a instanceof SVGElement;
  },
  inp: function(a) {
    return a instanceof HTMLInputElement;
  },
  dom: function(a) {
    return a.nodeType || is.svg(a);
  },
  str: function(a) {
    return typeof a === "string";
  },
  fnc: function(a) {
    return typeof a === "function";
  },
  und: function(a) {
    return typeof a === "undefined";
  },
  nil: function(a) {
    return is.und(a) || a === null;
  },
  hex: function(a) {
    return /(^#[0-9A-F]{6}$)|(^#[0-9A-F]{3}$)/i.test(a);
  },
  rgb: function(a) {
    return /^rgb/.test(a);
  },
  hsl: function(a) {
    return /^hsl/.test(a);
  },
  col: function(a) {
    return is.hex(a) || is.rgb(a) || is.hsl(a);
  },
  key: function(a) {
    return !defaultInstanceSettings.hasOwnProperty(a) && !defaultTweenSettings.hasOwnProperty(a) && a !== "targets" && a !== "keyframes";
  }
};
function parseEasingParameters(string) {
  var match = /\(([^)]+)\)/.exec(string);
  return match ? match[1].split(",").map(function(p) {
    return parseFloat(p);
  }) : [];
}
function spring(string, duration) {
  var params = parseEasingParameters(string);
  var mass = minMax$1(is.und(params[0]) ? 1 : params[0], 0.1, 100);
  var stiffness = minMax$1(is.und(params[1]) ? 100 : params[1], 0.1, 100);
  var damping = minMax$1(is.und(params[2]) ? 10 : params[2], 0.1, 100);
  var velocity = minMax$1(is.und(params[3]) ? 0 : params[3], 0.1, 100);
  var w0 = Math.sqrt(stiffness / mass);
  var zeta = damping / (2 * Math.sqrt(stiffness * mass));
  var wd = zeta < 1 ? w0 * Math.sqrt(1 - zeta * zeta) : 0;
  var a = 1;
  var b = zeta < 1 ? (zeta * w0 + -velocity) / wd : -velocity + w0;
  function solver(t) {
    var progress = duration ? duration * t / 1e3 : t;
    if (zeta < 1) {
      progress = Math.exp(-progress * zeta * w0) * (a * Math.cos(wd * progress) + b * Math.sin(wd * progress));
    } else {
      progress = (a + b * progress) * Math.exp(-progress * w0);
    }
    if (t === 0 || t === 1) {
      return t;
    }
    return 1 - progress;
  }
  function getDuration() {
    var cached = cache.springs[string];
    if (cached) {
      return cached;
    }
    var frame = 1 / 6;
    var elapsed = 0;
    var rest = 0;
    while (true) {
      elapsed += frame;
      if (solver(elapsed) === 1) {
        rest++;
        if (rest >= 16) {
          break;
        }
      } else {
        rest = 0;
      }
    }
    var duration2 = elapsed * frame * 1e3;
    cache.springs[string] = duration2;
    return duration2;
  }
  return duration ? solver : getDuration;
}
function steps(steps2) {
  if (steps2 === void 0)
    steps2 = 10;
  return function(t) {
    return Math.ceil(minMax$1(t, 1e-6, 1) * steps2) * (1 / steps2);
  };
}
var bezier = function() {
  var kSplineTableSize = 11;
  var kSampleStepSize = 1 / (kSplineTableSize - 1);
  function A(aA1, aA2) {
    return 1 - 3 * aA2 + 3 * aA1;
  }
  function B(aA1, aA2) {
    return 3 * aA2 - 6 * aA1;
  }
  function C(aA1) {
    return 3 * aA1;
  }
  function calcBezier(aT, aA1, aA2) {
    return ((A(aA1, aA2) * aT + B(aA1, aA2)) * aT + C(aA1)) * aT;
  }
  function getSlope(aT, aA1, aA2) {
    return 3 * A(aA1, aA2) * aT * aT + 2 * B(aA1, aA2) * aT + C(aA1);
  }
  function binarySubdivide(aX, aA, aB, mX1, mX2) {
    var currentX, currentT, i = 0;
    do {
      currentT = aA + (aB - aA) / 2;
      currentX = calcBezier(currentT, mX1, mX2) - aX;
      if (currentX > 0) {
        aB = currentT;
      } else {
        aA = currentT;
      }
    } while (Math.abs(currentX) > 1e-7 && ++i < 10);
    return currentT;
  }
  function newtonRaphsonIterate(aX, aGuessT, mX1, mX2) {
    for (var i = 0; i < 4; ++i) {
      var currentSlope = getSlope(aGuessT, mX1, mX2);
      if (currentSlope === 0) {
        return aGuessT;
      }
      var currentX = calcBezier(aGuessT, mX1, mX2) - aX;
      aGuessT -= currentX / currentSlope;
    }
    return aGuessT;
  }
  function bezier2(mX1, mY1, mX2, mY2) {
    if (!(0 <= mX1 && mX1 <= 1 && 0 <= mX2 && mX2 <= 1)) {
      return;
    }
    var sampleValues = new Float32Array(kSplineTableSize);
    if (mX1 !== mY1 || mX2 !== mY2) {
      for (var i = 0; i < kSplineTableSize; ++i) {
        sampleValues[i] = calcBezier(i * kSampleStepSize, mX1, mX2);
      }
    }
    function getTForX(aX) {
      var intervalStart = 0;
      var currentSample = 1;
      var lastSample = kSplineTableSize - 1;
      for (; currentSample !== lastSample && sampleValues[currentSample] <= aX; ++currentSample) {
        intervalStart += kSampleStepSize;
      }
      --currentSample;
      var dist = (aX - sampleValues[currentSample]) / (sampleValues[currentSample + 1] - sampleValues[currentSample]);
      var guessForT = intervalStart + dist * kSampleStepSize;
      var initialSlope = getSlope(guessForT, mX1, mX2);
      if (initialSlope >= 1e-3) {
        return newtonRaphsonIterate(aX, guessForT, mX1, mX2);
      } else if (initialSlope === 0) {
        return guessForT;
      } else {
        return binarySubdivide(aX, intervalStart, intervalStart + kSampleStepSize, mX1, mX2);
      }
    }
    return function(x) {
      if (mX1 === mY1 && mX2 === mY2) {
        return x;
      }
      if (x === 0 || x === 1) {
        return x;
      }
      return calcBezier(getTForX(x), mY1, mY2);
    };
  }
  return bezier2;
}();
var penner = function() {
  var eases = { linear: function() {
    return function(t) {
      return t;
    };
  } };
  var functionEasings = {
    Sine: function() {
      return function(t) {
        return 1 - Math.cos(t * Math.PI / 2);
      };
    },
    Circ: function() {
      return function(t) {
        return 1 - Math.sqrt(1 - t * t);
      };
    },
    Back: function() {
      return function(t) {
        return t * t * (3 * t - 2);
      };
    },
    Bounce: function() {
      return function(t) {
        var pow2, b = 4;
        while (t < ((pow2 = Math.pow(2, --b)) - 1) / 11) {
        }
        return 1 / Math.pow(4, 3 - b) - 7.5625 * Math.pow((pow2 * 3 - 2) / 22 - t, 2);
      };
    },
    Elastic: function(amplitude, period) {
      if (amplitude === void 0)
        amplitude = 1;
      if (period === void 0)
        period = 0.5;
      var a = minMax$1(amplitude, 1, 10);
      var p = minMax$1(period, 0.1, 2);
      return function(t) {
        return t === 0 || t === 1 ? t : -a * Math.pow(2, 10 * (t - 1)) * Math.sin((t - 1 - p / (Math.PI * 2) * Math.asin(1 / a)) * (Math.PI * 2) / p);
      };
    }
  };
  var baseEasings = ["Quad", "Cubic", "Quart", "Quint", "Expo"];
  baseEasings.forEach(function(name, i) {
    functionEasings[name] = function() {
      return function(t) {
        return Math.pow(t, i + 2);
      };
    };
  });
  Object.keys(functionEasings).forEach(function(name) {
    var easeIn = functionEasings[name];
    eases["easeIn" + name] = easeIn;
    eases["easeOut" + name] = function(a, b) {
      return function(t) {
        return 1 - easeIn(a, b)(1 - t);
      };
    };
    eases["easeInOut" + name] = function(a, b) {
      return function(t) {
        return t < 0.5 ? easeIn(a, b)(t * 2) / 2 : 1 - easeIn(a, b)(t * -2 + 2) / 2;
      };
    };
    eases["easeOutIn" + name] = function(a, b) {
      return function(t) {
        return t < 0.5 ? (1 - easeIn(a, b)(1 - t * 2)) / 2 : (easeIn(a, b)(t * 2 - 1) + 1) / 2;
      };
    };
  });
  return eases;
}();
function parseEasings(easing, duration) {
  if (is.fnc(easing)) {
    return easing;
  }
  var name = easing.split("(")[0];
  var ease = penner[name];
  var args = parseEasingParameters(easing);
  switch (name) {
    case "spring":
      return spring(easing, duration);
    case "cubicBezier":
      return applyArguments(bezier, args);
    case "steps":
      return applyArguments(steps, args);
    default:
      return applyArguments(ease, args);
  }
}
function selectString(str) {
  try {
    var nodes = document.querySelectorAll(str);
    return nodes;
  } catch (e) {
    return;
  }
}
function filterArray(arr, callback) {
  var len = arr.length;
  var thisArg = arguments.length >= 2 ? arguments[1] : void 0;
  var result = [];
  for (var i = 0; i < len; i++) {
    if (i in arr) {
      var val = arr[i];
      if (callback.call(thisArg, val, i, arr)) {
        result.push(val);
      }
    }
  }
  return result;
}
function flattenArray(arr) {
  return arr.reduce(function(a, b) {
    return a.concat(is.arr(b) ? flattenArray(b) : b);
  }, []);
}
function toArray(o) {
  if (is.arr(o)) {
    return o;
  }
  if (is.str(o)) {
    o = selectString(o) || o;
  }
  if (o instanceof NodeList || o instanceof HTMLCollection) {
    return [].slice.call(o);
  }
  return [o];
}
function arrayContains(arr, val) {
  return arr.some(function(a) {
    return a === val;
  });
}
function cloneObject(o) {
  var clone = {};
  for (var p in o) {
    clone[p] = o[p];
  }
  return clone;
}
function replaceObjectProps(o1, o2) {
  var o = cloneObject(o1);
  for (var p in o1) {
    o[p] = o2.hasOwnProperty(p) ? o2[p] : o1[p];
  }
  return o;
}
function mergeObjects(o1, o2) {
  var o = cloneObject(o1);
  for (var p in o2) {
    o[p] = is.und(o1[p]) ? o2[p] : o1[p];
  }
  return o;
}
function rgbToRgba(rgbValue) {
  var rgb = /rgb\((\d+,\s*[\d]+,\s*[\d]+)\)/g.exec(rgbValue);
  return rgb ? "rgba(" + rgb[1] + ",1)" : rgbValue;
}
function hexToRgba(hexValue) {
  var rgx = /^#?([a-f\d])([a-f\d])([a-f\d])$/i;
  var hex = hexValue.replace(rgx, function(m, r2, g2, b2) {
    return r2 + r2 + g2 + g2 + b2 + b2;
  });
  var rgb = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
  var r = parseInt(rgb[1], 16);
  var g = parseInt(rgb[2], 16);
  var b = parseInt(rgb[3], 16);
  return "rgba(" + r + "," + g + "," + b + ",1)";
}
function hslToRgba(hslValue) {
  var hsl = /hsl\((\d+),\s*([\d.]+)%,\s*([\d.]+)%\)/g.exec(hslValue) || /hsla\((\d+),\s*([\d.]+)%,\s*([\d.]+)%,\s*([\d.]+)\)/g.exec(hslValue);
  var h2 = parseInt(hsl[1], 10) / 360;
  var s = parseInt(hsl[2], 10) / 100;
  var l = parseInt(hsl[3], 10) / 100;
  var a = hsl[4] || 1;
  function hue2rgb(p2, q2, t) {
    if (t < 0) {
      t += 1;
    }
    if (t > 1) {
      t -= 1;
    }
    if (t < 1 / 6) {
      return p2 + (q2 - p2) * 6 * t;
    }
    if (t < 1 / 2) {
      return q2;
    }
    if (t < 2 / 3) {
      return p2 + (q2 - p2) * (2 / 3 - t) * 6;
    }
    return p2;
  }
  var r, g, b;
  if (s == 0) {
    r = g = b = l;
  } else {
    var q = l < 0.5 ? l * (1 + s) : l + s - l * s;
    var p = 2 * l - q;
    r = hue2rgb(p, q, h2 + 1 / 3);
    g = hue2rgb(p, q, h2);
    b = hue2rgb(p, q, h2 - 1 / 3);
  }
  return "rgba(" + r * 255 + "," + g * 255 + "," + b * 255 + "," + a + ")";
}
function colorToRgb(val) {
  if (is.rgb(val)) {
    return rgbToRgba(val);
  }
  if (is.hex(val)) {
    return hexToRgba(val);
  }
  if (is.hsl(val)) {
    return hslToRgba(val);
  }
}
function getUnit(val) {
  var split = /[+-]?\d*\.?\d+(?:\.\d+)?(?:[eE][+-]?\d+)?(%|px|pt|em|rem|in|cm|mm|ex|ch|pc|vw|vh|vmin|vmax|deg|rad|turn)?$/.exec(val);
  if (split) {
    return split[1];
  }
}
function getTransformUnit(propName) {
  if (stringContains(propName, "translate") || propName === "perspective") {
    return "px";
  }
  if (stringContains(propName, "rotate") || stringContains(propName, "skew")) {
    return "deg";
  }
}
function getFunctionValue(val, animatable) {
  if (!is.fnc(val)) {
    return val;
  }
  return val(animatable.target, animatable.id, animatable.total);
}
function getAttribute(el, prop) {
  return el.getAttribute(prop);
}
function convertPxToUnit(el, value, unit) {
  var valueUnit = getUnit(value);
  if (arrayContains([unit, "deg", "rad", "turn"], valueUnit)) {
    return value;
  }
  var cached = cache.CSS[value + unit];
  if (!is.und(cached)) {
    return cached;
  }
  var baseline = 100;
  var tempEl = document.createElement(el.tagName);
  var parentEl = el.parentNode && el.parentNode !== document ? el.parentNode : document.body;
  parentEl.appendChild(tempEl);
  tempEl.style.position = "absolute";
  tempEl.style.width = baseline + unit;
  var factor = baseline / tempEl.offsetWidth;
  parentEl.removeChild(tempEl);
  var convertedUnit = factor * parseFloat(value);
  cache.CSS[value + unit] = convertedUnit;
  return convertedUnit;
}
function getCSSValue(el, prop, unit) {
  if (prop in el.style) {
    var uppercasePropName = prop.replace(/([a-z])([A-Z])/g, "$1-$2").toLowerCase();
    var value = el.style[prop] || getComputedStyle(el).getPropertyValue(uppercasePropName) || "0";
    return unit ? convertPxToUnit(el, value, unit) : value;
  }
}
function getAnimationType(el, prop) {
  if (is.dom(el) && !is.inp(el) && (!is.nil(getAttribute(el, prop)) || is.svg(el) && el[prop])) {
    return "attribute";
  }
  if (is.dom(el) && arrayContains(validTransforms, prop)) {
    return "transform";
  }
  if (is.dom(el) && (prop !== "transform" && getCSSValue(el, prop))) {
    return "css";
  }
  if (el[prop] != null) {
    return "object";
  }
}
function getElementTransforms(el) {
  if (!is.dom(el)) {
    return;
  }
  var str = el.style.transform || "";
  var reg = /(\w+)\(([^)]*)\)/g;
  var transforms = /* @__PURE__ */ new Map();
  var m;
  while (m = reg.exec(str)) {
    transforms.set(m[1], m[2]);
  }
  return transforms;
}
function getTransformValue(el, propName, animatable, unit) {
  var defaultVal = stringContains(propName, "scale") ? 1 : 0 + getTransformUnit(propName);
  var value = getElementTransforms(el).get(propName) || defaultVal;
  if (animatable) {
    animatable.transforms.list.set(propName, value);
    animatable.transforms["last"] = propName;
  }
  return unit ? convertPxToUnit(el, value, unit) : value;
}
function getOriginalTargetValue(target, propName, unit, animatable) {
  switch (getAnimationType(target, propName)) {
    case "transform":
      return getTransformValue(target, propName, animatable, unit);
    case "css":
      return getCSSValue(target, propName, unit);
    case "attribute":
      return getAttribute(target, propName);
    default:
      return target[propName] || 0;
  }
}
function getRelativeValue(to, from) {
  var operator = /^(\*=|\+=|-=)/.exec(to);
  if (!operator) {
    return to;
  }
  var u = getUnit(to) || 0;
  var x = parseFloat(from);
  var y = parseFloat(to.replace(operator[0], ""));
  switch (operator[0][0]) {
    case "+":
      return x + y + u;
    case "-":
      return x - y + u;
    case "*":
      return x * y + u;
  }
}
function validateValue(val, unit) {
  if (is.col(val)) {
    return colorToRgb(val);
  }
  if (/\s/g.test(val)) {
    return val;
  }
  var originalUnit = getUnit(val);
  var unitLess = originalUnit ? val.substr(0, val.length - originalUnit.length) : val;
  if (unit) {
    return unitLess + unit;
  }
  return unitLess;
}
function getDistance(p1, p2) {
  return Math.sqrt(Math.pow(p2.x - p1.x, 2) + Math.pow(p2.y - p1.y, 2));
}
function getCircleLength(el) {
  return Math.PI * 2 * getAttribute(el, "r");
}
function getRectLength(el) {
  return getAttribute(el, "width") * 2 + getAttribute(el, "height") * 2;
}
function getLineLength(el) {
  return getDistance({ x: getAttribute(el, "x1"), y: getAttribute(el, "y1") }, { x: getAttribute(el, "x2"), y: getAttribute(el, "y2") });
}
function getPolylineLength(el) {
  var points = el.points;
  var totalLength = 0;
  var previousPos;
  for (var i = 0; i < points.numberOfItems; i++) {
    var currentPos = points.getItem(i);
    if (i > 0) {
      totalLength += getDistance(previousPos, currentPos);
    }
    previousPos = currentPos;
  }
  return totalLength;
}
function getPolygonLength(el) {
  var points = el.points;
  return getPolylineLength(el) + getDistance(points.getItem(points.numberOfItems - 1), points.getItem(0));
}
function getTotalLength(el) {
  if (el.getTotalLength) {
    return el.getTotalLength();
  }
  switch (el.tagName.toLowerCase()) {
    case "circle":
      return getCircleLength(el);
    case "rect":
      return getRectLength(el);
    case "line":
      return getLineLength(el);
    case "polyline":
      return getPolylineLength(el);
    case "polygon":
      return getPolygonLength(el);
  }
}
function setDashoffset(el) {
  var pathLength = getTotalLength(el);
  el.setAttribute("stroke-dasharray", pathLength);
  return pathLength;
}
function getParentSvgEl(el) {
  var parentEl = el.parentNode;
  while (is.svg(parentEl)) {
    if (!is.svg(parentEl.parentNode)) {
      break;
    }
    parentEl = parentEl.parentNode;
  }
  return parentEl;
}
function getParentSvg(pathEl, svgData) {
  var svg = svgData || {};
  var parentSvgEl = svg.el || getParentSvgEl(pathEl);
  var rect = parentSvgEl.getBoundingClientRect();
  var viewBoxAttr = getAttribute(parentSvgEl, "viewBox");
  var width = rect.width;
  var height = rect.height;
  var viewBox = svg.viewBox || (viewBoxAttr ? viewBoxAttr.split(" ") : [0, 0, width, height]);
  return {
    el: parentSvgEl,
    viewBox,
    x: viewBox[0] / 1,
    y: viewBox[1] / 1,
    w: width,
    h: height,
    vW: viewBox[2],
    vH: viewBox[3]
  };
}
function getPath(path, percent) {
  var pathEl = is.str(path) ? selectString(path)[0] : path;
  var p = percent || 100;
  return function(property) {
    return {
      property,
      el: pathEl,
      svg: getParentSvg(pathEl),
      totalLength: getTotalLength(pathEl) * (p / 100)
    };
  };
}
function getPathProgress(path, progress, isPathTargetInsideSVG) {
  function point(offset2) {
    if (offset2 === void 0)
      offset2 = 0;
    var l = progress + offset2 >= 1 ? progress + offset2 : 0;
    return path.el.getPointAtLength(l);
  }
  var svg = getParentSvg(path.el, path.svg);
  var p = point();
  var p0 = point(-1);
  var p1 = point(1);
  var scaleX = isPathTargetInsideSVG ? 1 : svg.w / svg.vW;
  var scaleY = isPathTargetInsideSVG ? 1 : svg.h / svg.vH;
  switch (path.property) {
    case "x":
      return (p.x - svg.x) * scaleX;
    case "y":
      return (p.y - svg.y) * scaleY;
    case "angle":
      return Math.atan2(p1.y - p0.y, p1.x - p0.x) * 180 / Math.PI;
  }
}
function decomposeValue(val, unit) {
  var rgx = /[+-]?\d*\.?\d+(?:\.\d+)?(?:[eE][+-]?\d+)?/g;
  var value = validateValue(is.pth(val) ? val.totalLength : val, unit) + "";
  return {
    original: value,
    numbers: value.match(rgx) ? value.match(rgx).map(Number) : [0],
    strings: is.str(val) || unit ? value.split(rgx) : []
  };
}
function parseTargets(targets) {
  var targetsArray = targets ? flattenArray(is.arr(targets) ? targets.map(toArray) : toArray(targets)) : [];
  return filterArray(targetsArray, function(item, pos, self) {
    return self.indexOf(item) === pos;
  });
}
function getAnimatables(targets) {
  var parsed = parseTargets(targets);
  return parsed.map(function(t, i) {
    return { target: t, id: i, total: parsed.length, transforms: { list: getElementTransforms(t) } };
  });
}
function normalizePropertyTweens(prop, tweenSettings) {
  var settings = cloneObject(tweenSettings);
  if (/^spring/.test(settings.easing)) {
    settings.duration = spring(settings.easing);
  }
  if (is.arr(prop)) {
    var l = prop.length;
    var isFromTo = l === 2 && !is.obj(prop[0]);
    if (!isFromTo) {
      if (!is.fnc(tweenSettings.duration)) {
        settings.duration = tweenSettings.duration / l;
      }
    } else {
      prop = { value: prop };
    }
  }
  var propArray = is.arr(prop) ? prop : [prop];
  return propArray.map(function(v, i) {
    var obj = is.obj(v) && !is.pth(v) ? v : { value: v };
    if (is.und(obj.delay)) {
      obj.delay = !i ? tweenSettings.delay : 0;
    }
    if (is.und(obj.endDelay)) {
      obj.endDelay = i === propArray.length - 1 ? tweenSettings.endDelay : 0;
    }
    return obj;
  }).map(function(k) {
    return mergeObjects(k, settings);
  });
}
function flattenKeyframes(keyframes) {
  var propertyNames = filterArray(flattenArray(keyframes.map(function(key) {
    return Object.keys(key);
  })), function(p) {
    return is.key(p);
  }).reduce(function(a, b) {
    if (a.indexOf(b) < 0) {
      a.push(b);
    }
    return a;
  }, []);
  var properties = {};
  var loop = function(i2) {
    var propName = propertyNames[i2];
    properties[propName] = keyframes.map(function(key) {
      var newKey = {};
      for (var p in key) {
        if (is.key(p)) {
          if (p == propName) {
            newKey.value = key[p];
          }
        } else {
          newKey[p] = key[p];
        }
      }
      return newKey;
    });
  };
  for (var i = 0; i < propertyNames.length; i++)
    loop(i);
  return properties;
}
function getProperties(tweenSettings, params) {
  var properties = [];
  var keyframes = params.keyframes;
  if (keyframes) {
    params = mergeObjects(flattenKeyframes(keyframes), params);
  }
  for (var p in params) {
    if (is.key(p)) {
      properties.push({
        name: p,
        tweens: normalizePropertyTweens(params[p], tweenSettings)
      });
    }
  }
  return properties;
}
function normalizeTweenValues(tween, animatable) {
  var t = {};
  for (var p in tween) {
    var value = getFunctionValue(tween[p], animatable);
    if (is.arr(value)) {
      value = value.map(function(v) {
        return getFunctionValue(v, animatable);
      });
      if (value.length === 1) {
        value = value[0];
      }
    }
    t[p] = value;
  }
  t.duration = parseFloat(t.duration);
  t.delay = parseFloat(t.delay);
  return t;
}
function normalizeTweens(prop, animatable) {
  var previousTween;
  return prop.tweens.map(function(t) {
    var tween = normalizeTweenValues(t, animatable);
    var tweenValue = tween.value;
    var to = is.arr(tweenValue) ? tweenValue[1] : tweenValue;
    var toUnit = getUnit(to);
    var originalValue = getOriginalTargetValue(animatable.target, prop.name, toUnit, animatable);
    var previousValue = previousTween ? previousTween.to.original : originalValue;
    var from = is.arr(tweenValue) ? tweenValue[0] : previousValue;
    var fromUnit = getUnit(from) || getUnit(originalValue);
    var unit = toUnit || fromUnit;
    if (is.und(to)) {
      to = previousValue;
    }
    tween.from = decomposeValue(from, unit);
    tween.to = decomposeValue(getRelativeValue(to, from), unit);
    tween.start = previousTween ? previousTween.end : 0;
    tween.end = tween.start + tween.delay + tween.duration + tween.endDelay;
    tween.easing = parseEasings(tween.easing, tween.duration);
    tween.isPath = is.pth(tweenValue);
    tween.isPathTargetInsideSVG = tween.isPath && is.svg(animatable.target);
    tween.isColor = is.col(tween.from.original);
    if (tween.isColor) {
      tween.round = 1;
    }
    previousTween = tween;
    return tween;
  });
}
var setProgressValue = {
  css: function(t, p, v) {
    return t.style[p] = v;
  },
  attribute: function(t, p, v) {
    return t.setAttribute(p, v);
  },
  object: function(t, p, v) {
    return t[p] = v;
  },
  transform: function(t, p, v, transforms, manual) {
    transforms.list.set(p, v);
    if (p === transforms.last || manual) {
      var str = "";
      transforms.list.forEach(function(value, prop) {
        str += prop + "(" + value + ") ";
      });
      t.style.transform = str;
    }
  }
};
function setTargetsValue(targets, properties) {
  var animatables = getAnimatables(targets);
  animatables.forEach(function(animatable) {
    for (var property in properties) {
      var value = getFunctionValue(properties[property], animatable);
      var target = animatable.target;
      var valueUnit = getUnit(value);
      var originalValue = getOriginalTargetValue(target, property, valueUnit, animatable);
      var unit = valueUnit || getUnit(originalValue);
      var to = getRelativeValue(validateValue(value, unit), originalValue);
      var animType = getAnimationType(target, property);
      setProgressValue[animType](target, property, to, animatable.transforms, true);
    }
  });
}
function createAnimation(animatable, prop) {
  var animType = getAnimationType(animatable.target, prop.name);
  if (animType) {
    var tweens = normalizeTweens(prop, animatable);
    var lastTween = tweens[tweens.length - 1];
    return {
      type: animType,
      property: prop.name,
      animatable,
      tweens,
      duration: lastTween.end,
      delay: tweens[0].delay,
      endDelay: lastTween.endDelay
    };
  }
}
function getAnimations(animatables, properties) {
  return filterArray(flattenArray(animatables.map(function(animatable) {
    return properties.map(function(prop) {
      return createAnimation(animatable, prop);
    });
  })), function(a) {
    return !is.und(a);
  });
}
function getInstanceTimings(animations, tweenSettings) {
  var animLength = animations.length;
  var getTlOffset = function(anim) {
    return anim.timelineOffset ? anim.timelineOffset : 0;
  };
  var timings = {};
  timings.duration = animLength ? Math.max.apply(Math, animations.map(function(anim) {
    return getTlOffset(anim) + anim.duration;
  })) : tweenSettings.duration;
  timings.delay = animLength ? Math.min.apply(Math, animations.map(function(anim) {
    return getTlOffset(anim) + anim.delay;
  })) : tweenSettings.delay;
  timings.endDelay = animLength ? timings.duration - Math.max.apply(Math, animations.map(function(anim) {
    return getTlOffset(anim) + anim.duration - anim.endDelay;
  })) : tweenSettings.endDelay;
  return timings;
}
var instanceID = 0;
function createNewInstance(params) {
  var instanceSettings = replaceObjectProps(defaultInstanceSettings, params);
  var tweenSettings = replaceObjectProps(defaultTweenSettings, params);
  var properties = getProperties(tweenSettings, params);
  var animatables = getAnimatables(params.targets);
  var animations = getAnimations(animatables, properties);
  var timings = getInstanceTimings(animations, tweenSettings);
  var id = instanceID;
  instanceID++;
  return mergeObjects(instanceSettings, {
    id,
    children: [],
    animatables,
    animations,
    duration: timings.duration,
    delay: timings.delay,
    endDelay: timings.endDelay
  });
}
var activeInstances = [];
var engine = function() {
  var raf;
  function play() {
    if (!raf && (!isDocumentHidden() || !anime.suspendWhenDocumentHidden) && activeInstances.length > 0) {
      raf = requestAnimationFrame(step);
    }
  }
  function step(t) {
    var activeInstancesLength = activeInstances.length;
    var i = 0;
    while (i < activeInstancesLength) {
      var activeInstance = activeInstances[i];
      if (!activeInstance.paused) {
        activeInstance.tick(t);
        i++;
      } else {
        activeInstances.splice(i, 1);
        activeInstancesLength--;
      }
    }
    raf = i > 0 ? requestAnimationFrame(step) : void 0;
  }
  function handleVisibilityChange() {
    if (!anime.suspendWhenDocumentHidden) {
      return;
    }
    if (isDocumentHidden()) {
      raf = cancelAnimationFrame(raf);
    } else {
      activeInstances.forEach(function(instance) {
        return instance._onDocumentVisibility();
      });
      engine();
    }
  }
  if (typeof document !== "undefined") {
    document.addEventListener("visibilitychange", handleVisibilityChange);
  }
  return play;
}();
function isDocumentHidden() {
  return !!document && document.hidden;
}
function anime(params) {
  if (params === void 0)
    params = {};
  var startTime = 0, lastTime = 0, now = 0;
  var children, childrenLength = 0;
  var resolve = null;
  function makePromise(instance2) {
    var promise = window.Promise && new Promise(function(_resolve) {
      return resolve = _resolve;
    });
    instance2.finished = promise;
    return promise;
  }
  var instance = createNewInstance(params);
  makePromise(instance);
  function toggleInstanceDirection() {
    var direction = instance.direction;
    if (direction !== "alternate") {
      instance.direction = direction !== "normal" ? "normal" : "reverse";
    }
    instance.reversed = !instance.reversed;
    children.forEach(function(child) {
      return child.reversed = instance.reversed;
    });
  }
  function adjustTime(time) {
    return instance.reversed ? instance.duration - time : time;
  }
  function resetTime() {
    startTime = 0;
    lastTime = adjustTime(instance.currentTime) * (1 / anime.speed);
  }
  function seekChild(time, child) {
    if (child) {
      child.seek(time - child.timelineOffset);
    }
  }
  function syncInstanceChildren(time) {
    if (!instance.reversePlayback) {
      for (var i = 0; i < childrenLength; i++) {
        seekChild(time, children[i]);
      }
    } else {
      for (var i$1 = childrenLength; i$1--; ) {
        seekChild(time, children[i$1]);
      }
    }
  }
  function setAnimationsProgress(insTime) {
    var i = 0;
    var animations = instance.animations;
    var animationsLength = animations.length;
    while (i < animationsLength) {
      var anim = animations[i];
      var animatable = anim.animatable;
      var tweens = anim.tweens;
      var tweenLength = tweens.length - 1;
      var tween = tweens[tweenLength];
      if (tweenLength) {
        tween = filterArray(tweens, function(t) {
          return insTime < t.end;
        })[0] || tween;
      }
      var elapsed = minMax$1(insTime - tween.start - tween.delay, 0, tween.duration) / tween.duration;
      var eased = isNaN(elapsed) ? 1 : tween.easing(elapsed);
      var strings = tween.to.strings;
      var round2 = tween.round;
      var numbers = [];
      var toNumbersLength = tween.to.numbers.length;
      var progress = void 0;
      for (var n = 0; n < toNumbersLength; n++) {
        var value = void 0;
        var toNumber = tween.to.numbers[n];
        var fromNumber = tween.from.numbers[n] || 0;
        if (!tween.isPath) {
          value = fromNumber + eased * (toNumber - fromNumber);
        } else {
          value = getPathProgress(tween.value, eased * toNumber, tween.isPathTargetInsideSVG);
        }
        if (round2) {
          if (!(tween.isColor && n > 2)) {
            value = Math.round(value * round2) / round2;
          }
        }
        numbers.push(value);
      }
      var stringsLength = strings.length;
      if (!stringsLength) {
        progress = numbers[0];
      } else {
        progress = strings[0];
        for (var s = 0; s < stringsLength; s++) {
          strings[s];
          var b = strings[s + 1];
          var n$1 = numbers[s];
          if (!isNaN(n$1)) {
            if (!b) {
              progress += n$1 + " ";
            } else {
              progress += n$1 + b;
            }
          }
        }
      }
      setProgressValue[anim.type](animatable.target, anim.property, progress, animatable.transforms);
      anim.currentValue = progress;
      i++;
    }
  }
  function setCallback(cb) {
    if (instance[cb] && !instance.passThrough) {
      instance[cb](instance);
    }
  }
  function countIteration() {
    if (instance.remaining && instance.remaining !== true) {
      instance.remaining--;
    }
  }
  function setInstanceProgress(engineTime) {
    var insDuration = instance.duration;
    var insDelay = instance.delay;
    var insEndDelay = insDuration - instance.endDelay;
    var insTime = adjustTime(engineTime);
    instance.progress = minMax$1(insTime / insDuration * 100, 0, 100);
    instance.reversePlayback = insTime < instance.currentTime;
    if (children) {
      syncInstanceChildren(insTime);
    }
    if (!instance.began && instance.currentTime > 0) {
      instance.began = true;
      setCallback("begin");
    }
    if (!instance.loopBegan && instance.currentTime > 0) {
      instance.loopBegan = true;
      setCallback("loopBegin");
    }
    if (insTime <= insDelay && instance.currentTime !== 0) {
      setAnimationsProgress(0);
    }
    if (insTime >= insEndDelay && instance.currentTime !== insDuration || !insDuration) {
      setAnimationsProgress(insDuration);
    }
    if (insTime > insDelay && insTime < insEndDelay) {
      if (!instance.changeBegan) {
        instance.changeBegan = true;
        instance.changeCompleted = false;
        setCallback("changeBegin");
      }
      setCallback("change");
      setAnimationsProgress(insTime);
    } else {
      if (instance.changeBegan) {
        instance.changeCompleted = true;
        instance.changeBegan = false;
        setCallback("changeComplete");
      }
    }
    instance.currentTime = minMax$1(insTime, 0, insDuration);
    if (instance.began) {
      setCallback("update");
    }
    if (engineTime >= insDuration) {
      lastTime = 0;
      countIteration();
      if (!instance.remaining) {
        instance.paused = true;
        if (!instance.completed) {
          instance.completed = true;
          setCallback("loopComplete");
          setCallback("complete");
          if (!instance.passThrough && "Promise" in window) {
            resolve();
            makePromise(instance);
          }
        }
      } else {
        startTime = now;
        setCallback("loopComplete");
        instance.loopBegan = false;
        if (instance.direction === "alternate") {
          toggleInstanceDirection();
        }
      }
    }
  }
  instance.reset = function() {
    var direction = instance.direction;
    instance.passThrough = false;
    instance.currentTime = 0;
    instance.progress = 0;
    instance.paused = true;
    instance.began = false;
    instance.loopBegan = false;
    instance.changeBegan = false;
    instance.completed = false;
    instance.changeCompleted = false;
    instance.reversePlayback = false;
    instance.reversed = direction === "reverse";
    instance.remaining = instance.loop;
    children = instance.children;
    childrenLength = children.length;
    for (var i = childrenLength; i--; ) {
      instance.children[i].reset();
    }
    if (instance.reversed && instance.loop !== true || direction === "alternate" && instance.loop === 1) {
      instance.remaining++;
    }
    setAnimationsProgress(instance.reversed ? instance.duration : 0);
  };
  instance._onDocumentVisibility = resetTime;
  instance.set = function(targets, properties) {
    setTargetsValue(targets, properties);
    return instance;
  };
  instance.tick = function(t) {
    now = t;
    if (!startTime) {
      startTime = now;
    }
    setInstanceProgress((now + (lastTime - startTime)) * anime.speed);
  };
  instance.seek = function(time) {
    setInstanceProgress(adjustTime(time));
  };
  instance.pause = function() {
    instance.paused = true;
    resetTime();
  };
  instance.play = function() {
    if (!instance.paused) {
      return;
    }
    if (instance.completed) {
      instance.reset();
    }
    instance.paused = false;
    activeInstances.push(instance);
    resetTime();
    engine();
  };
  instance.reverse = function() {
    toggleInstanceDirection();
    instance.completed = instance.reversed ? false : true;
    resetTime();
  };
  instance.restart = function() {
    instance.reset();
    instance.play();
  };
  instance.remove = function(targets) {
    var targetsArray = parseTargets(targets);
    removeTargetsFromInstance(targetsArray, instance);
  };
  instance.reset();
  if (instance.autoplay) {
    instance.play();
  }
  return instance;
}
function removeTargetsFromAnimations(targetsArray, animations) {
  for (var a = animations.length; a--; ) {
    if (arrayContains(targetsArray, animations[a].animatable.target)) {
      animations.splice(a, 1);
    }
  }
}
function removeTargetsFromInstance(targetsArray, instance) {
  var animations = instance.animations;
  var children = instance.children;
  removeTargetsFromAnimations(targetsArray, animations);
  for (var c = children.length; c--; ) {
    var child = children[c];
    var childAnimations = child.animations;
    removeTargetsFromAnimations(targetsArray, childAnimations);
    if (!childAnimations.length && !child.children.length) {
      children.splice(c, 1);
    }
  }
  if (!animations.length && !children.length) {
    instance.pause();
  }
}
function removeTargetsFromActiveInstances(targets) {
  var targetsArray = parseTargets(targets);
  for (var i = activeInstances.length; i--; ) {
    var instance = activeInstances[i];
    removeTargetsFromInstance(targetsArray, instance);
  }
}
function stagger(val, params) {
  if (params === void 0)
    params = {};
  var direction = params.direction || "normal";
  var easing = params.easing ? parseEasings(params.easing) : null;
  var grid = params.grid;
  var axis = params.axis;
  var fromIndex = params.from || 0;
  var fromFirst = fromIndex === "first";
  var fromCenter = fromIndex === "center";
  var fromLast = fromIndex === "last";
  var isRange = is.arr(val);
  var val1 = isRange ? parseFloat(val[0]) : parseFloat(val);
  var val2 = isRange ? parseFloat(val[1]) : 0;
  var unit = getUnit(isRange ? val[1] : val) || 0;
  var start2 = params.start || 0 + (isRange ? val1 : 0);
  var values = [];
  var maxValue = 0;
  return function(el, i, t) {
    if (fromFirst) {
      fromIndex = 0;
    }
    if (fromCenter) {
      fromIndex = (t - 1) / 2;
    }
    if (fromLast) {
      fromIndex = t - 1;
    }
    if (!values.length) {
      for (var index = 0; index < t; index++) {
        if (!grid) {
          values.push(Math.abs(fromIndex - index));
        } else {
          var fromX = !fromCenter ? fromIndex % grid[0] : (grid[0] - 1) / 2;
          var fromY = !fromCenter ? Math.floor(fromIndex / grid[0]) : (grid[1] - 1) / 2;
          var toX = index % grid[0];
          var toY = Math.floor(index / grid[0]);
          var distanceX = fromX - toX;
          var distanceY = fromY - toY;
          var value = Math.sqrt(distanceX * distanceX + distanceY * distanceY);
          if (axis === "x") {
            value = -distanceX;
          }
          if (axis === "y") {
            value = -distanceY;
          }
          values.push(value);
        }
        maxValue = Math.max.apply(Math, values);
      }
      if (easing) {
        values = values.map(function(val3) {
          return easing(val3 / maxValue) * maxValue;
        });
      }
      if (direction === "reverse") {
        values = values.map(function(val3) {
          return axis ? val3 < 0 ? val3 * -1 : -val3 : Math.abs(maxValue - val3);
        });
      }
    }
    var spacing = isRange ? (val2 - val1) / maxValue : val1;
    return start2 + spacing * (Math.round(values[i] * 100) / 100) + unit;
  };
}
function timeline(params) {
  if (params === void 0)
    params = {};
  var tl = anime(params);
  tl.duration = 0;
  tl.add = function(instanceParams, timelineOffset) {
    var tlIndex = activeInstances.indexOf(tl);
    var children = tl.children;
    if (tlIndex > -1) {
      activeInstances.splice(tlIndex, 1);
    }
    function passThrough(ins2) {
      ins2.passThrough = true;
    }
    for (var i = 0; i < children.length; i++) {
      passThrough(children[i]);
    }
    var insParams = mergeObjects(instanceParams, replaceObjectProps(defaultTweenSettings, params));
    insParams.targets = insParams.targets || params.targets;
    var tlDuration = tl.duration;
    insParams.autoplay = false;
    insParams.direction = tl.direction;
    insParams.timelineOffset = is.und(timelineOffset) ? tlDuration : getRelativeValue(timelineOffset, tlDuration);
    passThrough(tl);
    tl.seek(insParams.timelineOffset);
    var ins = anime(insParams);
    passThrough(ins);
    children.push(ins);
    var timings = getInstanceTimings(children, params);
    tl.delay = timings.delay;
    tl.endDelay = timings.endDelay;
    tl.duration = timings.duration;
    tl.seek(0);
    tl.reset();
    if (tl.autoplay) {
      tl.play();
    }
    return tl;
  };
  return tl;
}
anime.version = "3.2.1";
anime.speed = 1;
anime.suspendWhenDocumentHidden = true;
anime.running = activeInstances;
anime.remove = removeTargetsFromActiveInstances;
anime.get = getOriginalTargetValue;
anime.set = setTargetsValue;
anime.convertPx = convertPxToUnit;
anime.path = getPath;
anime.setDashoffset = setDashoffset;
anime.stagger = stagger;
anime.timeline = timeline;
anime.easing = parseEasings;
anime.penner = penner;
anime.random = function(min2, max2) {
  return Math.floor(Math.random() * (max2 - min2 + 1)) + min2;
};
var SdHamburger_vue_vue_type_style_index_0_lang = "";
const _sfc_main$Q = defineComponent({
  name: "SdHamburger",
  props: {
    id: {
      type: String,
      default: () => "sd--hamburger--" + sdUuid()
    },
    active: Boolean,
    theme: {
      type: String,
      default: "auto"
    },
    animated: {
      type: Boolean,
      default: true
    }
  },
  emits: ["update:active"],
  setup(props, { emit }) {
    const hamburgerRef = ref(null);
    const hasFocus = useKeyboardFocus(hamburgerRef);
    const state = reactive({
      active: false
    });
    watchEffect(() => {
      state.active = props.active;
      animateHamburger(state.active);
    }, { flush: "post" });
    const classes = computed(() => {
      return {
        "sd--button": true,
        "sd--button__hamburger": true,
        "sd--button__flat": true,
        "is--focused": hasFocus.value,
        "is--active": props.active
      };
    });
    const activeClass = computed(() => {
      return {
        "is--active": props.active,
        [`is--${props.theme}`]: !!props.theme
      };
    });
    const animateHamburger = (open) => {
      const tl = anime.timeline({
        duration: 250,
        easing: "easeInOutQuart"
      });
      if (!open) {
        tl.add({
          targets: `#${props.id} .bar--1`,
          keyframes: [
            { rotateZ: 0, translateY: 0, translateX: 0, easing: "easeInOutQuad" },
            { width: 24, easing: "easeInOutQuad" }
          ]
        }, 0).add({
          targets: `#${props.id} .bar--3`,
          keyframes: [
            { rotateZ: 0, translateY: 0, translateX: 0, easing: "easeInOutQuad" },
            { width: 24, easing: "easeInOutQuad" }
          ]
        }, 0).add({
          targets: `#${props.id} .bar--2`,
          keyframes: [
            { width: 24, translateX: 0, easing: "easeInOutQuad" }
          ]
        }, 0);
      } else {
        tl.add({
          targets: `#${props.id} .bar--1`,
          keyframes: [
            { width: 12, easing: "easeInOutQuad" },
            { rotateZ: -45, translateY: 7, translateX: -4, easing: "easeInOutQuad" }
          ]
        }, 0).add({
          targets: `#${props.id} .bar--3`,
          keyframes: [
            { width: 12, easing: "easeInOutQuad" },
            { rotateZ: 45, translateY: -7, translateX: -4, easing: "easeInOutQuad" }
          ]
        }, 0).add({
          targets: `#${props.id} .bar--2`,
          keyframes: [
            { width: 21, translateX: 3, easing: "easeInOutQuad" },
            { translateX: 3 }
          ]
        }, 0);
      }
    };
    const handleToggle = () => {
      state.active = !props.active;
      emit("update:active", state.active);
    };
    return {
      hasFocus,
      handleToggle,
      classes,
      activeClass,
      hamburgerRef
    };
  }
});
const _hoisted_1$C = ["id"];
function _sfc_render$P(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("button", {
    ref: "hamburgerRef",
    id: _ctx.id,
    class: normalizeClass(_ctx.classes),
    onClick: _cache[0] || (_cache[0] = (e) => _ctx.handleToggle(e))
  }, [
    createElementVNode("span", {
      class: normalizeClass(["sd--hamburger", _ctx.activeClass])
    }, [
      (openBlock(), createElementBlock(Fragment, null, renderList(3, (n) => {
        return createElementVNode("i", {
          class: normalizeClass(["sd--hamburger__bar", `bar--${n}`]),
          key: n
        }, null, 2);
      }), 64))
    ], 2)
  ], 10, _hoisted_1$C);
}
var SdHamburger = /* @__PURE__ */ _export_sfc(_sfc_main$Q, [["render", _sfc_render$P]]);
var SdCard_vue_vue_type_style_index_0_lang = "";
const _sfc_main$P = defineComponent({
  name: "SdCard",
  props: {
    title: {
      type: String,
      default: ""
    },
    baseClass: {
      type: String,
      default: "sd--card"
    },
    elevation: {
      type: [Number, String],
      default: 6
    },
    clickable: {
      type: Boolean,
      default: false
    }
  },
  setup(props) {
    const classes = computed(() => {
      return {
        [`elevation--${props.elevation}`]: true,
        "is--clickable": props.clickable
      };
    });
    return { classes };
  }
});
function _sfc_render$O(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("div", {
    class: normalizeClass(["sd--card", _ctx.classes])
  }, [
    renderSlot(_ctx.$slots, "default")
  ], 2);
}
var SdCard = /* @__PURE__ */ _export_sfc(_sfc_main$P, [["render", _sfc_render$O]]);
var SdCardBody_vue_vue_type_style_index_0_lang = "";
const _sfc_main$O = defineComponent({
  name: "SdCardBody"
});
const _hoisted_1$B = { class: "sd--card__body" };
function _sfc_render$N(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("div", _hoisted_1$B, [
    renderSlot(_ctx.$slots, "default")
  ]);
}
var SdCardBody = /* @__PURE__ */ _export_sfc(_sfc_main$O, [["render", _sfc_render$N]]);
var SdCardHeader_vue_vue_type_style_index_0_lang = "";
const _sfc_main$N = defineComponent({
  name: "SdCardHeader",
  props: {
    title: {
      type: String,
      default: void 0
    },
    subtitle: {
      type: String,
      default: void 0
    },
    inline: Boolean
  },
  setup(props) {
    const classes = computed(() => {
      return {
        "is--inline": props.inline
      };
    });
    return {
      classes
    };
  }
});
const _hoisted_1$A = { class: "sd--card__header" };
const _hoisted_2$i = {
  key: 0,
  class: "sd--text__header"
};
const _hoisted_3$b = {
  key: 1,
  class: "sd--text__caption"
};
function _sfc_render$M(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("div", _hoisted_1$A, [
    _ctx.title || _ctx.subtitle ? (openBlock(), createElementBlock("div", {
      key: 0,
      class: normalizeClass(["sd--card__header-group", _ctx.classes])
    }, [
      _ctx.title ? (openBlock(), createElementBlock("h3", _hoisted_2$i, toDisplayString(_ctx.title), 1)) : createCommentVNode("", true),
      _ctx.subtitle ? (openBlock(), createElementBlock("p", _hoisted_3$b, toDisplayString(_ctx.subtitle), 1)) : createCommentVNode("", true)
    ], 2)) : createCommentVNode("", true),
    renderSlot(_ctx.$slots, "default")
  ]);
}
var SdCardHeader = /* @__PURE__ */ _export_sfc(_sfc_main$N, [["render", _sfc_render$M]]);
var SdCardFooter_vue_vue_type_style_index_0_lang = "";
const _sfc_main$M = defineComponent({
  name: "SdCardFooter",
  props: {
    align: {
      type: String,
      default: "flex-start"
    },
    direction: {
      type: String,
      default: "initial"
    }
  },
  setup(props) {
    const alignmentStyle = computed(() => {
      return {
        "justify-content": props.align
      };
    });
    return { alignmentStyle };
  }
});
function _sfc_render$L(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("div", {
    class: "sd--card__footer",
    style: normalizeStyle(_ctx.alignmentStyle)
  }, [
    renderSlot(_ctx.$slots, "default")
  ], 4);
}
var SdCardFooter = /* @__PURE__ */ _export_sfc(_sfc_main$M, [["render", _sfc_render$L]]);
var SdCardMedia_vue_vue_type_style_index_0_lang = "";
const _sfc_main$L = defineComponent({
  name: "SdCardMedia",
  props: {
    ratio: {
      type: String,
      default: "1x1",
      validator: (value) => {
        return [
          "16-9",
          "16/9",
          "16:9",
          "16x9",
          "4-3",
          "4/3",
          "4:3",
          "4x3",
          "1-1",
          "1/1",
          "1:1",
          "1x1"
        ].indexOf(value) !== -1;
      }
    },
    size: {
      type: String,
      default: "md",
      validator: (value) => {
        return [
          "sm",
          "md",
          "lg"
        ].indexOf(value) !== -1;
      }
    }
  },
  setup(props) {
    const getRatioFormat = (divider) => {
      return props.ratio.indexOf(divider) !== -1;
    };
    const getAspectRatio = computed(() => {
      let ratio = [];
      if (getRatioFormat(":")) {
        ratio = props.ratio.split(":");
      } else if (getRatioFormat("/")) {
        ratio = props.ratio.split("/");
      } else if (getRatioFormat("-")) {
        ratio = props.ratio.split("-");
      } else if (getRatioFormat("x")) {
        ratio = props.ratio.split("x");
      }
      return ratio.length === 2 ? ratio : null;
    });
    const mediaSize = computed(() => {
      return `sd--card__media--${props.size}`;
    });
    const mediaClasses = computed(() => {
      let classes = "";
      if (props.ratio) {
        const ratio = getAspectRatio.value;
        if (ratio) {
          const [horz, vert] = ratio;
          classes = `sd--card__media--${horz}-${vert}`;
        }
      }
      return classes;
    });
    return { mediaClasses, mediaSize, getAspectRatio };
  }
});
function _sfc_render$K(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("div", {
    class: normalizeClass(["sd--card__media", _ctx.mediaClasses, _ctx.mediaSize])
  }, [
    renderSlot(_ctx.$slots, "default")
  ], 2);
}
var SdCardMedia = /* @__PURE__ */ _export_sfc(_sfc_main$L, [["render", _sfc_render$K]]);
/*!
* tabbable 5.3.1
* @license MIT, https://github.com/focus-trap/tabbable/blob/master/LICENSE
*/
var candidateSelectors = ["input", "select", "textarea", "a[href]", "button", "[tabindex]:not(slot)", "audio[controls]", "video[controls]", '[contenteditable]:not([contenteditable="false"])', "details>summary:first-of-type", "details"];
var candidateSelector = /* @__PURE__ */ candidateSelectors.join(",");
var NoElement = typeof Element === "undefined";
var matches = NoElement ? function() {
} : Element.prototype.matches || Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector;
var getRootNode = !NoElement && Element.prototype.getRootNode ? function(element) {
  return element.getRootNode();
} : function(element) {
  return element.ownerDocument;
};
var getCandidates = function getCandidates2(el, includeContainer, filter) {
  var candidates = Array.prototype.slice.apply(el.querySelectorAll(candidateSelector));
  if (includeContainer && matches.call(el, candidateSelector)) {
    candidates.unshift(el);
  }
  candidates = candidates.filter(filter);
  return candidates;
};
var getCandidatesIteratively = function getCandidatesIteratively2(elements, includeContainer, options) {
  var candidates = [];
  var elementsToCheck = Array.from(elements);
  while (elementsToCheck.length) {
    var element = elementsToCheck.shift();
    if (element.tagName === "SLOT") {
      var assigned = element.assignedElements();
      var content = assigned.length ? assigned : element.children;
      var nestedCandidates = getCandidatesIteratively2(content, true, options);
      if (options.flatten) {
        candidates.push.apply(candidates, nestedCandidates);
      } else {
        candidates.push({
          scope: element,
          candidates: nestedCandidates
        });
      }
    } else {
      var validCandidate = matches.call(element, candidateSelector);
      if (validCandidate && options.filter(element) && (includeContainer || !elements.includes(element))) {
        candidates.push(element);
      }
      var shadowRoot = element.shadowRoot || typeof options.getShadowRoot === "function" && options.getShadowRoot(element);
      if (shadowRoot) {
        var _nestedCandidates = getCandidatesIteratively2(shadowRoot === true ? element.children : shadowRoot.children, true, options);
        if (options.flatten) {
          candidates.push.apply(candidates, _nestedCandidates);
        } else {
          candidates.push({
            scope: element,
            candidates: _nestedCandidates
          });
        }
      } else {
        elementsToCheck.unshift.apply(elementsToCheck, element.children);
      }
    }
  }
  return candidates;
};
var getTabindex = function getTabindex2(node, isScope) {
  if (node.tabIndex < 0) {
    if ((isScope || /^(AUDIO|VIDEO|DETAILS)$/.test(node.tagName) || node.isContentEditable) && isNaN(parseInt(node.getAttribute("tabindex"), 10))) {
      return 0;
    }
  }
  return node.tabIndex;
};
var sortOrderedTabbables = function sortOrderedTabbables2(a, b) {
  return a.tabIndex === b.tabIndex ? a.documentOrder - b.documentOrder : a.tabIndex - b.tabIndex;
};
var isInput = function isInput2(node) {
  return node.tagName === "INPUT";
};
var isHiddenInput = function isHiddenInput2(node) {
  return isInput(node) && node.type === "hidden";
};
var isDetailsWithSummary = function isDetailsWithSummary2(node) {
  var r = node.tagName === "DETAILS" && Array.prototype.slice.apply(node.children).some(function(child) {
    return child.tagName === "SUMMARY";
  });
  return r;
};
var getCheckedRadio = function getCheckedRadio2(nodes, form) {
  for (var i = 0; i < nodes.length; i++) {
    if (nodes[i].checked && nodes[i].form === form) {
      return nodes[i];
    }
  }
};
var isTabbableRadio = function isTabbableRadio2(node) {
  if (!node.name) {
    return true;
  }
  var radioScope = node.form || getRootNode(node);
  var queryRadios = function queryRadios2(name) {
    return radioScope.querySelectorAll('input[type="radio"][name="' + name + '"]');
  };
  var radioSet;
  if (typeof window !== "undefined" && typeof window.CSS !== "undefined" && typeof window.CSS.escape === "function") {
    radioSet = queryRadios(window.CSS.escape(node.name));
  } else {
    try {
      radioSet = queryRadios(node.name);
    } catch (err) {
      console.error("Looks like you have a radio button with a name attribute containing invalid CSS selector characters and need the CSS.escape polyfill: %s", err.message);
      return false;
    }
  }
  var checked = getCheckedRadio(radioSet, node.form);
  return !checked || checked === node;
};
var isRadio = function isRadio2(node) {
  return isInput(node) && node.type === "radio";
};
var isNonTabbableRadio = function isNonTabbableRadio2(node) {
  return isRadio(node) && !isTabbableRadio(node);
};
var isZeroArea = function isZeroArea2(node) {
  var _node$getBoundingClie = node.getBoundingClientRect(), width = _node$getBoundingClie.width, height = _node$getBoundingClie.height;
  return width === 0 && height === 0;
};
var isHidden = function isHidden2(node, _ref) {
  var displayCheck = _ref.displayCheck, getShadowRoot = _ref.getShadowRoot;
  if (getComputedStyle(node).visibility === "hidden") {
    return true;
  }
  var isDirectSummary = matches.call(node, "details>summary:first-of-type");
  var nodeUnderDetails = isDirectSummary ? node.parentElement : node;
  if (matches.call(nodeUnderDetails, "details:not([open]) *")) {
    return true;
  }
  if (!displayCheck || displayCheck === "full") {
    if (typeof getShadowRoot === "function") {
      var originalNode = node;
      while (node) {
        var parentElement = node.parentElement;
        var rootNode = getRootNode(node);
        if (parentElement && !parentElement.shadowRoot && getShadowRoot(parentElement) === true) {
          return isZeroArea(node);
        } else if (node.assignedSlot) {
          node = node.assignedSlot;
        } else if (!parentElement && rootNode !== node.ownerDocument) {
          node = rootNode.host;
        } else {
          node = parentElement;
        }
      }
      node = originalNode;
    }
    return !node.getClientRects().length;
  } else if (displayCheck === "non-zero-area") {
    return isZeroArea(node);
  }
  return false;
};
var isDisabledFromFieldset = function isDisabledFromFieldset2(node) {
  if (/^(INPUT|BUTTON|SELECT|TEXTAREA)$/.test(node.tagName)) {
    var parentNode = node.parentElement;
    while (parentNode) {
      if (parentNode.tagName === "FIELDSET" && parentNode.disabled) {
        for (var i = 0; i < parentNode.children.length; i++) {
          var child = parentNode.children.item(i);
          if (child.tagName === "LEGEND") {
            return matches.call(parentNode, "fieldset[disabled] *") ? true : !child.contains(node);
          }
        }
        return true;
      }
      parentNode = parentNode.parentElement;
    }
  }
  return false;
};
var isNodeMatchingSelectorFocusable = function isNodeMatchingSelectorFocusable2(options, node) {
  if (node.disabled || isHiddenInput(node) || isHidden(node, options) || isDetailsWithSummary(node) || isDisabledFromFieldset(node)) {
    return false;
  }
  return true;
};
var isNodeMatchingSelectorTabbable = function isNodeMatchingSelectorTabbable2(options, node) {
  if (isNonTabbableRadio(node) || getTabindex(node) < 0 || !isNodeMatchingSelectorFocusable(options, node)) {
    return false;
  }
  return true;
};
var sortByOrder = function sortByOrder2(candidates) {
  var regularTabbables = [];
  var orderedTabbables = [];
  candidates.forEach(function(item, i) {
    var isScope = !!item.scope;
    var element = isScope ? item.scope : item;
    var candidateTabindex = getTabindex(element, isScope);
    var elements = isScope ? sortByOrder2(item.candidates) : element;
    if (candidateTabindex === 0) {
      isScope ? regularTabbables.push.apply(regularTabbables, elements) : regularTabbables.push(element);
    } else {
      orderedTabbables.push({
        documentOrder: i,
        tabIndex: candidateTabindex,
        item,
        isScope,
        content: elements
      });
    }
  });
  return orderedTabbables.sort(sortOrderedTabbables).reduce(function(acc, sortable) {
    sortable.isScope ? acc.push.apply(acc, sortable.content) : acc.push(sortable.content);
    return acc;
  }, []).concat(regularTabbables);
};
var tabbable = function tabbable2(el, options) {
  options = options || {};
  var candidates;
  if (options.getShadowRoot) {
    candidates = getCandidatesIteratively([el], options.includeContainer, {
      filter: isNodeMatchingSelectorTabbable.bind(null, options),
      flatten: false,
      getShadowRoot: options.getShadowRoot
    });
  } else {
    candidates = getCandidates(el, options.includeContainer, isNodeMatchingSelectorTabbable.bind(null, options));
  }
  return sortByOrder(candidates);
};
var focusable = function focusable2(el, options) {
  options = options || {};
  var candidates;
  if (options.getShadowRoot) {
    candidates = getCandidatesIteratively([el], options.includeContainer, {
      filter: isNodeMatchingSelectorFocusable.bind(null, options),
      flatten: true,
      getShadowRoot: options.getShadowRoot
    });
  } else {
    candidates = getCandidates(el, options.includeContainer, isNodeMatchingSelectorFocusable.bind(null, options));
  }
  return candidates;
};
var isTabbable = function isTabbable2(node, options) {
  options = options || {};
  if (!node) {
    throw new Error("No node provided");
  }
  if (matches.call(node, candidateSelector) === false) {
    return false;
  }
  return isNodeMatchingSelectorTabbable(options, node);
};
var focusableCandidateSelector = /* @__PURE__ */ candidateSelectors.concat("iframe").join(",");
var isFocusable = function isFocusable2(node, options) {
  options = options || {};
  if (!node) {
    throw new Error("No node provided");
  }
  if (matches.call(node, focusableCandidateSelector) === false) {
    return false;
  }
  return isNodeMatchingSelectorFocusable(options, node);
};
/*!
* focus-trap 6.9.0
* @license MIT, https://github.com/focus-trap/focus-trap/blob/master/LICENSE
*/
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function(sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), true).forEach(function(key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function(key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
var activeFocusTraps = function() {
  var trapQueue = [];
  return {
    activateTrap: function activateTrap(trap) {
      if (trapQueue.length > 0) {
        var activeTrap = trapQueue[trapQueue.length - 1];
        if (activeTrap !== trap) {
          activeTrap.pause();
        }
      }
      var trapIndex = trapQueue.indexOf(trap);
      if (trapIndex === -1) {
        trapQueue.push(trap);
      } else {
        trapQueue.splice(trapIndex, 1);
        trapQueue.push(trap);
      }
    },
    deactivateTrap: function deactivateTrap(trap) {
      var trapIndex = trapQueue.indexOf(trap);
      if (trapIndex !== -1) {
        trapQueue.splice(trapIndex, 1);
      }
      if (trapQueue.length > 0) {
        trapQueue[trapQueue.length - 1].unpause();
      }
    }
  };
}();
var isSelectableInput = function isSelectableInput2(node) {
  return node.tagName && node.tagName.toLowerCase() === "input" && typeof node.select === "function";
};
var isEscapeEvent = function isEscapeEvent2(e) {
  return e.key === "Escape" || e.key === "Esc" || e.keyCode === 27;
};
var isTabEvent = function isTabEvent2(e) {
  return e.key === "Tab" || e.keyCode === 9;
};
var delay = function delay2(fn2) {
  return setTimeout(fn2, 0);
};
var findIndex = function findIndex2(arr, fn2) {
  var idx = -1;
  arr.every(function(value, i) {
    if (fn2(value)) {
      idx = i;
      return false;
    }
    return true;
  });
  return idx;
};
var valueOrHandler = function valueOrHandler2(value) {
  for (var _len = arguments.length, params = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    params[_key - 1] = arguments[_key];
  }
  return typeof value === "function" ? value.apply(void 0, params) : value;
};
var getActualTarget = function getActualTarget2(event) {
  return event.target.shadowRoot && typeof event.composedPath === "function" ? event.composedPath()[0] : event.target;
};
var createFocusTrap = function createFocusTrap2(elements, userOptions) {
  var doc = (userOptions === null || userOptions === void 0 ? void 0 : userOptions.document) || document;
  var config = _objectSpread2({
    returnFocusOnDeactivate: true,
    escapeDeactivates: true,
    delayInitialFocus: true
  }, userOptions);
  var state = {
    containers: [],
    containerGroups: [],
    tabbableGroups: [],
    nodeFocusedBeforeActivation: null,
    mostRecentlyFocusedNode: null,
    active: false,
    paused: false,
    delayInitialFocusTimer: void 0
  };
  var trap;
  var getOption = function getOption2(configOverrideOptions, optionName, configOptionName) {
    return configOverrideOptions && configOverrideOptions[optionName] !== void 0 ? configOverrideOptions[optionName] : config[configOptionName || optionName];
  };
  var findContainerIndex = function findContainerIndex2(element) {
    return state.containerGroups.findIndex(function(_ref) {
      var container = _ref.container, tabbableNodes = _ref.tabbableNodes;
      return container.contains(element) || tabbableNodes.find(function(node) {
        return node === element;
      });
    });
  };
  var getNodeForOption = function getNodeForOption2(optionName) {
    var optionValue = config[optionName];
    if (typeof optionValue === "function") {
      for (var _len2 = arguments.length, params = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
        params[_key2 - 1] = arguments[_key2];
      }
      optionValue = optionValue.apply(void 0, params);
    }
    if (!optionValue) {
      if (optionValue === void 0 || optionValue === false) {
        return optionValue;
      }
      throw new Error("`".concat(optionName, "` was specified but was not a node, or did not return a node"));
    }
    var node = optionValue;
    if (typeof optionValue === "string") {
      node = doc.querySelector(optionValue);
      if (!node) {
        throw new Error("`".concat(optionName, "` as selector refers to no known node"));
      }
    }
    return node;
  };
  var getInitialFocusNode = function getInitialFocusNode2() {
    var node = getNodeForOption("initialFocus");
    if (node === false) {
      return false;
    }
    if (node === void 0) {
      if (findContainerIndex(doc.activeElement) >= 0) {
        node = doc.activeElement;
      } else {
        var firstTabbableGroup = state.tabbableGroups[0];
        var firstTabbableNode = firstTabbableGroup && firstTabbableGroup.firstTabbableNode;
        node = firstTabbableNode || getNodeForOption("fallbackFocus");
      }
    }
    if (!node) {
      throw new Error("Your focus-trap needs to have at least one focusable element");
    }
    return node;
  };
  var updateTabbableNodes = function updateTabbableNodes2() {
    state.containerGroups = state.containers.map(function(container) {
      var tabbableNodes = tabbable(container, config.tabbableOptions);
      var focusableNodes = focusable(container, config.tabbableOptions);
      return {
        container,
        tabbableNodes,
        focusableNodes,
        firstTabbableNode: tabbableNodes.length > 0 ? tabbableNodes[0] : null,
        lastTabbableNode: tabbableNodes.length > 0 ? tabbableNodes[tabbableNodes.length - 1] : null,
        nextTabbableNode: function nextTabbableNode(node) {
          var forward = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true;
          var nodeIdx = focusableNodes.findIndex(function(n) {
            return n === node;
          });
          if (nodeIdx < 0) {
            return void 0;
          }
          if (forward) {
            return focusableNodes.slice(nodeIdx + 1).find(function(n) {
              return isTabbable(n, config.tabbableOptions);
            });
          }
          return focusableNodes.slice(0, nodeIdx).reverse().find(function(n) {
            return isTabbable(n, config.tabbableOptions);
          });
        }
      };
    });
    state.tabbableGroups = state.containerGroups.filter(function(group) {
      return group.tabbableNodes.length > 0;
    });
    if (state.tabbableGroups.length <= 0 && !getNodeForOption("fallbackFocus")) {
      throw new Error("Your focus-trap must have at least one container with at least one tabbable node in it at all times");
    }
  };
  var tryFocus = function tryFocus2(node) {
    if (node === false) {
      return;
    }
    if (node === doc.activeElement) {
      return;
    }
    if (!node || !node.focus) {
      tryFocus2(getInitialFocusNode());
      return;
    }
    node.focus({
      preventScroll: !!config.preventScroll
    });
    state.mostRecentlyFocusedNode = node;
    if (isSelectableInput(node)) {
      node.select();
    }
  };
  var getReturnFocusNode = function getReturnFocusNode2(previousActiveElement) {
    var node = getNodeForOption("setReturnFocus", previousActiveElement);
    return node ? node : node === false ? false : previousActiveElement;
  };
  var checkPointerDown = function checkPointerDown2(e) {
    var target = getActualTarget(e);
    if (findContainerIndex(target) >= 0) {
      return;
    }
    if (valueOrHandler(config.clickOutsideDeactivates, e)) {
      trap.deactivate({
        returnFocus: config.returnFocusOnDeactivate && !isFocusable(target, config.tabbableOptions)
      });
      return;
    }
    if (valueOrHandler(config.allowOutsideClick, e)) {
      return;
    }
    e.preventDefault();
  };
  var checkFocusIn = function checkFocusIn2(e) {
    var target = getActualTarget(e);
    var targetContained = findContainerIndex(target) >= 0;
    if (targetContained || target instanceof Document) {
      if (targetContained) {
        state.mostRecentlyFocusedNode = target;
      }
    } else {
      e.stopImmediatePropagation();
      tryFocus(state.mostRecentlyFocusedNode || getInitialFocusNode());
    }
  };
  var checkTab = function checkTab2(e) {
    var target = getActualTarget(e);
    updateTabbableNodes();
    var destinationNode = null;
    if (state.tabbableGroups.length > 0) {
      var containerIndex = findContainerIndex(target);
      var containerGroup = containerIndex >= 0 ? state.containerGroups[containerIndex] : void 0;
      if (containerIndex < 0) {
        if (e.shiftKey) {
          destinationNode = state.tabbableGroups[state.tabbableGroups.length - 1].lastTabbableNode;
        } else {
          destinationNode = state.tabbableGroups[0].firstTabbableNode;
        }
      } else if (e.shiftKey) {
        var startOfGroupIndex = findIndex(state.tabbableGroups, function(_ref2) {
          var firstTabbableNode = _ref2.firstTabbableNode;
          return target === firstTabbableNode;
        });
        if (startOfGroupIndex < 0 && (containerGroup.container === target || isFocusable(target, config.tabbableOptions) && !isTabbable(target, config.tabbableOptions) && !containerGroup.nextTabbableNode(target, false))) {
          startOfGroupIndex = containerIndex;
        }
        if (startOfGroupIndex >= 0) {
          var destinationGroupIndex = startOfGroupIndex === 0 ? state.tabbableGroups.length - 1 : startOfGroupIndex - 1;
          var destinationGroup = state.tabbableGroups[destinationGroupIndex];
          destinationNode = destinationGroup.lastTabbableNode;
        }
      } else {
        var lastOfGroupIndex = findIndex(state.tabbableGroups, function(_ref3) {
          var lastTabbableNode = _ref3.lastTabbableNode;
          return target === lastTabbableNode;
        });
        if (lastOfGroupIndex < 0 && (containerGroup.container === target || isFocusable(target, config.tabbableOptions) && !isTabbable(target, config.tabbableOptions) && !containerGroup.nextTabbableNode(target))) {
          lastOfGroupIndex = containerIndex;
        }
        if (lastOfGroupIndex >= 0) {
          var _destinationGroupIndex = lastOfGroupIndex === state.tabbableGroups.length - 1 ? 0 : lastOfGroupIndex + 1;
          var _destinationGroup = state.tabbableGroups[_destinationGroupIndex];
          destinationNode = _destinationGroup.firstTabbableNode;
        }
      }
    } else {
      destinationNode = getNodeForOption("fallbackFocus");
    }
    if (destinationNode) {
      e.preventDefault();
      tryFocus(destinationNode);
    }
  };
  var checkKey = function checkKey2(e) {
    if (isEscapeEvent(e) && valueOrHandler(config.escapeDeactivates, e) !== false) {
      e.preventDefault();
      trap.deactivate();
      return;
    }
    if (isTabEvent(e)) {
      checkTab(e);
      return;
    }
  };
  var checkClick = function checkClick2(e) {
    var target = getActualTarget(e);
    if (findContainerIndex(target) >= 0) {
      return;
    }
    if (valueOrHandler(config.clickOutsideDeactivates, e)) {
      return;
    }
    if (valueOrHandler(config.allowOutsideClick, e)) {
      return;
    }
    e.preventDefault();
    e.stopImmediatePropagation();
  };
  var addListeners = function addListeners2() {
    if (!state.active) {
      return;
    }
    activeFocusTraps.activateTrap(trap);
    state.delayInitialFocusTimer = config.delayInitialFocus ? delay(function() {
      tryFocus(getInitialFocusNode());
    }) : tryFocus(getInitialFocusNode());
    doc.addEventListener("focusin", checkFocusIn, true);
    doc.addEventListener("mousedown", checkPointerDown, {
      capture: true,
      passive: false
    });
    doc.addEventListener("touchstart", checkPointerDown, {
      capture: true,
      passive: false
    });
    doc.addEventListener("click", checkClick, {
      capture: true,
      passive: false
    });
    doc.addEventListener("keydown", checkKey, {
      capture: true,
      passive: false
    });
    return trap;
  };
  var removeListeners = function removeListeners2() {
    if (!state.active) {
      return;
    }
    doc.removeEventListener("focusin", checkFocusIn, true);
    doc.removeEventListener("mousedown", checkPointerDown, true);
    doc.removeEventListener("touchstart", checkPointerDown, true);
    doc.removeEventListener("click", checkClick, true);
    doc.removeEventListener("keydown", checkKey, true);
    return trap;
  };
  trap = {
    get active() {
      return state.active;
    },
    get paused() {
      return state.paused;
    },
    activate: function activate(activateOptions) {
      if (state.active) {
        return this;
      }
      var onActivate = getOption(activateOptions, "onActivate");
      var onPostActivate = getOption(activateOptions, "onPostActivate");
      var checkCanFocusTrap = getOption(activateOptions, "checkCanFocusTrap");
      if (!checkCanFocusTrap) {
        updateTabbableNodes();
      }
      state.active = true;
      state.paused = false;
      state.nodeFocusedBeforeActivation = doc.activeElement;
      if (onActivate) {
        onActivate();
      }
      var finishActivation = function finishActivation2() {
        if (checkCanFocusTrap) {
          updateTabbableNodes();
        }
        addListeners();
        if (onPostActivate) {
          onPostActivate();
        }
      };
      if (checkCanFocusTrap) {
        checkCanFocusTrap(state.containers.concat()).then(finishActivation, finishActivation);
        return this;
      }
      finishActivation();
      return this;
    },
    deactivate: function deactivate(deactivateOptions) {
      if (!state.active) {
        return this;
      }
      var options = _objectSpread2({
        onDeactivate: config.onDeactivate,
        onPostDeactivate: config.onPostDeactivate,
        checkCanReturnFocus: config.checkCanReturnFocus
      }, deactivateOptions);
      clearTimeout(state.delayInitialFocusTimer);
      state.delayInitialFocusTimer = void 0;
      removeListeners();
      state.active = false;
      state.paused = false;
      activeFocusTraps.deactivateTrap(trap);
      var onDeactivate = getOption(options, "onDeactivate");
      var onPostDeactivate = getOption(options, "onPostDeactivate");
      var checkCanReturnFocus = getOption(options, "checkCanReturnFocus");
      var returnFocus = getOption(options, "returnFocus", "returnFocusOnDeactivate");
      if (onDeactivate) {
        onDeactivate();
      }
      var finishDeactivation = function finishDeactivation2() {
        delay(function() {
          if (returnFocus) {
            tryFocus(getReturnFocusNode(state.nodeFocusedBeforeActivation));
          }
          if (onPostDeactivate) {
            onPostDeactivate();
          }
        });
      };
      if (returnFocus && checkCanReturnFocus) {
        checkCanReturnFocus(getReturnFocusNode(state.nodeFocusedBeforeActivation)).then(finishDeactivation, finishDeactivation);
        return this;
      }
      finishDeactivation();
      return this;
    },
    pause: function pause() {
      if (state.paused || !state.active) {
        return this;
      }
      state.paused = true;
      removeListeners();
      return this;
    },
    unpause: function unpause() {
      if (!state.paused || !state.active) {
        return this;
      }
      state.paused = false;
      updateTabbableNodes();
      addListeners();
      return this;
    },
    updateContainerElements: function updateContainerElements(containerElements) {
      var elementsAsArray = [].concat(containerElements).filter(Boolean);
      state.containers = elementsAsArray.map(function(element) {
        return typeof element === "string" ? doc.querySelector(element) : element;
      });
      if (state.active) {
        updateTabbableNodes();
      }
      return this;
    }
  };
  trap.updateContainerElements(elements);
  return trap;
};
const _sfc_main$K = {
  name: "SdFocusTrap",
  emits: ["activate", "deactivate", "update:modelValue"],
  props: {
    target: {
      type: [HTMLElement, String],
      default: null
    },
    active: {
      type: Boolean,
      default: false
    },
    modelValue: {
      type: Boolean,
      default: false
    },
    escDeactivates: {
      type: Boolean,
      default: true
    },
    outsideClick: {
      type: Boolean,
      default: false
    },
    returnFocus: {
      type: Boolean,
      default: true
    },
    setReturnFocus: {
      type: [HTMLElement, SVGElement, String, Function],
      default: void 0
    },
    preventScroll: {
      type: Boolean,
      default: false
    }
  },
  setup(props, { emit }) {
    let trap = null;
    watchEffect(() => {
      if (props.target instanceof HTMLElement) {
        trap = createFocusTrap(props.target, {
          returnFocusOnDeactivate: props.returnFocus,
          clickOutsideDeactivates: props.outsideClick,
          setReturnFocus: props.setReturnFocus,
          escDeactivates: props.escDeactivates,
          preventScroll: props.preventScroll,
          onActivate: () => {
            emit("update:modelValue", true);
            emit("activate", true);
          },
          onDeactivate: () => {
            emit("update:modelValue", false);
            emit("activate", false);
            emit("deactivate", true);
          }
        });
        if (props.active || props.modelValue) {
          trap.activate();
        } else {
          trap.deactivate();
        }
      }
    }, { flush: "pre" });
    onUnmounted(() => {
      trap.deactivate();
    });
  }
};
function _sfc_render$J(_ctx, _cache, $props, $setup, $data, $options) {
  return renderSlot(_ctx.$slots, "default");
}
var SdFocusTrap = /* @__PURE__ */ _export_sfc(_sfc_main$K, [["render", _sfc_render$J]]);
var SdOverlay_vue_vue_type_style_index_0_lang = "";
const _sfc_main$J = defineComponent({
  name: "SdOverlay",
  props: {
    active: Boolean,
    fixed: Boolean,
    blur: Boolean,
    transparent: Boolean
  },
  setup(props) {
    const overlayClasses = computed(() => {
      return {
        "is--fixed": props.fixed,
        "is--blur": props.blur,
        "is--transparent": props.transparent
      };
    });
    return {
      overlayClasses
    };
  }
});
function _sfc_render$I(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createBlock(Transition, { name: "sd-overlay" }, {
    default: withCtx(() => [
      _ctx.active ? (openBlock(), createElementBlock("div", {
        key: 0,
        class: normalizeClass(["sd--overlay", _ctx.overlayClasses])
      }, null, 2)) : createCommentVNode("", true)
    ]),
    _: 1
  });
}
var SdOverlay = /* @__PURE__ */ _export_sfc(_sfc_main$J, [["render", _sfc_render$I]]);
var SdDialog_vue_vue_type_style_index_0_lang = "";
const _sfc_main$I = defineComponent({
  name: "SdDialog",
  props: {
    id: {
      type: String,
      default: "modal-" + sdUuid()
    },
    portalTo: {
      type: String,
      default: "#app"
    },
    portalDisabled: {
      type: Boolean,
      default: false
    },
    active: Boolean,
    backdrop: {
      type: Boolean,
      default: true
    },
    backdropClass: {
      type: String,
      default: "sd--dialog__overlay"
    },
    backdropBlur: Boolean,
    clickOutsideToClose: {
      type: Boolean,
      default: true
    },
    closeOnEsc: {
      type: Boolean,
      default: true
    },
    size: {
      type: String,
      default: "md"
    },
    fullscreen: {
      type: Boolean,
      default: true
    },
    aside: Boolean,
    placement: {
      type: String,
      default: "right"
    }
  },
  components: {
    SdOverlay,
    SdFocusTrap
  },
  emits: ["update:active", "clicked-outside", "opened", "closed"],
  setup(props, { emit }) {
    const modalContainer = ref(null);
    const trapActive = ref(false);
    const classes = computed(() => {
      const sizeClass = `is--${props.size}`;
      const asidePlacement = `sd--dialog__aside--${props.placement}`;
      return {
        "sd--dialog__aside": props.aside,
        "sd--dialog__fullscreen": props.fullscreen && !props.aside,
        [asidePlacement]: props.aside && props.placement,
        [sizeClass]: true
      };
    });
    const setFocus = () => {
      window.setTimeout(() => {
        if (modalContainer.value) {
          modalContainer.value.setAttribute("tabindex", "-1");
          modalContainer.value.focus();
        }
      }, 0);
    };
    watch(() => props.active, () => {
      nextTick().then(() => {
        if (props.active) {
          document.body.classList.add("sd--dialog--open");
          document.body.style.top = `-${window.scrollY}px`;
          document.body.style.position = "fixed";
          document.body.style.left = "0";
          document.body.style.right = "0";
          setFocus();
        } else {
          const scrollY = document.body.style.top;
          document.body.classList.remove("sd--dialog--open");
          document.body.removeAttribute("style");
          window.scrollTo(0, parseInt(scrollY || "0") * -1);
        }
      });
    });
    const closeModal = () => {
      emit("update:active", false);
      trapActive.value = false;
    };
    const onOutsideClick = () => {
      if (props.clickOutsideToClose) {
        closeModal();
      }
      emit("clicked-outside");
    };
    const onEsc = () => {
      if (props.closeOnEsc) {
        closeModal();
      }
    };
    const dispatchEvents = (state) => {
      nextTick().then(() => {
        window.dispatchEvent(new Event("resize"));
        if (state === "enter") {
          emit("opened");
          trapActive.value = true;
        }
        if (state === "leave") {
          emit("closed");
        }
      });
    };
    onMounted(() => {
      setFocus();
    });
    return {
      onEsc,
      onOutsideClick,
      closeModal,
      classes,
      modalContainer,
      dispatchEvents,
      trapActive
    };
  }
});
const _hoisted_1$z = {
  key: 0,
  role: "dialog",
  class: "sd--dialog",
  "aria-modal": "true"
};
const _hoisted_2$h = { class: "sd--dialog__container" };
function _sfc_render$H(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_sd_overlay = resolveComponent("sd-overlay");
  const _component_sd_focus_trap = resolveComponent("sd-focus-trap");
  return openBlock(), createBlock(Teleport, {
    to: _ctx.portalTo,
    disabled: _ctx.portalDisabled
  }, [
    createVNode(Transition, {
      name: "dialog",
      onAfterEnter: _cache[2] || (_cache[2] = ($event) => _ctx.dispatchEvents("enter")),
      onAfterLeave: _cache[3] || (_cache[3] = ($event) => _ctx.dispatchEvents("leave"))
    }, {
      default: withCtx(() => [
        _ctx.active ? (openBlock(), createElementBlock("div", _hoisted_1$z, [
          createVNode(_component_sd_focus_trap, {
            target: _ctx.modalContainer,
            modelValue: _ctx.trapActive,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => _ctx.trapActive = $event),
            "outside-click": _ctx.clickOutsideToClose
          }, {
            default: withCtx(() => [
              createElementVNode("div", {
                ref: "modalContainer",
                class: normalizeClass(["sd--dialog__wrapper", "elevation--6", _ctx.classes]),
                onKeydown: _cache[0] || (_cache[0] = withKeys((...args) => _ctx.onEsc && _ctx.onEsc(...args), ["esc"]))
              }, [
                createElementVNode("div", _hoisted_2$h, [
                  renderSlot(_ctx.$slots, "default")
                ])
              ], 34),
              _ctx.backdrop && _ctx.active ? (openBlock(), createBlock(_component_sd_overlay, {
                key: 0,
                fixed: "",
                parent: `#${_ctx.id}`,
                class: normalizeClass(_ctx.backdropClass),
                active: _ctx.active,
                blur: _ctx.backdropBlur,
                onClick: _ctx.onOutsideClick
              }, null, 8, ["parent", "class", "active", "blur", "onClick"])) : createCommentVNode("", true)
            ]),
            _: 3
          }, 8, ["target", "modelValue", "outside-click"])
        ])) : createCommentVNode("", true)
      ]),
      _: 3
    })
  ], 8, ["to", "disabled"]);
}
var SdDialog = /* @__PURE__ */ _export_sfc(_sfc_main$I, [["render", _sfc_render$H]]);
var SdDialogHeader_vue_vue_type_style_index_0_lang = "";
const _sfc_main$H = defineComponent({
  name: "SdDialogHeader",
  props: {
    title: {
      type: String,
      default: ""
    },
    subtitle: {
      type: String,
      default: ""
    }
  }
});
const _hoisted_1$y = { class: "sd--dialog__header" };
const _hoisted_2$g = {
  key: 0,
  class: "sd--dialog__header-content"
};
const _hoisted_3$a = {
  key: 0,
  class: "sd--dialog__title"
};
const _hoisted_4$7 = {
  key: 1,
  class: "sd--dialog__subtitle"
};
function _sfc_render$G(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("div", _hoisted_1$y, [
    _ctx.title || _ctx.subtitle ? (openBlock(), createElementBlock("div", _hoisted_2$g, [
      _ctx.title ? (openBlock(), createElementBlock("h3", _hoisted_3$a, toDisplayString(_ctx.title), 1)) : createCommentVNode("", true),
      _ctx.subtitle ? (openBlock(), createElementBlock("p", _hoisted_4$7, toDisplayString(_ctx.subtitle), 1)) : createCommentVNode("", true)
    ])) : createCommentVNode("", true),
    renderSlot(_ctx.$slots, "default")
  ]);
}
var SdDialogHeader = /* @__PURE__ */ _export_sfc(_sfc_main$H, [["render", _sfc_render$G]]);
var SdDialogContent_vue_vue_type_style_index_0_lang = "";
const _sfc_main$G = defineComponent({
  name: "SdDialogContent"
});
const _hoisted_1$x = { class: "sd--dialog__content" };
function _sfc_render$F(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("div", _hoisted_1$x, [
    renderSlot(_ctx.$slots, "default")
  ]);
}
var SdDialogContent = /* @__PURE__ */ _export_sfc(_sfc_main$G, [["render", _sfc_render$F]]);
const useAlignment = (align, direction) => {
  const alignmentStyle = computed(() => {
    return {
      justifyContent: align,
      flexDirection: direction
    };
  });
  return { alignmentStyle };
};
var SdDialogFooter_vue_vue_type_style_index_0_lang = "";
const _sfc_main$F = defineComponent({
  name: "SdDialogFooter",
  props: {
    align: {
      type: String,
      default: "flex-end"
    },
    direction: {
      type: String,
      default: "initial"
    }
  },
  setup(props) {
    const { alignmentStyle } = useAlignment(props.align, props.direction);
    return { alignmentStyle };
  }
});
const _hoisted_1$w = { class: "sd--dialog__footer" };
function _sfc_render$E(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("div", _hoisted_1$w, [
    renderSlot(_ctx.$slots, "default")
  ]);
}
var SdDialogFooter = /* @__PURE__ */ _export_sfc(_sfc_main$F, [["render", _sfc_render$E]]);
const useCheckbox = (props, emit) => {
  const checkboxRef = ref(null);
  const hasValue = computed(() => {
    return props.value !== null;
  });
  const isModelArray = computed(() => {
    return Array.isArray(props.modelValue);
  });
  const isChecked = computed(() => {
    if (isModelArray.value) {
      return props.modelValue.includes(props.value);
    }
    if (hasValue.value) {
      return props.modelValue === props.value;
    } else {
      return props.modelValue === props.trueValue;
    }
  });
  const removeItemFromModel = (newModel) => {
    const index = newModel.indexOf(props.value);
    if (index !== -1) {
      newModel.splice(index, 1);
    }
  };
  const handleArrayCheckbox = () => {
    const newModel = props.modelValue;
    if (!isChecked.value) {
      newModel.push(props.value);
    } else {
      removeItemFromModel(newModel);
    }
    emit("update:modelValue", newModel);
  };
  const handleSingleSelectCheckbox = () => {
    emit("update:modelValue", isChecked.value ? null : props.value);
  };
  const handleSimpleCheckbox = () => {
    emit("update:modelValue", isChecked.value ? props.falseValue : props.trueValue);
  };
  const onChecked = () => {
    if (!props.disabled) {
      if (isModelArray.value) {
        handleArrayCheckbox();
      } else if (hasValue.value) {
        handleSingleSelectCheckbox();
      } else {
        handleSimpleCheckbox();
      }
    }
  };
  return {
    checkboxRef,
    isChecked,
    onChecked
  };
};
var SdCheckbox_vue_vue_type_style_index_0_lang = "";
const _sfc_main$E = defineComponent({
  name: "SdCheckbox",
  props: {
    modelValue: {
      type: [
        String,
        Boolean,
        Object,
        Number,
        Array
      ],
      default: null
    },
    value: {
      type: [
        String,
        Boolean,
        Object,
        Number
      ],
      default: null
    },
    name: {
      type: String,
      default: ""
    },
    required: Boolean,
    disabled: Boolean,
    indeterminate: Boolean,
    trueValue: {
      type: [Boolean, String, Number],
      default: true
    },
    falseValue: {
      type: [Boolean, String, Number],
      default: false
    },
    id: {
      type: String,
      default: () => "sd-checkbox--" + sdUuid()
    },
    rotateAnim: {
      type: Boolean,
      default: true
    }
  },
  emits: ["update:modelValue"],
  setup(props, { emit }) {
    const {
      checkboxRef,
      isChecked,
      onChecked
    } = useCheckbox(props, emit);
    const isFocused = useKeyboardFocus(checkboxRef);
    const attributes = computed(() => {
      const attrs = {
        id: props.id,
        name: props.name,
        disabled: props.disabled,
        required: props.required,
        value: props.value,
        "true-value": props.trueValue,
        "false-value": props.falseValue
      };
      if (props.value === null || typeof props.value !== "object") {
        attrs.value = props.value === null || props.value === void 0 ? "" : String(props.value);
      }
      return attrs;
    });
    const containerClasses = computed(() => {
      return {
        "sd--checkbox": true,
        "is--disabled": props.disabled,
        "is--focused": isFocused.value
      };
    });
    const inputClasses = computed(() => {
      return {
        "sd--checkbox__field": true,
        "is--checked": isChecked.value,
        "is--disabled": props.disabled,
        "is--required": props.required,
        "is--indeterminate": props.indeterminate,
        "is--focused": isFocused.value,
        "is--rotated": props.rotateAnim
      };
    });
    return {
      checkboxRef,
      attributes,
      inputClasses,
      containerClasses,
      isFocused,
      isChecked,
      onChecked
    };
  }
});
const _hoisted_1$v = ["id", "checked", "indeterminate"];
const _hoisted_2$f = { class: "sd--checkbox__label" };
function _sfc_render$D(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("label", {
    class: normalizeClass([_ctx.containerClasses]),
    onClick: _cache[0] || (_cache[0] = withModifiers((...args) => _ctx.onChecked && _ctx.onChecked(...args), ["prevent"])),
    tabindex: "-1"
  }, [
    createElementVNode("input", mergeProps({
      ref: "checkboxRef",
      type: "checkbox",
      id: _ctx.id,
      class: [_ctx.inputClasses],
      checked: _ctx.isChecked,
      indeterminate: _ctx.indeterminate
    }, _ctx.attributes), null, 16, _hoisted_1$v),
    createElementVNode("span", _hoisted_2$f, [
      renderSlot(_ctx.$slots, "default")
    ])
  ], 2);
}
var SdCheckbox = /* @__PURE__ */ _export_sfc(_sfc_main$E, [["render", _sfc_render$D]]);
var SdSwitch_vue_vue_type_style_index_0_lang = "";
const _sfc_main$D = defineComponent({
  name: "SdSwitch",
  props: {
    modelValue: {
      type: [String, Boolean, Object, Number, Array],
      default: null
    },
    value: {
      type: [String, Boolean, Object, Number],
      default: null
    },
    name: {
      type: String,
      default: void 0
    },
    required: Boolean,
    disabled: Boolean,
    trueValue: {
      type: [String, Boolean, Number],
      default: true
    },
    falseValue: {
      type: [String, Boolean, Number],
      default: false
    },
    theme: {
      type: String,
      default: "primary"
    },
    id: {
      type: String,
      default: () => "sd-switch--" + sdUuid()
    }
  },
  emits: ["update:modelValue"],
  setup(props, { emit }) {
    const {
      checkboxRef,
      isChecked,
      onChecked
    } = useCheckbox(props, emit);
    const isFocused = useKeyboardFocus(checkboxRef);
    const attributes = computed(() => {
      const attrs = {
        id: props.id,
        name: props.name,
        disabled: props.disabled,
        required: props.required,
        value: props.value,
        "true-value": props.trueValue,
        "false-value": props.falseValue
      };
      if (props.value === null || typeof props.value !== "object") {
        attrs.value = props.value === null || props.value === void 0 ? "" : String(props.value);
      }
      return attrs;
    });
    const containerClasses = computed(() => {
      return {
        "is--disabled": props.disabled,
        "is--focused": isFocused.value
      };
    });
    const fieldClasses = computed(() => {
      return {
        [`sd--switch__${props.theme}`]: !!props.theme,
        "sd--switch__control": true,
        "is--checked": isChecked.value,
        "is--disabled": props.disabled,
        "is--required": props.required,
        "is--focused": isFocused.value
      };
    });
    return {
      checkboxRef,
      attributes,
      fieldClasses,
      containerClasses,
      isFocused,
      isChecked,
      onChecked
    };
  }
});
const _hoisted_1$u = ["for"];
const _hoisted_2$e = { class: "sd--switch__label" };
const _hoisted_3$9 = ["id", "checked"];
function _sfc_render$C(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("label", {
    for: _ctx.id,
    class: normalizeClass(["sd--switch", _ctx.containerClasses]),
    onClick: _cache[0] || (_cache[0] = withModifiers((...args) => _ctx.onChecked && _ctx.onChecked(...args), ["prevent"])),
    tabindex: "-1"
  }, [
    createElementVNode("span", _hoisted_2$e, [
      renderSlot(_ctx.$slots, "default")
    ]),
    createElementVNode("div", {
      class: normalizeClass([_ctx.fieldClasses])
    }, [
      createElementVNode("input", mergeProps({
        ref: "checkboxRef",
        class: "sd--switch__field",
        type: "checkbox"
      }, _ctx.attributes, {
        id: _ctx.id,
        checked: _ctx.isChecked
      }), null, 16, _hoisted_3$9)
    ], 2)
  ], 10, _hoisted_1$u);
}
var SdSwitch = /* @__PURE__ */ _export_sfc(_sfc_main$D, [["render", _sfc_render$C]]);
var SdRadio_vue_vue_type_style_index_0_lang = "";
const _sfc_main$C = defineComponent({
  name: "SdRadio",
  props: {
    modelValue: {
      type: [String, Number, Boolean, Object],
      default: ""
    },
    value: {
      type: [String, Number, Boolean, Object],
      default: "on"
    },
    id: {
      type: [String, Function],
      default: () => "sd--radio--" + sdUuid()
    },
    name: {
      type: String,
      default: ""
    },
    required: Boolean,
    disabled: Boolean,
    theme: {
      type: String,
      default: "primary"
    }
  },
  emits: ["update:modelValue"],
  setup(props, { emit }) {
    const radio = ref(null);
    const isFocused = useKeyboardFocus(radio);
    const isSelected = computed(() => {
      return props.modelValue === props.value;
    });
    const radioClasses = computed(() => {
      return {
        "is--required": props.required,
        "is--disabled": props.disabled,
        "is--focused": isFocused.value
      };
    });
    const handleChecked = () => {
      if (!props.disabled) {
        radio.value.focus();
        emit("update:modelValue", props.value);
      }
    };
    return {
      radio,
      isSelected,
      radioClasses,
      handleChecked
    };
  }
});
const _hoisted_1$t = ["id", "for"];
const _hoisted_2$d = { class: "sd--radio__content" };
function _sfc_render$B(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("label", {
    id: _ctx.id,
    for: _ctx.name,
    class: normalizeClass(["sd--radio", _ctx.radioClasses]),
    onClick: _cache[0] || (_cache[0] = (...args) => _ctx.handleChecked && _ctx.handleChecked(...args))
  }, [
    createElementVNode("input", mergeProps({
      ref: "radio",
      class: "sd--radio__input"
    }, { name: _ctx.name, disabled: _ctx.disabled, required: _ctx.required, value: _ctx.value, checked: _ctx.isSelected }, { type: "radio" }), null, 16),
    createElementVNode("span", _hoisted_2$d, [
      createElementVNode("span", null, [
        renderSlot(_ctx.$slots, "default")
      ])
    ])
  ], 10, _hoisted_1$t);
}
var SdRadio = /* @__PURE__ */ _export_sfc(_sfc_main$C, [["render", _sfc_render$B]]);
var SdLabel_vue_vue_type_style_index_0_lang = "";
const _sfc_main$B = defineComponent({
  name: "SdLabel",
  props: {
    inline: Boolean,
    required: Boolean
  },
  setup(props) {
    const computedClasses = computed(() => {
      return {
        "sd--label": true,
        "sd--label--inline": props.inline
      };
    });
    return { computedClasses };
  }
});
const _hoisted_1$s = {
  key: 0,
  class: "sd--label--required"
};
function _sfc_render$A(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("label", {
    class: normalizeClass([_ctx.computedClasses])
  }, [
    renderSlot(_ctx.$slots, "default"),
    _ctx.required ? (openBlock(), createElementBlock("span", _hoisted_1$s, "*")) : createCommentVNode("", true)
  ], 2);
}
var SdLabel = /* @__PURE__ */ _export_sfc(_sfc_main$B, [["render", _sfc_render$A]]);
var SdFieldset_vue_vue_type_style_index_0_lang = "";
const _sfc_main$A = defineComponent({
  name: "SdFieldset",
  components: { SdLabel },
  props: {
    title: {
      type: String,
      default: ""
    },
    stack: Boolean,
    inlineLabel: Boolean,
    inline: Boolean,
    tip: {
      type: String,
      default: ""
    },
    tipPlacement: {
      type: String,
      default: "top"
    }
  },
  setup(props) {
    const classes = computed(() => {
      return {
        "sd--fieldset--inline": props.inlineLabel,
        "sd--fieldset--stacked": props.stack,
        "sd--fieldset--inline-stacked": props.inlineLabel && props.stack
      };
    });
    const childClasses = computed(() => {
      return {
        "is--stacked": props.stack,
        "is--inline": props.inline
      };
    });
    return { classes, childClasses };
  }
});
const _hoisted_1$r = {
  key: 0,
  class: "sd--fieldset__header"
};
function _sfc_render$z(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_sd_label = resolveComponent("sd-label");
  return openBlock(), createElementBlock("div", {
    class: normalizeClass(["sd--fieldset", _ctx.classes])
  }, [
    _ctx.title ? (openBlock(), createElementBlock("div", _hoisted_1$r, [
      createVNode(_component_sd_label, { inline: _ctx.inlineLabel }, {
        default: withCtx(() => [
          createElementVNode("span", null, toDisplayString(_ctx.title), 1)
        ]),
        _: 1
      }, 8, ["inline"])
    ])) : createCommentVNode("", true),
    createElementVNode("div", {
      class: normalizeClass(["sd--fieldset__content", _ctx.childClasses])
    }, [
      renderSlot(_ctx.$slots, "default")
    ], 2)
  ], 2);
}
var SdFieldset = /* @__PURE__ */ _export_sfc(_sfc_main$A, [["render", _sfc_render$z]]);
var SdError_vue_vue_type_style_index_0_lang = "";
const _sfc_main$z = defineComponent({
  name: "SdError",
  props: {
    message: {
      type: [String, Boolean],
      default: ""
    }
  }
});
const _hoisted_1$q = {
  key: 0,
  class: "sd--error"
};
const _hoisted_2$c = { class: "sd--text__error" };
function _sfc_render$y(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createBlock(Transition, { name: "error" }, {
    default: withCtx(() => [
      _ctx.message ? (openBlock(), createElementBlock("div", _hoisted_1$q, [
        createElementVNode("span", _hoisted_2$c, toDisplayString(_ctx.message), 1)
      ])) : createCommentVNode("", true)
    ]),
    _: 1
  });
}
var SdError = /* @__PURE__ */ _export_sfc(_sfc_main$z, [["render", _sfc_render$y]]);
var SdField_vue_vue_type_style_index_0_lang = "";
const _sfc_main$y = defineComponent({
  name: "SdField",
  components: { SdLabel, SdError, SdIcon },
  emits: ["update:modelValue", "focus", "blur", "change", "input"],
  props: {
    modelValue: {
      type: [String, Number],
      default: void 0
    },
    value: {
      type: [String, Number],
      default: void 0
    },
    id: {
      type: [String, Function],
      default: () => "sd--field--" + sdUuid()
    },
    modelModifiers: {
      type: [Object, Function],
      default: () => ({})
    },
    icon: {
      type: String,
      default: ""
    },
    iconColor: {
      type: String,
      default: ""
    },
    iconEnd: {
      type: String,
      default: ""
    },
    iconEndColor: {
      type: String,
      default: ""
    },
    label: {
      type: String,
      default: void 0
    },
    name: {
      type: String,
      default: ""
    },
    type: {
      type: String,
      default: "text"
    },
    error: {
      type: [Boolean, String],
      default: false
    },
    placeholder: {
      type: String,
      default: ""
    },
    setFocus: Boolean,
    disabled: Boolean,
    required: Boolean,
    pristineError: Boolean
  },
  setup(props, { emit }) {
    const inputRef = ref(null);
    const state = reactive({
      touched: false,
      focused: false,
      autofill: null
    });
    const handleValidation = computed(() => {
      if (!props.pristineError && !state.touched) {
        return false;
      }
      if (props.pristineError) {
        return props.error;
      }
      if (isErrorString.value && props.error === "") {
        return false;
      }
      if (props.required && !props.modelValue && (props.required && !props.value)) {
        return props.error || "Required";
      }
      return state.touched && props.error;
    });
    const isErrorString = computed(() => {
      return typeof props.error === "string";
    });
    const handleInput = (e) => {
      let value = e.target.value;
      if (props.modelModifiers.number || props.type === "number") {
        value = parseFloat(value);
      }
      if (!props.modelValue) {
        emit("input", value);
      }
      emit("update:modelValue", value);
    };
    const handleTouched = (e) => {
      state.touched = true;
      state.focused = false;
      emit("blur", e);
    };
    const handleFocused = (e) => {
      state.focused = true;
      emit("focus", e);
    };
    const rootClasses = computed(() => {
      return {
        "sd--field": true,
        "is--focused": state.focused
      };
    });
    const inputClasses = computed(() => {
      return {
        "sd--field__control": true,
        "is--autofill": state.autofill,
        "is--dirty": state.touched,
        "is--error": handleValidation.value,
        "is--disabled": props.disabled
      };
    });
    watch(() => props.setFocus, () => {
      state.focused = props.setFocus;
      if (props.setFocus) {
        inputRef.value.focus();
      }
    });
    return __spreadProps(__spreadValues({}, toRefs(state)), {
      rootClasses,
      inputClasses,
      handleInput,
      handleTouched,
      handleFocused,
      isErrorString,
      handleValidation,
      inputRef
    });
  }
});
const _hoisted_1$p = ["id", "type", "name", "placeholder", "disabled", "required", "value"];
function _sfc_render$x(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_sd_label = resolveComponent("sd-label");
  const _component_sd_icon = resolveComponent("sd-icon");
  const _component_sd_error = resolveComponent("sd-error");
  return openBlock(), createElementBlock("div", {
    class: normalizeClass([_ctx.rootClasses])
  }, [
    createVNode(_component_sd_label, { required: _ctx.required }, {
      default: withCtx(() => [
        createTextVNode(toDisplayString(_ctx.label), 1)
      ]),
      _: 1
    }, 8, ["required"]),
    renderSlot(_ctx.$slots, "header"),
    createElementVNode("div", {
      class: normalizeClass([_ctx.inputClasses])
    }, [
      _ctx.icon ? (openBlock(), createBlock(_component_sd_icon, {
        key: 0,
        color: _ctx.iconColor,
        name: _ctx.icon
      }, null, 8, ["color", "name"])) : createCommentVNode("", true),
      renderSlot(_ctx.$slots, "addon"),
      createElementVNode("input", {
        ref: "inputRef",
        id: _ctx.id,
        type: _ctx.type,
        name: _ctx.name,
        placeholder: _ctx.placeholder,
        disabled: _ctx.disabled,
        required: _ctx.required,
        onAnimationstart: _cache[0] || (_cache[0] = (e) => _ctx.log(e)),
        onBlur: _cache[1] || (_cache[1] = (e) => _ctx.handleTouched(e)),
        onFocus: _cache[2] || (_cache[2] = (e) => _ctx.handleFocused(e)),
        onInput: _cache[3] || (_cache[3] = (e) => _ctx.handleInput(e)),
        value: _ctx.modelValue ? _ctx.modelValue : _ctx.value
      }, null, 40, _hoisted_1$p),
      _ctx.iconEnd ? (openBlock(), createBlock(_component_sd_icon, {
        key: 1,
        color: _ctx.iconEndColor,
        name: _ctx.iconEnd
      }, null, 8, ["color", "name"])) : createCommentVNode("", true),
      renderSlot(_ctx.$slots, "addon-end")
    ], 2),
    renderSlot(_ctx.$slots, "footer"),
    createVNode(_component_sd_error, { message: _ctx.handleValidation }, null, 8, ["message"])
  ], 2);
}
var SdField = /* @__PURE__ */ _export_sfc(_sfc_main$y, [["render", _sfc_render$x]]);
var SdSimpleSelect_vue_vue_type_style_index_0_lang = "";
const _sfc_main$x = defineComponent({
  name: "SdSimpleSelect",
  emits: ["update:modelValue", "focus", "blur", "click", "change"],
  components: { SdIcon, SdLabel },
  props: {
    modelValue: {
      type: [String, Object, Number],
      default: ""
    },
    label: {
      type: String,
      default: ""
    },
    block: Boolean,
    value: {
      type: String,
      default: ""
    }
  },
  setup(props, { emit }) {
    const state = reactive({
      hasFocus: false
    });
    const classes = computed(() => {
      return {
        "is--focused": state.hasFocus
      };
    });
    const baseClasses = computed(() => {
      return {
        "is--block": props.block
      };
    });
    const handleChange = (event) => {
      state.hasFocus = false;
      if (props.modelValue) {
        emit("update:modelValue", event.target.value);
      } else {
        emit("change", event);
      }
    };
    const handleClick = (event) => {
      emit("click", event);
      state.hasFocus = true;
    };
    const handleFocus = (event) => {
      emit("focus", event);
    };
    const handleBlur = (event) => {
      emit("blur", event);
    };
    return __spreadProps(__spreadValues({}, toRefs(state)), {
      handleChange,
      handleFocus,
      handleBlur,
      handleClick,
      classes,
      baseClasses
    });
  }
});
const _hoisted_1$o = { class: "sd--select__content" };
const _hoisted_2$b = ["value"];
function _sfc_render$w(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_sd_label = resolveComponent("sd-label");
  const _component_sd_icon = resolveComponent("sd-icon");
  return openBlock(), createElementBlock("div", {
    class: normalizeClass(["sd--select", _ctx.baseClasses])
  }, [
    _ctx.label ? (openBlock(), createBlock(_component_sd_label, { key: 0 }, {
      default: withCtx(() => [
        createTextVNode(toDisplayString(_ctx.label), 1)
      ]),
      _: 1
    })) : createCommentVNode("", true),
    createElementVNode("div", _hoisted_1$o, [
      createElementVNode("select", {
        class: normalizeClass(["sd--select__control", _ctx.classes]),
        value: _ctx.modelValue || _ctx.value,
        onClick: _cache[0] || (_cache[0] = (e) => _ctx.handleClick(e)),
        onChange: _cache[1] || (_cache[1] = (e) => _ctx.handleChange(e)),
        onFocus: _cache[2] || (_cache[2] = (e) => _ctx.handleFocus(e)),
        onBlur: _cache[3] || (_cache[3] = (e) => _ctx.handleBlur(e))
      }, [
        renderSlot(_ctx.$slots, "default")
      ], 42, _hoisted_2$b),
      createVNode(_component_sd_icon, {
        name: "arrow_drop_down",
        class: normalizeClass(["sd--select__indicator", _ctx.classes])
      }, null, 8, ["class"])
    ])
  ], 2);
}
var SdSimpleSelect = /* @__PURE__ */ _export_sfc(_sfc_main$x, [["render", _sfc_render$w]]);
var SdSelect_vue_vue_type_style_index_0_lang = "";
const _sfc_main$w = defineComponent({
  name: "SdSelect",
  props: {
    label: {
      type: String,
      default: "Label"
    },
    autoClose: {
      type: Boolean,
      default: false
    },
    items: {
      type: Array,
      default: () => []
    }
  },
  setup(props) {
    const slotted = ref(null);
    const state = reactive({
      active: false,
      search: ""
    });
    const selected = ref("okay");
    const handleSelected = (e) => {
      if (selected.value !== e) {
        selected.value = e;
      }
      if (props.autoClose) {
        state.active = false;
      }
    };
    const onFocus = () => {
      state.active = true;
    };
    const onBlur = () => {
      state.active = false;
    };
    onMounted(() => {
      console.log(slotted.value);
    });
    return __spreadProps(__spreadValues({}, toRefs(state)), { slotted, onFocus, onBlur, selected, handleSelected });
  }
});
const _hoisted_1$n = { class: "sd--select__group" };
function _sfc_render$v(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_sd_field = resolveComponent("sd-field");
  const _component_sd_dropdown = resolveComponent("sd-dropdown");
  return openBlock(), createElementBlock("div", _hoisted_1$n, [
    createVNode(_component_sd_field, {
      label: _ctx.label,
      onFocus: _ctx.onFocus,
      modelValue: _ctx.selected,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => _ctx.selected = $event)
    }, null, 8, ["label", "onFocus", "modelValue"]),
    createVNode(_component_sd_dropdown, {
      modelValue: _ctx.active,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => _ctx.active = $event),
      "return-focus": false,
      "trap-focus": false
    }, {
      default: withCtx(() => [
        renderSlot(_ctx.$slots, "default", {
          ref: "slotted",
          onSelected: (e) => _ctx.handleSelected(e.target.value)
        })
      ]),
      _: 3
    }, 8, ["modelValue"])
  ]);
}
var SdSelect = /* @__PURE__ */ _export_sfc(_sfc_main$w, [["render", _sfc_render$v]]);
var SdMouse_vue_vue_type_style_index_0_lang = "";
const _sfc_main$v = defineComponent({
  name: "SdIconMouse",
  props: {
    hover: Boolean,
    delay: {
      type: Number,
      default: 0
    }
  },
  setup(props) {
    onMounted(() => {
      const tl = anime.timeline({
        targets: ".sd--anim",
        loop: true,
        duration: 1440,
        delay: props.delay
      });
      tl.add({
        targets: ".wheel",
        translateY: 4,
        duration: 360,
        easing: "easeInQuad"
      }).add({
        targets: ".arrow",
        keyframes: [
          { opacity: 0.5, translateY: 6, easing: "easeInQuad" },
          { opacity: 0, translateY: 12, easing: "easeOutQuad" }
        ]
      }).add({
        targets: ".wheel",
        easing: "easeOutQuad",
        translateY: 0
      }, "-=360");
    });
  }
});
const _hoisted_1$m = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "23",
  height: "39",
  viewBox: "0 0 23 39",
  class: "sd--mouse-icon"
};
const _hoisted_2$a = {
  fill: "#FFF",
  "fill-rule": "evenodd"
};
const _hoisted_3$8 = /* @__PURE__ */ createElementVNode("path", {
  id: "mouse-outer-path",
  d: "M12.5516393,0 C15.313063,0 17.813063,1.11928813 19.6227071,2.92893219 C21.4323512,4.73857625 22.5516393,7.23857625 22.5516393,10 C22.5516393,10.3334563 22.5349603,10.6667039 22.5016649,10.9984938 L21.7432422,18.5562023 L22.3195286,27.4573295 C22.5129635,30.4450598 21.4770689,33.228347 19.6458831,35.3130602 C17.8146972,37.3977735 15.18822,38.7839129 12.2004896,38.9773478 C11.9672982,38.9924453 11.7336796,39 11.5,39 C8.50601443,39 5.79546921,37.7864476 3.83342039,35.8243987 C1.87137156,33.8623499 0.657819133,31.1518047 0.657819133,28.1578191 C0.657819133,27.9241395 0.665373818,27.6905209 0.68047135,27.4573295 L1.2558415,18.5703546 L0.316155047,11.2780295 C-0.0367630431,8.53925054 0.753839085,5.91670327 2.31736546,3.89062121 C3.88089184,1.86453915 6.21734247,0.434922289 8.95612139,0.0820041993 C9.37994151,0.0273908874 9.80682649,0 10.2341508,0 L12.5516393,0 Z M12.5516393,1 L10.2341508,1 C9.84955892,1 9.46536244,1.0246518 9.08392433,1.07380378 C4.15412229,1.70905634 0.672702065,6.22042447 1.30795463,11.1502265 L1.30795463,11.1502265 L2.26,18.5384615 L1.67838208,27.5219373 C1.66467703,27.7336209 1.65781913,27.9456923 1.65781913,28.1578191 C1.65781913,33.5935055 6.0643136,38 11.5,38 C11.7121268,38 11.9241982,37.9931421 12.1358818,37.9794371 C17.5602116,37.6282492 21.6728058,32.9462671 21.3216179,27.5219373 L21.3216179,27.5219373 L20.74,18.5384615 L21.5066623,10.8986444 C21.5366282,10.6000335 21.5516393,10.3001107 21.5516393,10 C21.5516393,5.02943725 17.522202,1 12.5516393,1 L12.5516393,1 Z"
}, null, -1);
const _hoisted_4$6 = /* @__PURE__ */ createElementVNode("path", {
  id: "mouse-inner-path",
  d: "M11,0 L12,0 L12,2.76923077 L12,6 L12,17.5 C12,17.7761424 11.7761424,18 11.5,18 C11.2238576,18 11,17.7761424 11,17.5 L11,6 L11,6 L11,4.15384615 L11,0 Z"
}, null, -1);
const _hoisted_5$4 = /* @__PURE__ */ createElementVNode("path", {
  class: "sd--anim wheel",
  d: "M11.5,3 C12.3284271,3 13,3.67157288 13,4.5 L13,11.5 C13,12.3284271 12.3284271,13 11.5,13 C10.6715729,13 10,12.3284271 10,11.5 L10,4.5 C10,3.67157288 10.6715729,3 11.5,3 Z"
}, null, -1);
const _hoisted_6$2 = /* @__PURE__ */ createElementVNode("path", {
  class: "sd--anim arrow",
  d: "M16,8.5 C16,8.22385763 16.2238576,8 16.5,8 C16.7761424,8 17,8.22385763 17,8.5 L17,13 L19,13 L16.5,16 L14,13 L16,13 L16,8.5 Z"
}, null, -1);
const _hoisted_7$1 = { transform: "translate(0 1)" };
const _hoisted_8$1 = {
  key: 0,
  "fill-opacity": ".5",
  transform: "translate(1)"
};
const _hoisted_9$1 = /* @__PURE__ */ createElementVNode("path", {
  fill: "url(#mouse-graphic-events-b)",
  d: "M2,16 C3,18 3,23 6,23 C8,23 9.33333333,21 10,17 L10,0 C4.66666667,0 1.33333333,2.66666667 0,8 C0.666666667,11.3333333 1.33333333,14 2,16 Z"
}, null, -1);
const _hoisted_10$1 = /* @__PURE__ */ createElementVNode("path", {
  fill: "url(#mouse-graphic-events-c)",
  d: "M6.83589941,18.3905996 C6.6129929,18.7249594 6.36842105,19 6,19 C5.13509849,17.997822 4.9118605,16.8560625 4.66000497,15.8347756 C4.41712442,14.8498827 4.17010757,13.9311587 3.85958358,13.2534464 C3.25623479,11.4194797 1.60314765,9.96032541 1,7 C1,5 1.72648737,3.0188101 3,2 C3.90067287,1.27946171 6.73784483,0.222552394 8,1.13686838e-13 L8,14.8313789 C7.72934343,16.3942279 7.3677592,17.5928099 6.83589941,18.3905996 Z"
}, null, -1);
const _hoisted_11$1 = [
  _hoisted_9$1,
  _hoisted_10$1
];
const _hoisted_12 = { transform: "translate(12 1)" };
const _hoisted_13 = {
  key: 0,
  "fill-opacity": ".5"
};
const _hoisted_14 = /* @__PURE__ */ createElementVNode("path", {
  fill: "url(#mouse-graphic-events-d)",
  d: "M8,16 C7,18 7,23 4,23 C2,23 0.666666667,21 0,17 C0,14.5555556 0,12.2222222 0,10 C0,7.77777778 0,4.44444444 0,0 C5.33333333,0 8.66666667,2.66666667 10,8 C9.33333333,11.3333333 8.66666667,14 8,16 Z"
}, null, -1);
const _hoisted_15 = /* @__PURE__ */ createElementVNode("path", {
  fill: "url(#mouse-graphic-events-e)",
  d: "M7.83589941,18.3905996 C7.6129929,18.7249594 7.36842105,19 7,19 C6.13509849,17.997822 5.9118605,16.8560625 5.66000497,15.8347756 C5.41712442,14.8498827 5.17010757,13.9311587 4.85958358,13.2534464 C4.25623479,11.4194797 2.60314765,9.96032541 2,7 C2,5 2.72648737,3.0188101 4,2 C4.90067287,1.27946171 7.73784483,0.222552394 9,0 L9,14.8313789 C8.72934343,16.3942279 8.3677592,17.5928099 7.83589941,18.3905996 Z",
  transform: "matrix(-1 0 0 1 11 0)"
}, null, -1);
const _hoisted_16 = [
  _hoisted_14,
  _hoisted_15
];
function _sfc_render$u(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("svg", _hoisted_1$m, [
    createElementVNode("g", _hoisted_2$a, [
      _hoisted_3$8,
      _hoisted_4$6,
      _hoisted_5$4,
      _hoisted_6$2,
      createElementVNode("g", _hoisted_7$1, [
        _ctx.hover ? (openBlock(), createElementBlock("g", _hoisted_8$1, _hoisted_11$1)) : createCommentVNode("", true)
      ]),
      createElementVNode("g", _hoisted_12, [
        _ctx.hover ? (openBlock(), createElementBlock("g", _hoisted_13, _hoisted_16)) : createCommentVNode("", true)
      ])
    ])
  ]);
}
var SdMouse = /* @__PURE__ */ _export_sfc(_sfc_main$v, [["render", _sfc_render$u]]);
var top = "top";
var bottom = "bottom";
var right = "right";
var left = "left";
var auto = "auto";
var basePlacements = [top, bottom, right, left];
var start = "start";
var end = "end";
var clippingParents = "clippingParents";
var viewport = "viewport";
var popper = "popper";
var reference = "reference";
var variationPlacements = /* @__PURE__ */ basePlacements.reduce(function(acc, placement) {
  return acc.concat([placement + "-" + start, placement + "-" + end]);
}, []);
var placements = /* @__PURE__ */ [].concat(basePlacements, [auto]).reduce(function(acc, placement) {
  return acc.concat([placement, placement + "-" + start, placement + "-" + end]);
}, []);
var beforeRead = "beforeRead";
var read = "read";
var afterRead = "afterRead";
var beforeMain = "beforeMain";
var main = "main";
var afterMain = "afterMain";
var beforeWrite = "beforeWrite";
var write = "write";
var afterWrite = "afterWrite";
var modifierPhases = [beforeRead, read, afterRead, beforeMain, main, afterMain, beforeWrite, write, afterWrite];
function getNodeName(element) {
  return element ? (element.nodeName || "").toLowerCase() : null;
}
function getWindow(node) {
  if (node == null) {
    return window;
  }
  if (node.toString() !== "[object Window]") {
    var ownerDocument = node.ownerDocument;
    return ownerDocument ? ownerDocument.defaultView || window : window;
  }
  return node;
}
function isElement(node) {
  var OwnElement = getWindow(node).Element;
  return node instanceof OwnElement || node instanceof Element;
}
function isHTMLElement(node) {
  var OwnElement = getWindow(node).HTMLElement;
  return node instanceof OwnElement || node instanceof HTMLElement;
}
function isShadowRoot(node) {
  if (typeof ShadowRoot === "undefined") {
    return false;
  }
  var OwnElement = getWindow(node).ShadowRoot;
  return node instanceof OwnElement || node instanceof ShadowRoot;
}
function applyStyles(_ref) {
  var state = _ref.state;
  Object.keys(state.elements).forEach(function(name) {
    var style = state.styles[name] || {};
    var attributes = state.attributes[name] || {};
    var element = state.elements[name];
    if (!isHTMLElement(element) || !getNodeName(element)) {
      return;
    }
    Object.assign(element.style, style);
    Object.keys(attributes).forEach(function(name2) {
      var value = attributes[name2];
      if (value === false) {
        element.removeAttribute(name2);
      } else {
        element.setAttribute(name2, value === true ? "" : value);
      }
    });
  });
}
function effect$2(_ref2) {
  var state = _ref2.state;
  var initialStyles = {
    popper: {
      position: state.options.strategy,
      left: "0",
      top: "0",
      margin: "0"
    },
    arrow: {
      position: "absolute"
    },
    reference: {}
  };
  Object.assign(state.elements.popper.style, initialStyles.popper);
  state.styles = initialStyles;
  if (state.elements.arrow) {
    Object.assign(state.elements.arrow.style, initialStyles.arrow);
  }
  return function() {
    Object.keys(state.elements).forEach(function(name) {
      var element = state.elements[name];
      var attributes = state.attributes[name] || {};
      var styleProperties = Object.keys(state.styles.hasOwnProperty(name) ? state.styles[name] : initialStyles[name]);
      var style = styleProperties.reduce(function(style2, property) {
        style2[property] = "";
        return style2;
      }, {});
      if (!isHTMLElement(element) || !getNodeName(element)) {
        return;
      }
      Object.assign(element.style, style);
      Object.keys(attributes).forEach(function(attribute) {
        element.removeAttribute(attribute);
      });
    });
  };
}
var applyStyles$1 = {
  name: "applyStyles",
  enabled: true,
  phase: "write",
  fn: applyStyles,
  effect: effect$2,
  requires: ["computeStyles"]
};
function getBasePlacement(placement) {
  return placement.split("-")[0];
}
var max = Math.max;
var min = Math.min;
var round = Math.round;
function getBoundingClientRect(element, includeScale) {
  if (includeScale === void 0) {
    includeScale = false;
  }
  var rect = element.getBoundingClientRect();
  var scaleX = 1;
  var scaleY = 1;
  if (isHTMLElement(element) && includeScale) {
    var offsetHeight = element.offsetHeight;
    var offsetWidth = element.offsetWidth;
    if (offsetWidth > 0) {
      scaleX = round(rect.width) / offsetWidth || 1;
    }
    if (offsetHeight > 0) {
      scaleY = round(rect.height) / offsetHeight || 1;
    }
  }
  return {
    width: rect.width / scaleX,
    height: rect.height / scaleY,
    top: rect.top / scaleY,
    right: rect.right / scaleX,
    bottom: rect.bottom / scaleY,
    left: rect.left / scaleX,
    x: rect.left / scaleX,
    y: rect.top / scaleY
  };
}
function getLayoutRect(element) {
  var clientRect = getBoundingClientRect(element);
  var width = element.offsetWidth;
  var height = element.offsetHeight;
  if (Math.abs(clientRect.width - width) <= 1) {
    width = clientRect.width;
  }
  if (Math.abs(clientRect.height - height) <= 1) {
    height = clientRect.height;
  }
  return {
    x: element.offsetLeft,
    y: element.offsetTop,
    width,
    height
  };
}
function contains(parent, child) {
  var rootNode = child.getRootNode && child.getRootNode();
  if (parent.contains(child)) {
    return true;
  } else if (rootNode && isShadowRoot(rootNode)) {
    var next = child;
    do {
      if (next && parent.isSameNode(next)) {
        return true;
      }
      next = next.parentNode || next.host;
    } while (next);
  }
  return false;
}
function getComputedStyle$1(element) {
  return getWindow(element).getComputedStyle(element);
}
function isTableElement(element) {
  return ["table", "td", "th"].indexOf(getNodeName(element)) >= 0;
}
function getDocumentElement(element) {
  return ((isElement(element) ? element.ownerDocument : element.document) || window.document).documentElement;
}
function getParentNode(element) {
  if (getNodeName(element) === "html") {
    return element;
  }
  return element.assignedSlot || element.parentNode || (isShadowRoot(element) ? element.host : null) || getDocumentElement(element);
}
function getTrueOffsetParent(element) {
  if (!isHTMLElement(element) || getComputedStyle$1(element).position === "fixed") {
    return null;
  }
  return element.offsetParent;
}
function getContainingBlock(element) {
  var isFirefox = navigator.userAgent.toLowerCase().indexOf("firefox") !== -1;
  var isIE = navigator.userAgent.indexOf("Trident") !== -1;
  if (isIE && isHTMLElement(element)) {
    var elementCss = getComputedStyle$1(element);
    if (elementCss.position === "fixed") {
      return null;
    }
  }
  var currentNode = getParentNode(element);
  if (isShadowRoot(currentNode)) {
    currentNode = currentNode.host;
  }
  while (isHTMLElement(currentNode) && ["html", "body"].indexOf(getNodeName(currentNode)) < 0) {
    var css = getComputedStyle$1(currentNode);
    if (css.transform !== "none" || css.perspective !== "none" || css.contain === "paint" || ["transform", "perspective"].indexOf(css.willChange) !== -1 || isFirefox && css.willChange === "filter" || isFirefox && css.filter && css.filter !== "none") {
      return currentNode;
    } else {
      currentNode = currentNode.parentNode;
    }
  }
  return null;
}
function getOffsetParent(element) {
  var window2 = getWindow(element);
  var offsetParent = getTrueOffsetParent(element);
  while (offsetParent && isTableElement(offsetParent) && getComputedStyle$1(offsetParent).position === "static") {
    offsetParent = getTrueOffsetParent(offsetParent);
  }
  if (offsetParent && (getNodeName(offsetParent) === "html" || getNodeName(offsetParent) === "body" && getComputedStyle$1(offsetParent).position === "static")) {
    return window2;
  }
  return offsetParent || getContainingBlock(element) || window2;
}
function getMainAxisFromPlacement(placement) {
  return ["top", "bottom"].indexOf(placement) >= 0 ? "x" : "y";
}
function within(min$1, value, max$1) {
  return max(min$1, min(value, max$1));
}
function withinMaxClamp(min2, value, max2) {
  var v = within(min2, value, max2);
  return v > max2 ? max2 : v;
}
function getFreshSideObject() {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
  };
}
function mergePaddingObject(paddingObject) {
  return Object.assign({}, getFreshSideObject(), paddingObject);
}
function expandToHashMap(value, keys) {
  return keys.reduce(function(hashMap, key) {
    hashMap[key] = value;
    return hashMap;
  }, {});
}
var toPaddingObject = function toPaddingObject2(padding, state) {
  padding = typeof padding === "function" ? padding(Object.assign({}, state.rects, {
    placement: state.placement
  })) : padding;
  return mergePaddingObject(typeof padding !== "number" ? padding : expandToHashMap(padding, basePlacements));
};
function arrow(_ref) {
  var _state$modifiersData$;
  var state = _ref.state, name = _ref.name, options = _ref.options;
  var arrowElement = state.elements.arrow;
  var popperOffsets2 = state.modifiersData.popperOffsets;
  var basePlacement = getBasePlacement(state.placement);
  var axis = getMainAxisFromPlacement(basePlacement);
  var isVertical = [left, right].indexOf(basePlacement) >= 0;
  var len = isVertical ? "height" : "width";
  if (!arrowElement || !popperOffsets2) {
    return;
  }
  var paddingObject = toPaddingObject(options.padding, state);
  var arrowRect = getLayoutRect(arrowElement);
  var minProp = axis === "y" ? top : left;
  var maxProp = axis === "y" ? bottom : right;
  var endDiff = state.rects.reference[len] + state.rects.reference[axis] - popperOffsets2[axis] - state.rects.popper[len];
  var startDiff = popperOffsets2[axis] - state.rects.reference[axis];
  var arrowOffsetParent = getOffsetParent(arrowElement);
  var clientSize = arrowOffsetParent ? axis === "y" ? arrowOffsetParent.clientHeight || 0 : arrowOffsetParent.clientWidth || 0 : 0;
  var centerToReference = endDiff / 2 - startDiff / 2;
  var min2 = paddingObject[minProp];
  var max2 = clientSize - arrowRect[len] - paddingObject[maxProp];
  var center = clientSize / 2 - arrowRect[len] / 2 + centerToReference;
  var offset2 = within(min2, center, max2);
  var axisProp = axis;
  state.modifiersData[name] = (_state$modifiersData$ = {}, _state$modifiersData$[axisProp] = offset2, _state$modifiersData$.centerOffset = offset2 - center, _state$modifiersData$);
}
function effect$1(_ref2) {
  var state = _ref2.state, options = _ref2.options;
  var _options$element = options.element, arrowElement = _options$element === void 0 ? "[data-popper-arrow]" : _options$element;
  if (arrowElement == null) {
    return;
  }
  if (typeof arrowElement === "string") {
    arrowElement = state.elements.popper.querySelector(arrowElement);
    if (!arrowElement) {
      return;
    }
  }
  if (!contains(state.elements.popper, arrowElement)) {
    return;
  }
  state.elements.arrow = arrowElement;
}
var arrow$1 = {
  name: "arrow",
  enabled: true,
  phase: "main",
  fn: arrow,
  effect: effect$1,
  requires: ["popperOffsets"],
  requiresIfExists: ["preventOverflow"]
};
function getVariation(placement) {
  return placement.split("-")[1];
}
var unsetSides = {
  top: "auto",
  right: "auto",
  bottom: "auto",
  left: "auto"
};
function roundOffsetsByDPR(_ref) {
  var x = _ref.x, y = _ref.y;
  var win = window;
  var dpr = win.devicePixelRatio || 1;
  return {
    x: round(x * dpr) / dpr || 0,
    y: round(y * dpr) / dpr || 0
  };
}
function mapToStyles(_ref2) {
  var _Object$assign2;
  var popper2 = _ref2.popper, popperRect = _ref2.popperRect, placement = _ref2.placement, variation = _ref2.variation, offsets = _ref2.offsets, position = _ref2.position, gpuAcceleration = _ref2.gpuAcceleration, adaptive = _ref2.adaptive, roundOffsets = _ref2.roundOffsets, isFixed = _ref2.isFixed;
  var _offsets$x = offsets.x, x = _offsets$x === void 0 ? 0 : _offsets$x, _offsets$y = offsets.y, y = _offsets$y === void 0 ? 0 : _offsets$y;
  var _ref3 = typeof roundOffsets === "function" ? roundOffsets({
    x,
    y
  }) : {
    x,
    y
  };
  x = _ref3.x;
  y = _ref3.y;
  var hasX = offsets.hasOwnProperty("x");
  var hasY = offsets.hasOwnProperty("y");
  var sideX = left;
  var sideY = top;
  var win = window;
  if (adaptive) {
    var offsetParent = getOffsetParent(popper2);
    var heightProp = "clientHeight";
    var widthProp = "clientWidth";
    if (offsetParent === getWindow(popper2)) {
      offsetParent = getDocumentElement(popper2);
      if (getComputedStyle$1(offsetParent).position !== "static" && position === "absolute") {
        heightProp = "scrollHeight";
        widthProp = "scrollWidth";
      }
    }
    offsetParent = offsetParent;
    if (placement === top || (placement === left || placement === right) && variation === end) {
      sideY = bottom;
      var offsetY = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.height : offsetParent[heightProp];
      y -= offsetY - popperRect.height;
      y *= gpuAcceleration ? 1 : -1;
    }
    if (placement === left || (placement === top || placement === bottom) && variation === end) {
      sideX = right;
      var offsetX = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.width : offsetParent[widthProp];
      x -= offsetX - popperRect.width;
      x *= gpuAcceleration ? 1 : -1;
    }
  }
  var commonStyles = Object.assign({
    position
  }, adaptive && unsetSides);
  var _ref4 = roundOffsets === true ? roundOffsetsByDPR({
    x,
    y
  }) : {
    x,
    y
  };
  x = _ref4.x;
  y = _ref4.y;
  if (gpuAcceleration) {
    var _Object$assign;
    return Object.assign({}, commonStyles, (_Object$assign = {}, _Object$assign[sideY] = hasY ? "0" : "", _Object$assign[sideX] = hasX ? "0" : "", _Object$assign.transform = (win.devicePixelRatio || 1) <= 1 ? "translate(" + x + "px, " + y + "px)" : "translate3d(" + x + "px, " + y + "px, 0)", _Object$assign));
  }
  return Object.assign({}, commonStyles, (_Object$assign2 = {}, _Object$assign2[sideY] = hasY ? y + "px" : "", _Object$assign2[sideX] = hasX ? x + "px" : "", _Object$assign2.transform = "", _Object$assign2));
}
function computeStyles(_ref5) {
  var state = _ref5.state, options = _ref5.options;
  var _options$gpuAccelerat = options.gpuAcceleration, gpuAcceleration = _options$gpuAccelerat === void 0 ? true : _options$gpuAccelerat, _options$adaptive = options.adaptive, adaptive = _options$adaptive === void 0 ? true : _options$adaptive, _options$roundOffsets = options.roundOffsets, roundOffsets = _options$roundOffsets === void 0 ? true : _options$roundOffsets;
  var commonStyles = {
    placement: getBasePlacement(state.placement),
    variation: getVariation(state.placement),
    popper: state.elements.popper,
    popperRect: state.rects.popper,
    gpuAcceleration,
    isFixed: state.options.strategy === "fixed"
  };
  if (state.modifiersData.popperOffsets != null) {
    state.styles.popper = Object.assign({}, state.styles.popper, mapToStyles(Object.assign({}, commonStyles, {
      offsets: state.modifiersData.popperOffsets,
      position: state.options.strategy,
      adaptive,
      roundOffsets
    })));
  }
  if (state.modifiersData.arrow != null) {
    state.styles.arrow = Object.assign({}, state.styles.arrow, mapToStyles(Object.assign({}, commonStyles, {
      offsets: state.modifiersData.arrow,
      position: "absolute",
      adaptive: false,
      roundOffsets
    })));
  }
  state.attributes.popper = Object.assign({}, state.attributes.popper, {
    "data-popper-placement": state.placement
  });
}
var computeStyles$1 = {
  name: "computeStyles",
  enabled: true,
  phase: "beforeWrite",
  fn: computeStyles,
  data: {}
};
var passive = {
  passive: true
};
function effect(_ref) {
  var state = _ref.state, instance = _ref.instance, options = _ref.options;
  var _options$scroll = options.scroll, scroll = _options$scroll === void 0 ? true : _options$scroll, _options$resize = options.resize, resize = _options$resize === void 0 ? true : _options$resize;
  var window2 = getWindow(state.elements.popper);
  var scrollParents = [].concat(state.scrollParents.reference, state.scrollParents.popper);
  if (scroll) {
    scrollParents.forEach(function(scrollParent) {
      scrollParent.addEventListener("scroll", instance.update, passive);
    });
  }
  if (resize) {
    window2.addEventListener("resize", instance.update, passive);
  }
  return function() {
    if (scroll) {
      scrollParents.forEach(function(scrollParent) {
        scrollParent.removeEventListener("scroll", instance.update, passive);
      });
    }
    if (resize) {
      window2.removeEventListener("resize", instance.update, passive);
    }
  };
}
var eventListeners = {
  name: "eventListeners",
  enabled: true,
  phase: "write",
  fn: function fn() {
  },
  effect,
  data: {}
};
var hash$1 = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
};
function getOppositePlacement(placement) {
  return placement.replace(/left|right|bottom|top/g, function(matched) {
    return hash$1[matched];
  });
}
var hash = {
  start: "end",
  end: "start"
};
function getOppositeVariationPlacement(placement) {
  return placement.replace(/start|end/g, function(matched) {
    return hash[matched];
  });
}
function getWindowScroll(node) {
  var win = getWindow(node);
  var scrollLeft = win.pageXOffset;
  var scrollTop = win.pageYOffset;
  return {
    scrollLeft,
    scrollTop
  };
}
function getWindowScrollBarX(element) {
  return getBoundingClientRect(getDocumentElement(element)).left + getWindowScroll(element).scrollLeft;
}
function getViewportRect(element) {
  var win = getWindow(element);
  var html = getDocumentElement(element);
  var visualViewport = win.visualViewport;
  var width = html.clientWidth;
  var height = html.clientHeight;
  var x = 0;
  var y = 0;
  if (visualViewport) {
    width = visualViewport.width;
    height = visualViewport.height;
    if (!/^((?!chrome|android).)*safari/i.test(navigator.userAgent)) {
      x = visualViewport.offsetLeft;
      y = visualViewport.offsetTop;
    }
  }
  return {
    width,
    height,
    x: x + getWindowScrollBarX(element),
    y
  };
}
function getDocumentRect(element) {
  var _element$ownerDocumen;
  var html = getDocumentElement(element);
  var winScroll = getWindowScroll(element);
  var body = (_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body;
  var width = max(html.scrollWidth, html.clientWidth, body ? body.scrollWidth : 0, body ? body.clientWidth : 0);
  var height = max(html.scrollHeight, html.clientHeight, body ? body.scrollHeight : 0, body ? body.clientHeight : 0);
  var x = -winScroll.scrollLeft + getWindowScrollBarX(element);
  var y = -winScroll.scrollTop;
  if (getComputedStyle$1(body || html).direction === "rtl") {
    x += max(html.clientWidth, body ? body.clientWidth : 0) - width;
  }
  return {
    width,
    height,
    x,
    y
  };
}
function isScrollParent(element) {
  var _getComputedStyle = getComputedStyle$1(element), overflow = _getComputedStyle.overflow, overflowX = _getComputedStyle.overflowX, overflowY = _getComputedStyle.overflowY;
  return /auto|scroll|overlay|hidden/.test(overflow + overflowY + overflowX);
}
function getScrollParent(node) {
  if (["html", "body", "#document"].indexOf(getNodeName(node)) >= 0) {
    return node.ownerDocument.body;
  }
  if (isHTMLElement(node) && isScrollParent(node)) {
    return node;
  }
  return getScrollParent(getParentNode(node));
}
function listScrollParents(element, list) {
  var _element$ownerDocumen;
  if (list === void 0) {
    list = [];
  }
  var scrollParent = getScrollParent(element);
  var isBody = scrollParent === ((_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body);
  var win = getWindow(scrollParent);
  var target = isBody ? [win].concat(win.visualViewport || [], isScrollParent(scrollParent) ? scrollParent : []) : scrollParent;
  var updatedList = list.concat(target);
  return isBody ? updatedList : updatedList.concat(listScrollParents(getParentNode(target)));
}
function rectToClientRect(rect) {
  return Object.assign({}, rect, {
    left: rect.x,
    top: rect.y,
    right: rect.x + rect.width,
    bottom: rect.y + rect.height
  });
}
function getInnerBoundingClientRect(element) {
  var rect = getBoundingClientRect(element);
  rect.top = rect.top + element.clientTop;
  rect.left = rect.left + element.clientLeft;
  rect.bottom = rect.top + element.clientHeight;
  rect.right = rect.left + element.clientWidth;
  rect.width = element.clientWidth;
  rect.height = element.clientHeight;
  rect.x = rect.left;
  rect.y = rect.top;
  return rect;
}
function getClientRectFromMixedType(element, clippingParent) {
  return clippingParent === viewport ? rectToClientRect(getViewportRect(element)) : isElement(clippingParent) ? getInnerBoundingClientRect(clippingParent) : rectToClientRect(getDocumentRect(getDocumentElement(element)));
}
function getClippingParents(element) {
  var clippingParents2 = listScrollParents(getParentNode(element));
  var canEscapeClipping = ["absolute", "fixed"].indexOf(getComputedStyle$1(element).position) >= 0;
  var clipperElement = canEscapeClipping && isHTMLElement(element) ? getOffsetParent(element) : element;
  if (!isElement(clipperElement)) {
    return [];
  }
  return clippingParents2.filter(function(clippingParent) {
    return isElement(clippingParent) && contains(clippingParent, clipperElement) && getNodeName(clippingParent) !== "body";
  });
}
function getClippingRect(element, boundary, rootBoundary) {
  var mainClippingParents = boundary === "clippingParents" ? getClippingParents(element) : [].concat(boundary);
  var clippingParents2 = [].concat(mainClippingParents, [rootBoundary]);
  var firstClippingParent = clippingParents2[0];
  var clippingRect = clippingParents2.reduce(function(accRect, clippingParent) {
    var rect = getClientRectFromMixedType(element, clippingParent);
    accRect.top = max(rect.top, accRect.top);
    accRect.right = min(rect.right, accRect.right);
    accRect.bottom = min(rect.bottom, accRect.bottom);
    accRect.left = max(rect.left, accRect.left);
    return accRect;
  }, getClientRectFromMixedType(element, firstClippingParent));
  clippingRect.width = clippingRect.right - clippingRect.left;
  clippingRect.height = clippingRect.bottom - clippingRect.top;
  clippingRect.x = clippingRect.left;
  clippingRect.y = clippingRect.top;
  return clippingRect;
}
function computeOffsets(_ref) {
  var reference2 = _ref.reference, element = _ref.element, placement = _ref.placement;
  var basePlacement = placement ? getBasePlacement(placement) : null;
  var variation = placement ? getVariation(placement) : null;
  var commonX = reference2.x + reference2.width / 2 - element.width / 2;
  var commonY = reference2.y + reference2.height / 2 - element.height / 2;
  var offsets;
  switch (basePlacement) {
    case top:
      offsets = {
        x: commonX,
        y: reference2.y - element.height
      };
      break;
    case bottom:
      offsets = {
        x: commonX,
        y: reference2.y + reference2.height
      };
      break;
    case right:
      offsets = {
        x: reference2.x + reference2.width,
        y: commonY
      };
      break;
    case left:
      offsets = {
        x: reference2.x - element.width,
        y: commonY
      };
      break;
    default:
      offsets = {
        x: reference2.x,
        y: reference2.y
      };
  }
  var mainAxis = basePlacement ? getMainAxisFromPlacement(basePlacement) : null;
  if (mainAxis != null) {
    var len = mainAxis === "y" ? "height" : "width";
    switch (variation) {
      case start:
        offsets[mainAxis] = offsets[mainAxis] - (reference2[len] / 2 - element[len] / 2);
        break;
      case end:
        offsets[mainAxis] = offsets[mainAxis] + (reference2[len] / 2 - element[len] / 2);
        break;
    }
  }
  return offsets;
}
function detectOverflow(state, options) {
  if (options === void 0) {
    options = {};
  }
  var _options = options, _options$placement = _options.placement, placement = _options$placement === void 0 ? state.placement : _options$placement, _options$boundary = _options.boundary, boundary = _options$boundary === void 0 ? clippingParents : _options$boundary, _options$rootBoundary = _options.rootBoundary, rootBoundary = _options$rootBoundary === void 0 ? viewport : _options$rootBoundary, _options$elementConte = _options.elementContext, elementContext = _options$elementConte === void 0 ? popper : _options$elementConte, _options$altBoundary = _options.altBoundary, altBoundary = _options$altBoundary === void 0 ? false : _options$altBoundary, _options$padding = _options.padding, padding = _options$padding === void 0 ? 0 : _options$padding;
  var paddingObject = mergePaddingObject(typeof padding !== "number" ? padding : expandToHashMap(padding, basePlacements));
  var altContext = elementContext === popper ? reference : popper;
  var popperRect = state.rects.popper;
  var element = state.elements[altBoundary ? altContext : elementContext];
  var clippingClientRect = getClippingRect(isElement(element) ? element : element.contextElement || getDocumentElement(state.elements.popper), boundary, rootBoundary);
  var referenceClientRect = getBoundingClientRect(state.elements.reference);
  var popperOffsets2 = computeOffsets({
    reference: referenceClientRect,
    element: popperRect,
    strategy: "absolute",
    placement
  });
  var popperClientRect = rectToClientRect(Object.assign({}, popperRect, popperOffsets2));
  var elementClientRect = elementContext === popper ? popperClientRect : referenceClientRect;
  var overflowOffsets = {
    top: clippingClientRect.top - elementClientRect.top + paddingObject.top,
    bottom: elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom,
    left: clippingClientRect.left - elementClientRect.left + paddingObject.left,
    right: elementClientRect.right - clippingClientRect.right + paddingObject.right
  };
  var offsetData = state.modifiersData.offset;
  if (elementContext === popper && offsetData) {
    var offset2 = offsetData[placement];
    Object.keys(overflowOffsets).forEach(function(key) {
      var multiply = [right, bottom].indexOf(key) >= 0 ? 1 : -1;
      var axis = [top, bottom].indexOf(key) >= 0 ? "y" : "x";
      overflowOffsets[key] += offset2[axis] * multiply;
    });
  }
  return overflowOffsets;
}
function computeAutoPlacement(state, options) {
  if (options === void 0) {
    options = {};
  }
  var _options = options, placement = _options.placement, boundary = _options.boundary, rootBoundary = _options.rootBoundary, padding = _options.padding, flipVariations = _options.flipVariations, _options$allowedAutoP = _options.allowedAutoPlacements, allowedAutoPlacements = _options$allowedAutoP === void 0 ? placements : _options$allowedAutoP;
  var variation = getVariation(placement);
  var placements$1 = variation ? flipVariations ? variationPlacements : variationPlacements.filter(function(placement2) {
    return getVariation(placement2) === variation;
  }) : basePlacements;
  var allowedPlacements = placements$1.filter(function(placement2) {
    return allowedAutoPlacements.indexOf(placement2) >= 0;
  });
  if (allowedPlacements.length === 0) {
    allowedPlacements = placements$1;
  }
  var overflows = allowedPlacements.reduce(function(acc, placement2) {
    acc[placement2] = detectOverflow(state, {
      placement: placement2,
      boundary,
      rootBoundary,
      padding
    })[getBasePlacement(placement2)];
    return acc;
  }, {});
  return Object.keys(overflows).sort(function(a, b) {
    return overflows[a] - overflows[b];
  });
}
function getExpandedFallbackPlacements(placement) {
  if (getBasePlacement(placement) === auto) {
    return [];
  }
  var oppositePlacement = getOppositePlacement(placement);
  return [getOppositeVariationPlacement(placement), oppositePlacement, getOppositeVariationPlacement(oppositePlacement)];
}
function flip(_ref) {
  var state = _ref.state, options = _ref.options, name = _ref.name;
  if (state.modifiersData[name]._skip) {
    return;
  }
  var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? true : _options$altAxis, specifiedFallbackPlacements = options.fallbackPlacements, padding = options.padding, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, _options$flipVariatio = options.flipVariations, flipVariations = _options$flipVariatio === void 0 ? true : _options$flipVariatio, allowedAutoPlacements = options.allowedAutoPlacements;
  var preferredPlacement = state.options.placement;
  var basePlacement = getBasePlacement(preferredPlacement);
  var isBasePlacement = basePlacement === preferredPlacement;
  var fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipVariations ? [getOppositePlacement(preferredPlacement)] : getExpandedFallbackPlacements(preferredPlacement));
  var placements2 = [preferredPlacement].concat(fallbackPlacements).reduce(function(acc, placement2) {
    return acc.concat(getBasePlacement(placement2) === auto ? computeAutoPlacement(state, {
      placement: placement2,
      boundary,
      rootBoundary,
      padding,
      flipVariations,
      allowedAutoPlacements
    }) : placement2);
  }, []);
  var referenceRect = state.rects.reference;
  var popperRect = state.rects.popper;
  var checksMap = /* @__PURE__ */ new Map();
  var makeFallbackChecks = true;
  var firstFittingPlacement = placements2[0];
  for (var i = 0; i < placements2.length; i++) {
    var placement = placements2[i];
    var _basePlacement = getBasePlacement(placement);
    var isStartVariation = getVariation(placement) === start;
    var isVertical = [top, bottom].indexOf(_basePlacement) >= 0;
    var len = isVertical ? "width" : "height";
    var overflow = detectOverflow(state, {
      placement,
      boundary,
      rootBoundary,
      altBoundary,
      padding
    });
    var mainVariationSide = isVertical ? isStartVariation ? right : left : isStartVariation ? bottom : top;
    if (referenceRect[len] > popperRect[len]) {
      mainVariationSide = getOppositePlacement(mainVariationSide);
    }
    var altVariationSide = getOppositePlacement(mainVariationSide);
    var checks = [];
    if (checkMainAxis) {
      checks.push(overflow[_basePlacement] <= 0);
    }
    if (checkAltAxis) {
      checks.push(overflow[mainVariationSide] <= 0, overflow[altVariationSide] <= 0);
    }
    if (checks.every(function(check) {
      return check;
    })) {
      firstFittingPlacement = placement;
      makeFallbackChecks = false;
      break;
    }
    checksMap.set(placement, checks);
  }
  if (makeFallbackChecks) {
    var numberOfChecks = flipVariations ? 3 : 1;
    var _loop = function _loop2(_i2) {
      var fittingPlacement = placements2.find(function(placement2) {
        var checks2 = checksMap.get(placement2);
        if (checks2) {
          return checks2.slice(0, _i2).every(function(check) {
            return check;
          });
        }
      });
      if (fittingPlacement) {
        firstFittingPlacement = fittingPlacement;
        return "break";
      }
    };
    for (var _i = numberOfChecks; _i > 0; _i--) {
      var _ret = _loop(_i);
      if (_ret === "break")
        break;
    }
  }
  if (state.placement !== firstFittingPlacement) {
    state.modifiersData[name]._skip = true;
    state.placement = firstFittingPlacement;
    state.reset = true;
  }
}
var flip$1 = {
  name: "flip",
  enabled: true,
  phase: "main",
  fn: flip,
  requiresIfExists: ["offset"],
  data: {
    _skip: false
  }
};
function getSideOffsets(overflow, rect, preventedOffsets) {
  if (preventedOffsets === void 0) {
    preventedOffsets = {
      x: 0,
      y: 0
    };
  }
  return {
    top: overflow.top - rect.height - preventedOffsets.y,
    right: overflow.right - rect.width + preventedOffsets.x,
    bottom: overflow.bottom - rect.height + preventedOffsets.y,
    left: overflow.left - rect.width - preventedOffsets.x
  };
}
function isAnySideFullyClipped(overflow) {
  return [top, right, bottom, left].some(function(side) {
    return overflow[side] >= 0;
  });
}
function hide(_ref) {
  var state = _ref.state, name = _ref.name;
  var referenceRect = state.rects.reference;
  var popperRect = state.rects.popper;
  var preventedOffsets = state.modifiersData.preventOverflow;
  var referenceOverflow = detectOverflow(state, {
    elementContext: "reference"
  });
  var popperAltOverflow = detectOverflow(state, {
    altBoundary: true
  });
  var referenceClippingOffsets = getSideOffsets(referenceOverflow, referenceRect);
  var popperEscapeOffsets = getSideOffsets(popperAltOverflow, popperRect, preventedOffsets);
  var isReferenceHidden = isAnySideFullyClipped(referenceClippingOffsets);
  var hasPopperEscaped = isAnySideFullyClipped(popperEscapeOffsets);
  state.modifiersData[name] = {
    referenceClippingOffsets,
    popperEscapeOffsets,
    isReferenceHidden,
    hasPopperEscaped
  };
  state.attributes.popper = Object.assign({}, state.attributes.popper, {
    "data-popper-reference-hidden": isReferenceHidden,
    "data-popper-escaped": hasPopperEscaped
  });
}
var hide$1 = {
  name: "hide",
  enabled: true,
  phase: "main",
  requiresIfExists: ["preventOverflow"],
  fn: hide
};
function distanceAndSkiddingToXY(placement, rects, offset2) {
  var basePlacement = getBasePlacement(placement);
  var invertDistance = [left, top].indexOf(basePlacement) >= 0 ? -1 : 1;
  var _ref = typeof offset2 === "function" ? offset2(Object.assign({}, rects, {
    placement
  })) : offset2, skidding = _ref[0], distance = _ref[1];
  skidding = skidding || 0;
  distance = (distance || 0) * invertDistance;
  return [left, right].indexOf(basePlacement) >= 0 ? {
    x: distance,
    y: skidding
  } : {
    x: skidding,
    y: distance
  };
}
function offset(_ref2) {
  var state = _ref2.state, options = _ref2.options, name = _ref2.name;
  var _options$offset = options.offset, offset2 = _options$offset === void 0 ? [0, 0] : _options$offset;
  var data = placements.reduce(function(acc, placement) {
    acc[placement] = distanceAndSkiddingToXY(placement, state.rects, offset2);
    return acc;
  }, {});
  var _data$state$placement = data[state.placement], x = _data$state$placement.x, y = _data$state$placement.y;
  if (state.modifiersData.popperOffsets != null) {
    state.modifiersData.popperOffsets.x += x;
    state.modifiersData.popperOffsets.y += y;
  }
  state.modifiersData[name] = data;
}
var offset$1 = {
  name: "offset",
  enabled: true,
  phase: "main",
  requires: ["popperOffsets"],
  fn: offset
};
function popperOffsets(_ref) {
  var state = _ref.state, name = _ref.name;
  state.modifiersData[name] = computeOffsets({
    reference: state.rects.reference,
    element: state.rects.popper,
    strategy: "absolute",
    placement: state.placement
  });
}
var popperOffsets$1 = {
  name: "popperOffsets",
  enabled: true,
  phase: "read",
  fn: popperOffsets,
  data: {}
};
function getAltAxis(axis) {
  return axis === "x" ? "y" : "x";
}
function preventOverflow(_ref) {
  var state = _ref.state, options = _ref.options, name = _ref.name;
  var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? false : _options$altAxis, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, padding = options.padding, _options$tether = options.tether, tether = _options$tether === void 0 ? true : _options$tether, _options$tetherOffset = options.tetherOffset, tetherOffset = _options$tetherOffset === void 0 ? 0 : _options$tetherOffset;
  var overflow = detectOverflow(state, {
    boundary,
    rootBoundary,
    padding,
    altBoundary
  });
  var basePlacement = getBasePlacement(state.placement);
  var variation = getVariation(state.placement);
  var isBasePlacement = !variation;
  var mainAxis = getMainAxisFromPlacement(basePlacement);
  var altAxis = getAltAxis(mainAxis);
  var popperOffsets2 = state.modifiersData.popperOffsets;
  var referenceRect = state.rects.reference;
  var popperRect = state.rects.popper;
  var tetherOffsetValue = typeof tetherOffset === "function" ? tetherOffset(Object.assign({}, state.rects, {
    placement: state.placement
  })) : tetherOffset;
  var normalizedTetherOffsetValue = typeof tetherOffsetValue === "number" ? {
    mainAxis: tetherOffsetValue,
    altAxis: tetherOffsetValue
  } : Object.assign({
    mainAxis: 0,
    altAxis: 0
  }, tetherOffsetValue);
  var offsetModifierState = state.modifiersData.offset ? state.modifiersData.offset[state.placement] : null;
  var data = {
    x: 0,
    y: 0
  };
  if (!popperOffsets2) {
    return;
  }
  if (checkMainAxis) {
    var _offsetModifierState$;
    var mainSide = mainAxis === "y" ? top : left;
    var altSide = mainAxis === "y" ? bottom : right;
    var len = mainAxis === "y" ? "height" : "width";
    var offset2 = popperOffsets2[mainAxis];
    var min$1 = offset2 + overflow[mainSide];
    var max$1 = offset2 - overflow[altSide];
    var additive = tether ? -popperRect[len] / 2 : 0;
    var minLen = variation === start ? referenceRect[len] : popperRect[len];
    var maxLen = variation === start ? -popperRect[len] : -referenceRect[len];
    var arrowElement = state.elements.arrow;
    var arrowRect = tether && arrowElement ? getLayoutRect(arrowElement) : {
      width: 0,
      height: 0
    };
    var arrowPaddingObject = state.modifiersData["arrow#persistent"] ? state.modifiersData["arrow#persistent"].padding : getFreshSideObject();
    var arrowPaddingMin = arrowPaddingObject[mainSide];
    var arrowPaddingMax = arrowPaddingObject[altSide];
    var arrowLen = within(0, referenceRect[len], arrowRect[len]);
    var minOffset = isBasePlacement ? referenceRect[len] / 2 - additive - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis : minLen - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis;
    var maxOffset = isBasePlacement ? -referenceRect[len] / 2 + additive + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis : maxLen + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis;
    var arrowOffsetParent = state.elements.arrow && getOffsetParent(state.elements.arrow);
    var clientOffset = arrowOffsetParent ? mainAxis === "y" ? arrowOffsetParent.clientTop || 0 : arrowOffsetParent.clientLeft || 0 : 0;
    var offsetModifierValue = (_offsetModifierState$ = offsetModifierState == null ? void 0 : offsetModifierState[mainAxis]) != null ? _offsetModifierState$ : 0;
    var tetherMin = offset2 + minOffset - offsetModifierValue - clientOffset;
    var tetherMax = offset2 + maxOffset - offsetModifierValue;
    var preventedOffset = within(tether ? min(min$1, tetherMin) : min$1, offset2, tether ? max(max$1, tetherMax) : max$1);
    popperOffsets2[mainAxis] = preventedOffset;
    data[mainAxis] = preventedOffset - offset2;
  }
  if (checkAltAxis) {
    var _offsetModifierState$2;
    var _mainSide = mainAxis === "x" ? top : left;
    var _altSide = mainAxis === "x" ? bottom : right;
    var _offset = popperOffsets2[altAxis];
    var _len = altAxis === "y" ? "height" : "width";
    var _min = _offset + overflow[_mainSide];
    var _max = _offset - overflow[_altSide];
    var isOriginSide = [top, left].indexOf(basePlacement) !== -1;
    var _offsetModifierValue = (_offsetModifierState$2 = offsetModifierState == null ? void 0 : offsetModifierState[altAxis]) != null ? _offsetModifierState$2 : 0;
    var _tetherMin = isOriginSide ? _min : _offset - referenceRect[_len] - popperRect[_len] - _offsetModifierValue + normalizedTetherOffsetValue.altAxis;
    var _tetherMax = isOriginSide ? _offset + referenceRect[_len] + popperRect[_len] - _offsetModifierValue - normalizedTetherOffsetValue.altAxis : _max;
    var _preventedOffset = tether && isOriginSide ? withinMaxClamp(_tetherMin, _offset, _tetherMax) : within(tether ? _tetherMin : _min, _offset, tether ? _tetherMax : _max);
    popperOffsets2[altAxis] = _preventedOffset;
    data[altAxis] = _preventedOffset - _offset;
  }
  state.modifiersData[name] = data;
}
var preventOverflow$1 = {
  name: "preventOverflow",
  enabled: true,
  phase: "main",
  fn: preventOverflow,
  requiresIfExists: ["offset"]
};
function getHTMLElementScroll(element) {
  return {
    scrollLeft: element.scrollLeft,
    scrollTop: element.scrollTop
  };
}
function getNodeScroll(node) {
  if (node === getWindow(node) || !isHTMLElement(node)) {
    return getWindowScroll(node);
  } else {
    return getHTMLElementScroll(node);
  }
}
function isElementScaled(element) {
  var rect = element.getBoundingClientRect();
  var scaleX = round(rect.width) / element.offsetWidth || 1;
  var scaleY = round(rect.height) / element.offsetHeight || 1;
  return scaleX !== 1 || scaleY !== 1;
}
function getCompositeRect(elementOrVirtualElement, offsetParent, isFixed) {
  if (isFixed === void 0) {
    isFixed = false;
  }
  var isOffsetParentAnElement = isHTMLElement(offsetParent);
  var offsetParentIsScaled = isHTMLElement(offsetParent) && isElementScaled(offsetParent);
  var documentElement = getDocumentElement(offsetParent);
  var rect = getBoundingClientRect(elementOrVirtualElement, offsetParentIsScaled);
  var scroll = {
    scrollLeft: 0,
    scrollTop: 0
  };
  var offsets = {
    x: 0,
    y: 0
  };
  if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
    if (getNodeName(offsetParent) !== "body" || isScrollParent(documentElement)) {
      scroll = getNodeScroll(offsetParent);
    }
    if (isHTMLElement(offsetParent)) {
      offsets = getBoundingClientRect(offsetParent, true);
      offsets.x += offsetParent.clientLeft;
      offsets.y += offsetParent.clientTop;
    } else if (documentElement) {
      offsets.x = getWindowScrollBarX(documentElement);
    }
  }
  return {
    x: rect.left + scroll.scrollLeft - offsets.x,
    y: rect.top + scroll.scrollTop - offsets.y,
    width: rect.width,
    height: rect.height
  };
}
function order(modifiers) {
  var map = /* @__PURE__ */ new Map();
  var visited = /* @__PURE__ */ new Set();
  var result = [];
  modifiers.forEach(function(modifier) {
    map.set(modifier.name, modifier);
  });
  function sort(modifier) {
    visited.add(modifier.name);
    var requires = [].concat(modifier.requires || [], modifier.requiresIfExists || []);
    requires.forEach(function(dep) {
      if (!visited.has(dep)) {
        var depModifier = map.get(dep);
        if (depModifier) {
          sort(depModifier);
        }
      }
    });
    result.push(modifier);
  }
  modifiers.forEach(function(modifier) {
    if (!visited.has(modifier.name)) {
      sort(modifier);
    }
  });
  return result;
}
function orderModifiers(modifiers) {
  var orderedModifiers = order(modifiers);
  return modifierPhases.reduce(function(acc, phase) {
    return acc.concat(orderedModifiers.filter(function(modifier) {
      return modifier.phase === phase;
    }));
  }, []);
}
function debounce(fn2) {
  var pending;
  return function() {
    if (!pending) {
      pending = new Promise(function(resolve) {
        Promise.resolve().then(function() {
          pending = void 0;
          resolve(fn2());
        });
      });
    }
    return pending;
  };
}
function mergeByName(modifiers) {
  var merged = modifiers.reduce(function(merged2, current) {
    var existing = merged2[current.name];
    merged2[current.name] = existing ? Object.assign({}, existing, current, {
      options: Object.assign({}, existing.options, current.options),
      data: Object.assign({}, existing.data, current.data)
    }) : current;
    return merged2;
  }, {});
  return Object.keys(merged).map(function(key) {
    return merged[key];
  });
}
var DEFAULT_OPTIONS = {
  placement: "bottom",
  modifiers: [],
  strategy: "absolute"
};
function areValidElements() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }
  return !args.some(function(element) {
    return !(element && typeof element.getBoundingClientRect === "function");
  });
}
function popperGenerator(generatorOptions) {
  if (generatorOptions === void 0) {
    generatorOptions = {};
  }
  var _generatorOptions = generatorOptions, _generatorOptions$def = _generatorOptions.defaultModifiers, defaultModifiers2 = _generatorOptions$def === void 0 ? [] : _generatorOptions$def, _generatorOptions$def2 = _generatorOptions.defaultOptions, defaultOptions = _generatorOptions$def2 === void 0 ? DEFAULT_OPTIONS : _generatorOptions$def2;
  return function createPopper2(reference2, popper2, options) {
    if (options === void 0) {
      options = defaultOptions;
    }
    var state = {
      placement: "bottom",
      orderedModifiers: [],
      options: Object.assign({}, DEFAULT_OPTIONS, defaultOptions),
      modifiersData: {},
      elements: {
        reference: reference2,
        popper: popper2
      },
      attributes: {},
      styles: {}
    };
    var effectCleanupFns = [];
    var isDestroyed = false;
    var instance = {
      state,
      setOptions: function setOptions(setOptionsAction) {
        var options2 = typeof setOptionsAction === "function" ? setOptionsAction(state.options) : setOptionsAction;
        cleanupModifierEffects();
        state.options = Object.assign({}, defaultOptions, state.options, options2);
        state.scrollParents = {
          reference: isElement(reference2) ? listScrollParents(reference2) : reference2.contextElement ? listScrollParents(reference2.contextElement) : [],
          popper: listScrollParents(popper2)
        };
        var orderedModifiers = orderModifiers(mergeByName([].concat(defaultModifiers2, state.options.modifiers)));
        state.orderedModifiers = orderedModifiers.filter(function(m) {
          return m.enabled;
        });
        runModifierEffects();
        return instance.update();
      },
      forceUpdate: function forceUpdate() {
        if (isDestroyed) {
          return;
        }
        var _state$elements = state.elements, reference3 = _state$elements.reference, popper3 = _state$elements.popper;
        if (!areValidElements(reference3, popper3)) {
          return;
        }
        state.rects = {
          reference: getCompositeRect(reference3, getOffsetParent(popper3), state.options.strategy === "fixed"),
          popper: getLayoutRect(popper3)
        };
        state.reset = false;
        state.placement = state.options.placement;
        state.orderedModifiers.forEach(function(modifier) {
          return state.modifiersData[modifier.name] = Object.assign({}, modifier.data);
        });
        for (var index = 0; index < state.orderedModifiers.length; index++) {
          if (state.reset === true) {
            state.reset = false;
            index = -1;
            continue;
          }
          var _state$orderedModifie = state.orderedModifiers[index], fn2 = _state$orderedModifie.fn, _state$orderedModifie2 = _state$orderedModifie.options, _options = _state$orderedModifie2 === void 0 ? {} : _state$orderedModifie2, name = _state$orderedModifie.name;
          if (typeof fn2 === "function") {
            state = fn2({
              state,
              options: _options,
              name,
              instance
            }) || state;
          }
        }
      },
      update: debounce(function() {
        return new Promise(function(resolve) {
          instance.forceUpdate();
          resolve(state);
        });
      }),
      destroy: function destroy() {
        cleanupModifierEffects();
        isDestroyed = true;
      }
    };
    if (!areValidElements(reference2, popper2)) {
      return instance;
    }
    instance.setOptions(options).then(function(state2) {
      if (!isDestroyed && options.onFirstUpdate) {
        options.onFirstUpdate(state2);
      }
    });
    function runModifierEffects() {
      state.orderedModifiers.forEach(function(_ref3) {
        var name = _ref3.name, _ref3$options = _ref3.options, options2 = _ref3$options === void 0 ? {} : _ref3$options, effect2 = _ref3.effect;
        if (typeof effect2 === "function") {
          var cleanupFn = effect2({
            state,
            name,
            instance,
            options: options2
          });
          var noopFn = function noopFn2() {
          };
          effectCleanupFns.push(cleanupFn || noopFn);
        }
      });
    }
    function cleanupModifierEffects() {
      effectCleanupFns.forEach(function(fn2) {
        return fn2();
      });
      effectCleanupFns = [];
    }
    return instance;
  };
}
var defaultModifiers = [eventListeners, popperOffsets$1, computeStyles$1, applyStyles$1, offset$1, flip$1, preventOverflow$1, arrow$1, hide$1];
var createPopper = /* @__PURE__ */ popperGenerator({
  defaultModifiers
});
const usePopper = (props, emit, activate) => {
  const targetRef = ref(null);
  const instanceRef = ref(null);
  const parentRef = ref(null);
  const shouldRender = ref(false);
  const hasFocus = useKeyboardFocus(parentRef);
  const popper2 = reactive({
    instance: null,
    target: null
  });
  const options = reactive({
    placement: props.placement,
    modifiers: [
      {
        name: "offset",
        options: {
          offset: props.offset
        }
      },
      {
        name: "preventOverflow",
        options: {
          boundary: "viewport",
          rootBoundary: "document"
        }
      }
    ]
  });
  watchEffect(() => {
    if (!props.modelValue && activate) {
      shouldRender.value = activate.value;
    }
    if (props.modelValue) {
      shouldRender.value = props.modelValue;
    }
    if (props.focusable && hasFocus.value) {
      shouldRender.value = hasFocus.value;
    }
  }, { flush: "post" });
  watch(() => shouldRender.value, (next) => {
    if (next) {
      bindPopper();
    }
    if (props.modelValue) {
      emit("update:modelValue", next);
    }
  });
  const makePopper = () => {
    popper2.instance = createPopper(popper2.target, instanceRef.value, options);
  };
  const killPopper = () => {
    if (popper2.instance) {
      popper2.instance.destroy();
      popper2.instance = null;
    }
  };
  const bindPopper = () => {
    nextTick().then(() => {
      if (popper2.target) {
        makePopper();
      }
    });
  };
  const resetPopper = () => {
    if (popper2.instance) {
      killPopper();
      makePopper();
    }
  };
  const show = () => {
    shouldRender.value = true;
    emit("opened");
    emit("update:modelValue", true);
  };
  const hide2 = () => {
    shouldRender.value = false;
    emit("closed");
    emit("update:modelValue", false);
  };
  const touched = () => {
    shouldRender.value = !shouldRender.value;
  };
  const outsideTouch = (e) => {
    if (shouldRender.value && popper2.target !== e.target) {
      shouldRender.value = false;
    }
  };
  const mountEventBindings = async () => {
    await nextTick().then(() => {
      var _a;
      if (targetRef.value.parentNode instanceof HTMLElement) {
        parentRef.value = (_a = targetRef.value) == null ? void 0 : _a.parentNode;
        popper2.target = parentRef.value;
        if (props.autoOpen && popper2.target) {
          document.body.addEventListener("touchstart", outsideTouch, { passive: true });
          popper2.target.addEventListener("touchstart", touched, { passive: true });
          popper2.target.addEventListener("mouseenter", show, { passive: true });
          popper2.target.addEventListener("mouseleave", hide2, { passive: true });
        }
      }
    });
  };
  onMounted(() => {
    mountEventBindings();
    resetPopper();
  });
  onUnmounted(() => {
    if (props.autoOpen) {
      document.body.removeEventListener("touchstart", outsideTouch);
      popper2.target.removeEventListener("touchstart", touched);
      popper2.target.removeEventListener("mouseenter", show);
      popper2.target.removeEventListener("mouseleave", hide2);
    }
  });
  return { instanceRef, targetRef, shouldRender };
};
var SdTooltip_vue_vue_type_style_index_0_lang = "";
const _sfc_main$u = defineComponent({
  name: "SdTooltip",
  emits: ["update:modelValue", "opened", "closed"],
  props: {
    modelValue: {
      type: Boolean,
      default: false
    },
    theme: {
      type: String,
      default: ""
    },
    delay: {
      type: [String, Number],
      default: 100
    },
    placement: {
      type: String,
      default: "top"
    },
    autoOpen: {
      type: Boolean,
      default: true
    },
    offset: {
      type: Array,
      default: () => [0, 8]
    },
    showArrow: Boolean,
    portalTo: {
      type: String,
      default: "#app"
    },
    focusable: {
      type: Boolean,
      default: true
    },
    portalDisabled: {
      type: Boolean,
      default: false
    }
  },
  setup(props, { emit }) {
    const themeClass = computed(() => `is--${props.theme}`);
    const activate = ref(props.modelValue);
    const { shouldRender, targetRef, instanceRef } = usePopper(props, emit, activate);
    return {
      targetRef,
      instanceRef,
      themeClass,
      shouldRender
    };
  }
});
const _hoisted_1$l = {
  key: 0,
  ref: "instanceRef",
  class: "sd--tooltip"
};
function _sfc_render$t(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createBlock(Teleport, {
    ref: "targetRef",
    to: _ctx.portalDisabled ? null : _ctx.portalTo,
    disabled: _ctx.portalDisabled
  }, [
    createVNode(Transition, { name: "tooltip" }, {
      default: withCtx(() => [
        _ctx.shouldRender ? (openBlock(), createElementBlock("div", _hoisted_1$l, [
          createElementVNode("div", {
            class: normalizeClass(["sd--tooltip__content", _ctx.themeClass])
          }, [
            createElementVNode("div", null, [
              renderSlot(_ctx.$slots, "default")
            ]),
            _ctx.showArrow ? (openBlock(), createElementBlock("div", {
              key: 0,
              class: normalizeClass(["sd--tooltip__arrow", _ctx.themeClass]),
              "data-popper-arrow": ""
            }, null, 2)) : createCommentVNode("", true)
          ], 2)
        ], 512)) : createCommentVNode("", true)
      ]),
      _: 3
    })
  ], 8, ["to", "disabled"]);
}
var SdTooltip = /* @__PURE__ */ _export_sfc(_sfc_main$u, [["render", _sfc_render$t]]);
const useScheme = (mode) => {
  const scheme = computed(() => {
    return `sd--scheme--${isRef(mode) ? mode.value : mode}`;
  });
  watch(() => scheme.value, (newValue, oldValue) => {
    nextTick().then(() => {
      document.body.classList.remove(oldValue);
      document.body.classList.add(newValue);
    });
  });
  onMounted(() => {
    document.body.classList.remove("sd--scheme--dark", "sd--scheme--light");
    document.body.classList.add(scheme.value);
  });
};
var SdLayout_vue_vue_type_style_index_0_lang = "";
const _sfc_main$t = defineComponent({
  name: "SdLayout",
  props: {
    scheme: {
      type: String,
      default: "auto"
    },
    theme: {
      type: String,
      default: "auto"
    },
    sidebar: Boolean,
    floating: Boolean,
    overlay: {
      type: Boolean,
      default: true
    },
    position: {
      type: String,
      default: "left"
    }
  },
  components: {
    SdOverlay
  },
  emits: ["toggle"],
  setup(props, { emit }) {
    useScheme(toRef(props, "scheme"));
    const state = reactive({
      shouldSkip: false
    });
    const layoutClasses = computed(() => {
      return {
        [`sd--layout__body--open-${props.position}`]: props.sidebar && !props.floating
      };
    });
    const sidebarClasses = computed(() => {
      return {
        [`sd--layout__sidebar--${props.position}`]: !!props.position,
        [`sd--layout__sidebar--${props.theme}`]: !!props.theme,
        "is--open": props.sidebar,
        "is--floating": props.floating
      };
    });
    const handleOutsideClick = () => {
      emit("toggle", false);
    };
    const afterLeave = () => {
      if (!props.sidebar) {
        state.shouldSkip = true;
      }
    };
    const handleTabIndex = () => {
      return state.shouldSkip ? { visibility: "hidden" } : null;
    };
    watch(() => [props.sidebar, props.floating], () => {
      const animationTiming = 200;
      setTimeout(() => {
        nextTick().then(() => {
          window.dispatchEvent(new Event("resize"));
        });
      }, animationTiming);
    });
    return __spreadProps(__spreadValues({}, toRefs(state)), {
      sidebarClasses,
      layoutClasses,
      handleOutsideClick,
      handleTabIndex,
      afterLeave
    });
  }
});
const _hoisted_1$k = { class: "sd--layout" };
const _hoisted_2$9 = { class: "sd--layout__header" };
const _hoisted_3$7 = { class: "sd--layout__content" };
function _sfc_render$s(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_sd_overlay = resolveComponent("sd-overlay");
  return openBlock(), createElementBlock("div", _hoisted_1$k, [
    createElementVNode("div", _hoisted_2$9, [
      renderSlot(_ctx.$slots, "header")
    ]),
    createElementVNode("div", {
      class: normalizeClass(["sd--layout__body", _ctx.layoutClasses])
    }, [
      createVNode(Transition, {
        name: `sidebar-${_ctx.position}`,
        onLeave: _ctx.afterLeave
      }, {
        default: withCtx(() => [
          createElementVNode("div", {
            class: normalizeClass(["sd--layout__sidebar", "is--floating", _ctx.sidebarClasses]),
            style: normalizeStyle(_ctx.handleTabIndex)
          }, [
            renderSlot(_ctx.$slots, "sidebar")
          ], 6)
        ]),
        _: 3
      }, 8, ["name", "onLeave"]),
      createElementVNode("div", _hoisted_3$7, [
        renderSlot(_ctx.$slots, "subheader"),
        renderSlot(_ctx.$slots, "content"),
        renderSlot(_ctx.$slots, "footer")
      ])
    ], 2),
    createVNode(Transition, { name: "overlay-fade" }, {
      default: withCtx(() => [
        _ctx.sidebar && _ctx.overlay ? (openBlock(), createBlock(_component_sd_overlay, {
          key: 0,
          active: _ctx.floating && _ctx.sidebar,
          onClick: _ctx.handleOutsideClick
        }, null, 8, ["active", "onClick"])) : createCommentVNode("", true)
      ]),
      _: 1
    })
  ]);
}
var SdLayout = /* @__PURE__ */ _export_sfc(_sfc_main$t, [["render", _sfc_render$s]]);
const SdThrottle = (delay3, fn2) => {
  let lastCall = 0;
  return function(...args) {
    const now = new Date().getTime();
    if (now - lastCall < delay3) {
      return;
    }
    lastCall = now;
    return fn2(...args);
  };
};
const MIN_WIDTH = {
  XS: 0,
  SM: 576,
  MD: 768,
  LG: 992,
  XL: 1200
};
const MAX_WIDTH = {
  XS: 575.95,
  SM: 767.95,
  MD: 991.95,
  LG: 1199.95,
  XL: 1439.95
};
const useWindowWidth = () => {
  const state = reactive({
    windowWidth: null,
    smallDevice: false,
    breakpoint: null
  });
  const getCurrentBreakpoint = (windowWidth) => {
    if (windowWidth > MIN_WIDTH.XS && windowWidth < MAX_WIDTH.XS) {
      state.breakpoint = "XS";
    } else if (windowWidth > MIN_WIDTH.SM && windowWidth < MAX_WIDTH.SM) {
      state.breakpoint = "SM";
    } else if (windowWidth > MIN_WIDTH.MD && windowWidth < MAX_WIDTH.MD) {
      state.breakpoint = "MD";
    } else if (windowWidth > MIN_WIDTH.LG && windowWidth < MAX_WIDTH.LG) {
      state.breakpoint = "LG";
    } else if (windowWidth > MIN_WIDTH.XL) {
      state.breakpoint = "XL";
    }
  };
  const updateWindowWidth = () => {
    const width = window.innerWidth;
    getCurrentBreakpoint(width);
    state.windowWidth = width;
    state.smallDevice = state.windowWidth <= MIN_WIDTH.SM;
  };
  const addResizeListener = () => {
    window.addEventListener("resize", () => {
      SdThrottle(600, updateWindowWidth());
    }, false);
  };
  const removeResizeListener = () => {
    window.removeEventListener("resize", () => {
      SdThrottle(600, updateWindowWidth());
    });
  };
  updateWindowWidth();
  onMounted(() => {
    addResizeListener();
  });
  onUnmounted(() => {
    removeResizeListener();
  });
  return __spreadProps(__spreadValues({}, toRefs(state)), { MIN_WIDTH, MAX_WIDTH });
};
var SdHeader_vue_vue_type_style_index_0_lang = "";
const _sfc_main$s = defineComponent({
  name: "SdHeader",
  emits: ["toggle"],
  components: { SdHamburger },
  props: {
    asideOpen: {
      type: Boolean,
      default: false
    },
    theme: {
      type: String,
      default: "auto"
    },
    sidebarPosition: {
      type: String,
      default: "left"
    }
  },
  setup(props, { emit }) {
    const { smallDevice } = useWindowWidth();
    const sidebar = reactive({
      open: false
    });
    const getStoredMenuState = () => {
      const state = window.localStorage.getItem("SDUI:navState");
      sidebar.open = state === "true";
      emit("toggle", sidebar.open);
    };
    const updateWindowWidth = () => {
      const smScreen = smallDevice.value;
      if (smScreen === true) {
        window.localStorage.setItem("SDUI:navState", "false");
        emit("toggle", false);
      }
    };
    const handleMenu = (e) => {
      const smScreen = smallDevice.value;
      if (!smScreen) {
        window.localStorage.setItem("SDUI:navState", `${!props.asideOpen}`);
      } else {
        window.localStorage.setItem("SDUI:navState", "false");
      }
      emit("toggle", e);
    };
    const triggerClasses = computed(() => {
      return {
        "sd--header__trigger": true,
        [`is--${props.sidebarPosition}`]: !!props.sidebarPosition
      };
    });
    const headerClasses = computed(() => {
      return {
        [`sd--header--${props.theme}`]: !!props.theme
      };
    });
    updateWindowWidth();
    getStoredMenuState();
    return { handleMenu, triggerClasses, headerClasses };
  }
});
const _hoisted_1$j = { class: "sd--header__container" };
const _hoisted_2$8 = { class: "sd--header__content" };
const _hoisted_3$6 = { class: "sd--header__brand" };
const _hoisted_4$5 = { class: "sd--header__nav" };
const _hoisted_5$3 = { class: "sd--header__subheader" };
function _sfc_render$r(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_sd_hamburger = resolveComponent("sd-hamburger");
  return openBlock(), createElementBlock("header", {
    class: normalizeClass(["sd--header", _ctx.headerClasses])
  }, [
    createElementVNode("div", _hoisted_1$j, [
      createVNode(_component_sd_hamburger, {
        theme: _ctx.theme,
        class: normalizeClass([_ctx.triggerClasses]),
        active: _ctx.asideOpen,
        "onUpdate:active": _ctx.handleMenu
      }, null, 8, ["theme", "class", "active", "onUpdate:active"]),
      createElementVNode("div", _hoisted_2$8, [
        createElementVNode("div", _hoisted_3$6, [
          renderSlot(_ctx.$slots, "brand")
        ]),
        createElementVNode("nav", _hoisted_4$5, [
          renderSlot(_ctx.$slots, "nav")
        ])
      ])
    ]),
    createElementVNode("div", _hoisted_5$3, [
      renderSlot(_ctx.$slots, "subheader")
    ])
  ], 2);
}
var SdHeader = /* @__PURE__ */ _export_sfc(_sfc_main$s, [["render", _sfc_render$r]]);
var SdNavContent_vue_vue_type_style_index_0_lang = "";
const _sfc_main$r = defineComponent({
  name: "SdNavContent",
  components: { SdIcon },
  props: {
    href: {
      type: String,
      default: ""
    },
    active: Boolean,
    exactActive: Boolean,
    secondary: Boolean,
    icon: {
      type: String,
      default: ""
    },
    dark: {
      type: Boolean,
      default: false
    },
    light: {
      type: Boolean,
      default: false
    }
  },
  setup(props) {
    const linkClasses = computed(() => {
      return {
        "sd--nav__item": true,
        "is--secondary": props.secondary,
        "is--active": props.active,
        "is--exact-active": props.exactActive
      };
    });
    return {
      linkClasses
    };
  }
});
const _hoisted_1$i = ["href"];
const _hoisted_2$7 = { class: "sd--nav__content" };
function _sfc_render$q(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_sd_icon = resolveComponent("sd-icon");
  return openBlock(), createElementBlock("a", {
    href: _ctx.href,
    class: normalizeClass([_ctx.linkClasses])
  }, [
    _ctx.icon ? (openBlock(), createBlock(_component_sd_icon, {
      key: 0,
      name: _ctx.icon
    }, null, 8, ["name"])) : createCommentVNode("", true),
    createElementVNode("span", _hoisted_2$7, [
      renderSlot(_ctx.$slots, "default")
    ])
  ], 10, _hoisted_1$i);
}
var SdNavContent = /* @__PURE__ */ _export_sfc(_sfc_main$r, [["render", _sfc_render$q]]);
const _sfc_main$q = defineComponent({
  name: "SdNavLink",
  props: {
    icon: {
      type: String,
      default: void 0
    },
    to: {
      type: String,
      default: void 0
    },
    secondary: Boolean
  },
  components: { SdNavContent }
});
function _sfc_render$p(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_sd_nav_content = resolveComponent("sd-nav-content");
  const _component_router_link = resolveComponent("router-link");
  return openBlock(), createBlock(_component_router_link, {
    to: _ctx.to,
    custom: ""
  }, {
    default: withCtx(({ href, navigate, isActive, isExactActive }) => [
      createVNode(_component_sd_nav_content, {
        icon: _ctx.icon,
        href,
        active: isActive,
        "exact-active": isExactActive,
        onClick: navigate,
        secondary: _ctx.secondary
      }, {
        default: withCtx(() => [
          renderSlot(_ctx.$slots, "default")
        ]),
        _: 2
      }, 1032, ["icon", "href", "active", "exact-active", "onClick", "secondary"])
    ]),
    _: 3
  }, 8, ["to"]);
}
var SdNavLink = /* @__PURE__ */ _export_sfc(_sfc_main$q, [["render", _sfc_render$p]]);
var SdNavHeading_vue_vue_type_style_index_0_lang = "";
const _sfc_main$p = defineComponent({
  name: "SdNavHeading"
});
const _hoisted_1$h = { class: "sd--nav__heading" };
const _hoisted_2$6 = { class: "sd--text__footnote" };
function _sfc_render$o(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("div", _hoisted_1$h, [
    createElementVNode("h4", _hoisted_2$6, [
      renderSlot(_ctx.$slots, "default")
    ])
  ]);
}
var SdNavHeading = /* @__PURE__ */ _export_sfc(_sfc_main$p, [["render", _sfc_render$o]]);
var SdNav_vue_vue_type_style_index_0_lang = "";
const _sfc_main$o = defineComponent({
  name: "SdNav",
  props: {
    title: {
      type: String,
      default: ""
    }
  },
  components: { SdNavHeading }
});
const _hoisted_1$g = { class: "sd--nav" };
function _sfc_render$n(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_sd_nav_heading = resolveComponent("sd-nav-heading");
  return openBlock(), createElementBlock("div", _hoisted_1$g, [
    _ctx.title ? (openBlock(), createBlock(_component_sd_nav_heading, { key: 0 }, {
      default: withCtx(() => [
        createTextVNode(toDisplayString(_ctx.title), 1)
      ]),
      _: 1
    })) : createCommentVNode("", true),
    renderSlot(_ctx.$slots, "default")
  ]);
}
var SdNav = /* @__PURE__ */ _export_sfc(_sfc_main$o, [["render", _sfc_render$n]]);
var SdMast_vue_vue_type_style_index_0_lang = "";
const _sfc_main$n = defineComponent({
  name: "SdMast",
  props: {
    alignment: {
      type: String,
      default: ""
    },
    title: {
      type: String,
      default: ""
    },
    subtitle: {
      type: String,
      default: ""
    }
  }
});
const _hoisted_1$f = { class: "sd--mast" };
const _hoisted_2$5 = { class: "sd--mast__content" };
const _hoisted_3$5 = { class: "sd--text__caption" };
const _hoisted_4$4 = { class: "sd--text__headline" };
function _sfc_render$m(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("div", _hoisted_1$f, [
    createElementVNode("div", _hoisted_2$5, [
      createElementVNode("p", _hoisted_3$5, toDisplayString(_ctx.subtitle), 1),
      createElementVNode("h1", _hoisted_4$4, toDisplayString(_ctx.title), 1),
      renderSlot(_ctx.$slots, "default")
    ])
  ]);
}
var SdMast = /* @__PURE__ */ _export_sfc(_sfc_main$n, [["render", _sfc_render$m]]);
var SdRow_vue_vue_type_style_index_0_lang = "";
const _sfc_main$m = defineComponent({
  name: "SdRow",
  props: {
    dense: Boolean,
    gutterless: Boolean,
    alignItems: {
      type: String,
      default: void 0
    },
    justifyContent: {
      type: String,
      default: void 0
    }
  },
  setup(props) {
    const classes = computed(() => {
      return {
        "is--gutterless": props.gutterless,
        "is--dense": props.dense
      };
    });
    return { classes };
  }
});
function _sfc_render$l(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("div", {
    class: normalizeClass(["sd--row", _ctx.classes]),
    style: normalizeStyle({ alignItems: _ctx.alignItems, justifyContent: _ctx.justifyContent })
  }, [
    renderSlot(_ctx.$slots, "default")
  ], 6);
}
var SdRow = /* @__PURE__ */ _export_sfc(_sfc_main$m, [["render", _sfc_render$l]]);
var SdCol_vue_vue_type_style_index_0_lang = "";
const _sfc_main$l = defineComponent({
  name: "SdCol",
  props: {
    xs: {
      type: [Number, String],
      default: void 0
    },
    sm: {
      type: [Number, String],
      default: void 0
    },
    md: {
      type: [Number, String],
      default: void 0
    },
    lg: {
      type: [Number, String],
      default: void 0
    },
    xl: {
      type: [Number, String],
      default: void 0
    },
    order: {
      type: [Number, String],
      default: void 0
    }
  },
  setup(props) {
    const breakpointClasses = computed(() => {
      const classes = [];
      const breakpointAuto = "sd--col-auto";
      const breakpointXs = `sd--col-xs-${props.xs}`;
      const breakpointSm = `sd--col-sm-${props.sm}`;
      const breakpointMd = `sd--col-md-${props.md}`;
      const breakpointLg = `sd--col-lg-${props.lg}`;
      const breakpointXl = `sd--col-xl-${props.xl}`;
      if (props.xs) {
        classes.push(breakpointXs);
      }
      if (props.sm) {
        classes.push(breakpointSm);
      }
      if (props.md) {
        classes.push(breakpointMd);
      }
      if (props.lg) {
        classes.push(breakpointLg);
      }
      if (props.xl) {
        classes.push(breakpointXl);
      }
      if (!props.xs && !props.md && !props.lg && !props.xs && !props.sm) {
        classes.push(breakpointAuto);
      }
      return classes;
    });
    return { breakpointClasses };
  }
});
function _sfc_render$k(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("div", {
    class: normalizeClass([_ctx.breakpointClasses]),
    style: normalizeStyle({ order: _ctx.order })
  }, [
    renderSlot(_ctx.$slots, "default")
  ], 6);
}
var SdCol = /* @__PURE__ */ _export_sfc(_sfc_main$l, [["render", _sfc_render$k]]);
var SdContainer_vue_vue_type_style_index_0_lang = "";
const _sfc_main$k = defineComponent({
  name: "SdContainer",
  props: {
    break: {
      type: String,
      default: void 0
    },
    full: Boolean,
    article: Boolean
  },
  setup(props, { slots }) {
    const classes = computed(() => {
      if (props.full) {
        return "sd--container--full";
      } else if (props.break) {
        return `sd--container--${props.break}`;
      } else {
        return "sd--container";
      }
    });
    return () => h(props.article ? "article" : "div", {
      class: classes.value
    }, slots);
  }
});
var SdGrid_vue_vue_type_style_index_0_lang = "";
const _sfc_main$j = defineComponent({
  name: "SdGrid",
  props: {
    columns: {
      type: [Number, String],
      default: 12
    },
    gutter: {
      type: [Number, String, Array],
      default: null
    }
  },
  setup(props) {
    const isArray = computed(() => {
      return Array.isArray(props.gutter);
    });
    const handleGap = computed(() => {
      if (isArray.value) {
        return `${props.gutter[0]}px ${props.gutter[1]}px`;
      } else {
        return props.gutter + "px";
      }
    });
    const gridClasses = computed(() => {
      return {
        [`sd--grid--${props.columns}`]: true
      };
    });
    const gridStyles = computed(() => {
      return {
        "gap": handleGap.value
      };
    });
    return {
      gridStyles,
      handleGap,
      gridClasses
    };
  }
});
function _sfc_render$j(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("div", {
    class: normalizeClass(["sd--grid", [_ctx.gridClasses]]),
    style: normalizeStyle(_ctx.gridStyles)
  }, [
    renderSlot(_ctx.$slots, "default")
  ], 6);
}
var SdGrid = /* @__PURE__ */ _export_sfc(_sfc_main$j, [["render", _sfc_render$j]]);
var SdCell_vue_vue_type_style_index_0_lang = "";
const _sfc_main$i = defineComponent({
  name: "SdCell",
  props: {
    span: {
      type: [Number, String],
      default: 0
    },
    xs: {
      type: [Number, String],
      default: 12
    },
    sm: {
      type: [Number, String],
      default: 0
    },
    md: {
      type: [Number, String],
      default: 0
    },
    lg: {
      type: [Number, String],
      default: 0
    },
    xl: {
      type: [Number, String],
      default: 0
    },
    oXs: {
      type: [Number, String],
      default: 0
    },
    oSm: {
      type: [Number, String],
      default: 0
    },
    oMd: {
      type: [Number, String],
      default: 0
    },
    oLg: {
      type: [Number, String],
      default: 0
    },
    oXl: {
      type: [Number, String],
      default: 0
    },
    align: {
      type: String,
      default: void 0
    },
    justify: {
      type: String,
      default: void 0
    }
  },
  setup(props) {
    const cellStyles = computed(() => {
      return {
        "align-self": props.align,
        "justify-self": props.justify
      };
    });
    const cellClasses = computed(() => {
      return {
        [`sd--cell-xs-${props.xs}`]: props.xs,
        [`sd--cell-sm-${props.sm}`]: props.sm,
        [`sd--cell-md-${props.md}`]: props.md,
        [`sd--cell-lg-${props.lg}`]: props.lg,
        [`sd--cell-xl-${props.xl}`]: props.xl,
        [`sd--cell-xs-offset-${props.oXs}`]: props.oXs,
        [`sd--cell-sm-offset-${props.oSm}`]: props.oSm,
        [`sd--cell-md-offset-${props.oMd}`]: props.oMd,
        [`sd--cell-lg-offset-${props.oLg}`]: props.oLg,
        [`sd--cell-xl-offset-${props.oXl}`]: props.oXl
      };
    });
    return {
      cellStyles,
      cellClasses
    };
  }
});
function _sfc_render$i(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("div", {
    class: normalizeClass(["sd--cell", _ctx.cellClasses]),
    style: normalizeStyle(_ctx.cellStyles)
  }, [
    renderSlot(_ctx.$slots, "default")
  ], 6);
}
var SdCell = /* @__PURE__ */ _export_sfc(_sfc_main$i, [["render", _sfc_render$i]]);
const roundTo = (n, digits) => {
  let negative = false;
  if (digits === void 0) {
    digits = 0;
  }
  if (n < 0) {
    negative = true;
    n = n * -1;
  }
  const multiplicator = Math.pow(10, digits);
  n = parseFloat((n * multiplicator).toFixed(11));
  n = (Math.round(n) / multiplicator).toFixed(digits);
  if (negative) {
    n = parseFloat((n * -1).toFixed(digits));
  }
  return n;
};
const minMax = (min2, value, max2) => {
  return Math.max(min2, Math.min(value, max2));
};
const pctComplete = (value, maxValue) => {
  return roundTo(minMax(0, value / maxValue, 1), 2);
};
const quantizeValue = (value, step) => {
  return Number(Math.round(value / step) * step);
};
const convertValueToPx = (value, min2, max2, width) => {
  return minMax(0, Math.round((value - min2) / (max2 - min2) * width), width);
};
const singleUnitValue = (step, min2, max2, width) => {
  return minMax(0, Math.round(step / (max2 - min2) * width), width);
};
const convertToValue = (percentComplete, min2, max2) => {
  return min2 + percentComplete * (max2 - min2);
};
const useSlider = (props, emit) => {
  const slider = ref(null);
  const handle = ref(null);
  const isFocused = useKeyboardFocus(handle);
  const state = reactive({
    init: false,
    computedX: 0,
    x: 0,
    minX: 0,
    maxX: 0,
    dragStartX: 0,
    handleWidth: 0,
    handleHeight: 0,
    handleOffset: 0,
    unit: 0,
    pctComplete: 0,
    isHover: false,
    isDragging: false
  });
  const handleHover = (e) => {
    if (e.type === "mouseenter") {
      state.isHover = true;
    }
    if (e.type === "mouseleave") {
      state.isHover = false;
    }
  };
  const handleIncrementUp = () => {
    state.x = state.computedX + state.unit;
    state.pctComplete = pctComplete(state.x, state.maxX);
  };
  const handleIncrementDown = () => {
    state.x = state.computedX - state.unit;
    state.pctComplete = pctComplete(state.x, state.maxX);
  };
  const handleIncrementMax = () => {
    state.x = state.maxX;
    state.pctComplete = 1;
  };
  const handleIncrementMin = () => {
    state.x = 0;
    state.pctComplete = 0;
  };
  const onKeydown = (e) => {
    switch (e.key) {
      case "ArrowLeft":
      case "PageUp":
      case "ArrowDown":
        e.preventDefault();
        handleIncrementDown();
        break;
      case "ArrowRight":
      case "PageDown":
      case "ArrowUp":
        e.preventDefault();
        handleIncrementUp();
        break;
      case "Home":
        e.preventDefault();
        handleIncrementMin();
        break;
      case "End":
        e.preventDefault();
        handleIncrementMax();
        break;
    }
  };
  const handleMouseWheel = (e) => {
    if (e.wheelDelta > 0) {
      handleIncrementUp();
    } else {
      handleIncrementDown();
    }
  };
  const handleMove = (e) => {
    const { clientX } = e;
    state.x = Math.max(0, Math.min(clientX - state.dragStartX, state.maxX));
    state.pctComplete = pctComplete(state.x, state.maxX);
  };
  const handleStart = (e) => {
    const { clientX } = e;
    const clickX = Math.round(clientX - state.handleOffset);
    state.x = Math.max(0, Math.min(clickX, state.maxX));
    state.dragStartX = clientX - state.x;
    state.pctComplete = pctComplete(state.x, state.maxX);
    state.isDragging = true;
  };
  const handleEnd = () => {
    state.isDragging = false;
    state.dragStartX = 0;
  };
  const onMouseWheel = (e) => {
    e.preventDefault();
    handleMouseWheel(e);
  };
  const onMouseMove = (e) => {
    e.preventDefault();
    handleMove(e);
  };
  const onMouseDown = (e) => {
    handleStart(e);
    document.addEventListener("mouseup", onMouseUp, { passive: true });
    document.addEventListener("mousemove", onMouseMove, { passive: false });
  };
  const onMouseUp = (e) => {
    handleEnd();
    document.removeEventListener("mouseup", onMouseUp);
    document.removeEventListener("mousemove", onMouseMove);
    document.removeEventListener("mousedown", onMouseDown);
  };
  const onTouchMove = (e) => {
    const { touches } = e;
    e.preventDefault();
    handleMove(touches[0]);
  };
  const onTouchStart = (e) => {
    const { touches } = e;
    handleStart(touches[0]);
    document.addEventListener("touchend", onTouchEnd, { passive: true });
    document.addEventListener("touchmove", onTouchMove, { passive: false });
  };
  const onTouchEnd = () => {
    handleEnd();
    document.removeEventListener("touchstart", onTouchStart);
    document.removeEventListener("touchend", onTouchEnd);
    document.removeEventListener("touchmove", onTouchMove);
  };
  const handleWindowResize = () => {
    nextTick().then(() => {
      if (slider.value instanceof HTMLElement && handle.value instanceof HTMLElement) {
        const rect = slider.value.getBoundingClientRect();
        state.handleOffset = Math.round(rect.left);
        state.maxX = Math.round(slider.value.clientWidth);
        state.handleWidth = Math.round(handle.value.clientWidth);
      }
    });
  };
  watchEffect(() => {
    if (slider.value instanceof HTMLElement && handle.value instanceof HTMLElement) {
      const rect = slider.value.getBoundingClientRect();
      state.init = true;
      state.handleWidth = Math.round(handle.value.clientWidth);
      state.handleOffset = Math.round(rect.left);
      state.maxX = Math.round(slider.value.clientWidth);
      state.computedX = convertValueToPx(props.modelValue, props.min, props.max, state.maxX);
      state.unit = singleUnitValue(props.step, props.min, props.max, state.maxX);
      slider.value.addEventListener("touchstart", onTouchStart, { passive: true });
      slider.value.addEventListener("mousedown", onMouseDown);
      slider.value.addEventListener("mouseenter", handleHover, { passive: true });
      slider.value.addEventListener("mouseleave", handleHover, { passive: true });
      if (isFocused.value) {
        handle.value.addEventListener("keydown", onKeydown, { passive: false });
      } else {
        handle.value.removeEventListener("keydown", onKeydown);
      }
    }
  }, { flush: "post" });
  watch(() => state.isHover, (next) => {
    if (slider.value instanceof HTMLElement && next) {
      if (props.useWheel && state.isHover) {
        slider.value.addEventListener("wheel", onMouseWheel, { passive: false });
      } else {
        slider.value.removeEventListener("wheel", onMouseWheel);
      }
    }
  });
  const result = computed(() => {
    const currentValue = convertToValue(state.pctComplete, props.min, props.max);
    const quantize = quantizeValue(currentValue, props.step);
    if (currentValue !== props.max && currentValue !== props.min) {
      return minMax(props.min, quantize, props.max);
    }
    return roundTo(minMax(props.min, currentValue, props.max), 2);
  });
  watch(() => result.value, (next) => {
    emit("update:modelValue", next);
  });
  onMounted(() => {
    window.addEventListener("resize", handleWindowResize);
  });
  onUnmounted(() => {
    window.removeEventListener("resize", handleWindowResize);
    if (slider.value instanceof HTMLElement) {
      slider.value.removeEventListener("mouseenter", handleHover);
      slider.value.removeEventListener("mouseleave", handleHover);
    }
  });
  return __spreadProps(__spreadValues({}, toRefs(state)), {
    slider,
    handle,
    result,
    isFocused
  });
};
var SdSlider_vue_vue_type_style_index_0_lang = "";
const _sfc_main$h = defineComponent({
  name: "SdSlider",
  components: {
    SdTooltip,
    SdLabel
  },
  props: {
    label: {
      type: String,
      default: ""
    },
    modelValue: {
      type: Number,
      required: true
    },
    min: {
      type: Number,
      default: 1
    },
    max: {
      type: Number,
      default: 100
    },
    step: {
      type: Number,
      default: 1
    },
    showIndicators: {
      type: Boolean
    },
    showTicks: {
      type: Boolean
    },
    showTooltip: {
      type: Boolean,
      default: false
    },
    useWheel: {
      type: Boolean
    },
    hint: {
      type: String,
      default: ""
    }
  },
  emits: ["update:modelValue"],
  setup(props, { emit }) {
    const {
      slider,
      handle,
      result,
      computedX,
      handleWidth,
      isDragging,
      isFocused,
      isHover
    } = useSlider(props, emit);
    const renderTooltip = ref(isDragging || isFocused);
    const tickCount = computed(() => {
      const ticks = (props.max - props.min) / props.step;
      return minMax(2, ticks, 100);
    });
    const thumbTrackStyle = computed(() => {
      return {
        width: computedX.value + handleWidth.value / 2 + "px"
      };
    });
    const thumbStyle = computed(() => {
      return {
        transition: "transform .23s ease-in-out",
        position: "absolute",
        left: computedX.value - handleWidth.value / 2 + "px",
        cursor: isDragging.value ? "grab" : "pointer",
        zIndex: isDragging.value ? 1e3 : 0
      };
    });
    const thumbClass = computed(() => {
      return {
        "is--dragging": isDragging.value,
        "is--focused": isFocused.value
      };
    });
    return {
      slider,
      handle,
      thumbStyle,
      thumbClass,
      thumbTrackStyle,
      result,
      tickCount,
      isFocused,
      isDragging,
      isHover,
      renderTooltip
    };
  }
});
const _hoisted_1$e = { class: "sd--slider" };
const _hoisted_2$4 = { class: "sd--slider__container" };
const _hoisted_3$4 = {
  key: 0,
  class: "sd--slider__min"
};
const _hoisted_4$3 = {
  class: "sd--slider__content",
  ref: "slider"
};
const _hoisted_5$2 = { class: "sd--slider__track-container" };
const _hoisted_6$1 = {
  key: 0,
  class: "sd--slider__ticks"
};
const _hoisted_7 = /* @__PURE__ */ createElementVNode("svg", {
  class: "sd--slider__thumb",
  width: "24",
  height: "24"
}, [
  /* @__PURE__ */ createElementVNode("circle", {
    cx: "12",
    cy: "12",
    r: "12"
  })
], -1);
const _hoisted_8 = { class: "sd--center sd--big" };
const _hoisted_9 = {
  key: 0,
  class: "sd--slider__pulse"
};
const _hoisted_10 = {
  key: 1,
  class: "sd--slider__max"
};
const _hoisted_11 = {
  key: 1,
  class: "sd--text__footnote"
};
function _sfc_render$h(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_sd_label = resolveComponent("sd-label");
  const _component_sd_tooltip = resolveComponent("sd-tooltip");
  return openBlock(), createElementBlock("div", _hoisted_1$e, [
    _ctx.label ? (openBlock(), createBlock(_component_sd_label, { key: 0 }, {
      default: withCtx(() => [
        createTextVNode(toDisplayString(_ctx.label), 1)
      ]),
      _: 1
    })) : createCommentVNode("", true),
    renderSlot(_ctx.$slots, "label"),
    createElementVNode("div", _hoisted_2$4, [
      _ctx.showIndicators ? (openBlock(), createElementBlock("div", _hoisted_3$4, toDisplayString(_ctx.min), 1)) : createCommentVNode("", true),
      createElementVNode("div", _hoisted_4$3, [
        createElementVNode("div", _hoisted_5$2, [
          _ctx.showTicks ? (openBlock(), createElementBlock("div", _hoisted_6$1, [
            (openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.tickCount, (n) => {
              return openBlock(), createElementBlock("div", {
                class: "sd--slider__tick",
                key: n
              });
            }), 128))
          ])) : createCommentVNode("", true),
          createElementVNode("div", {
            class: "sd--slider__track",
            style: normalizeStyle(_ctx.thumbTrackStyle)
          }, null, 4)
        ]),
        createElementVNode("div", {
          ref: "handle",
          class: normalizeClass(["sd--slider__thumb-container", _ctx.thumbClass]),
          tabindex: "0",
          style: normalizeStyle(_ctx.thumbStyle)
        }, [
          _hoisted_7,
          _ctx.showTooltip ? (openBlock(), createBlock(_component_sd_tooltip, {
            key: 0,
            ref: "ttip",
            "portal-disabled": "",
            "auto-open": false,
            "show-arrow": false,
            offset: [0, 8],
            modelValue: _ctx.renderTooltip,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => _ctx.renderTooltip = $event)
          }, {
            default: withCtx(() => [
              createElementVNode("div", _hoisted_8, toDisplayString(_ctx.result), 1)
            ]),
            _: 1
          }, 8, ["modelValue"])) : createCommentVNode("", true),
          createVNode(Transition, { name: "dragging" }, {
            default: withCtx(() => [
              _ctx.isDragging || _ctx.isFocused ? (openBlock(), createElementBlock("div", _hoisted_9)) : createCommentVNode("", true)
            ]),
            _: 1
          })
        ], 6)
      ], 512),
      _ctx.showIndicators ? (openBlock(), createElementBlock("div", _hoisted_10, toDisplayString(_ctx.max), 1)) : createCommentVNode("", true)
    ]),
    _ctx.hint ? (openBlock(), createElementBlock("small", _hoisted_11, toDisplayString(_ctx.hint), 1)) : createCommentVNode("", true),
    renderSlot(_ctx.$slots, "hint")
  ]);
}
var SdSlider = /* @__PURE__ */ _export_sfc(_sfc_main$h, [["render", _sfc_render$h]]);
var SdProgress_vue_vue_type_style_index_0_lang = "";
const _sfc_main$g = defineComponent({
  name: "SdProgress",
  components: { SdLabel },
  props: {
    label: {
      type: String,
      default: void 0
    },
    hint: {
      type: String,
      default: void 0
    },
    total: {
      type: Number,
      default: void 0
    },
    current: {
      type: Number,
      default: void 0
    },
    theme: {
      type: String,
      default: "primary"
    },
    progress: {
      type: Number,
      default: void 0
    },
    decimalPlaces: {
      type: Number,
      default: 0
    },
    animated: Boolean
  },
  setup(props) {
    const progressDisplay = computed(() => {
      if (props.progress) {
        return roundTo(props.progress * 100, props.decimalPlaces) + "%";
      }
      if (props.current && props.total) {
        return roundTo(props.current / props.total * 100, props.decimalPlaces) + "%";
      } else {
        return "";
      }
    });
    const computedClasses = computed(() => {
      const theme = `sd--progress__rail--${props.theme}`;
      return {
        [theme]: true,
        "sd--progress__rail": true,
        "is--animated": props.animated
      };
    });
    const computedStyles = computed(() => {
      return {
        width: progressDisplay.value,
        maxWidth: "100%",
        transition: props.animated ? "width .23s ease-in-out" : "unset"
      };
    });
    return {
      computedStyles,
      progressDisplay,
      computedClasses
    };
  }
});
const _hoisted_1$d = { class: "sd--progress" };
const _hoisted_2$3 = { class: "sd--progress__track" };
const _hoisted_3$3 = { class: "sd--progress__footer" };
const _hoisted_4$2 = {
  key: 0,
  class: "sd--text__footnote"
};
function _sfc_render$g(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_sd_label = resolveComponent("sd-label");
  return openBlock(), createElementBlock("div", _hoisted_1$d, [
    createVNode(_component_sd_label, null, {
      default: withCtx(() => [
        createTextVNode(toDisplayString(_ctx.label), 1)
      ]),
      _: 1
    }),
    createElementVNode("div", _hoisted_2$3, [
      createElementVNode("div", {
        class: normalizeClass([_ctx.computedClasses]),
        style: normalizeStyle([_ctx.computedStyles])
      }, [
        createElementVNode("span", null, toDisplayString(_ctx.progressDisplay), 1)
      ], 6)
    ]),
    createElementVNode("div", _hoisted_3$3, [
      renderSlot(_ctx.$slots, "hint", {}, () => [
        _ctx.hint ? (openBlock(), createElementBlock("span", _hoisted_4$2, toDisplayString(_ctx.hint), 1)) : createCommentVNode("", true)
      ])
    ])
  ]);
}
var SdProgress = /* @__PURE__ */ _export_sfc(_sfc_main$g, [["render", _sfc_render$g]]);
var SdDropdown_vue_vue_type_style_index_0_lang = "";
const _sfc_main$f = defineComponent({
  components: { SdFocusTrap },
  name: "SdDropdown",
  emits: ["update:modelValue", "open", "close"],
  props: {
    modelValue: Boolean,
    theme: {
      type: [String],
      default: "default"
    },
    delay: {
      type: [String, Number],
      default: 100
    },
    placement: {
      type: String,
      default: "bottom"
    },
    autoClose: {
      type: Boolean,
      default: false
    },
    offset: {
      type: Array,
      default: () => [0, 8]
    },
    trigger: {
      type: String,
      default: null
    },
    portalToBody: {
      type: Boolean,
      default: true
    },
    lazy: {
      type: Boolean,
      default: true
    },
    closeOnClick: {
      type: Boolean,
      default: false
    }
  },
  setup(props, { emit }) {
    const dropdownPortal = ref(null);
    const dropdownRef = ref(null);
    const dropdownContent = ref(null);
    const themeClass = computed(() => `is--${props.theme}`);
    const state = reactive({
      targetEl: null,
      popperInstance: null,
      shouldRender: false,
      trapActive: false
    });
    const options = reactive({
      placement: props.placement,
      modifiers: [
        {
          name: "offset",
          options: {
            mainAxis: false,
            offset: ({ placement, reference: reference2, popper: popper2 }) => {
              if (placement === "bottom") {
                return [popper2.width / 2 - reference2.width / 2, 8];
              } else {
                return props.offset;
              }
            }
          }
        },
        {
          name: "preventOverflow",
          options: {
            boundary: "viewport",
            rootBoundary: "document"
          }
        }
      ]
    });
    watch(() => props.modelValue, () => {
      state.shouldRender = props.modelValue;
    });
    const makePopper = () => {
      state.popperInstance = createPopper(state.targetEl, dropdownRef.value, options);
    };
    const killPopper = () => {
      if (state.popperInstance) {
        state.popperInstance.destroy();
        state.popperInstance = null;
      }
    };
    const resetPopper = () => {
      if (state.popperInstance) {
        killPopper();
        makePopper();
      }
    };
    const bindPopper = () => {
      nextTick().then(() => {
        if (state.targetEl) {
          makePopper();
        }
      });
    };
    watch(() => state.shouldRender, (shouldRender) => {
      if (shouldRender) {
        bindPopper();
      } else {
        hide2();
      }
    });
    const show = () => {
      state.shouldRender = true;
      state.trapActive = true;
      document.addEventListener("mouseup", clickOutside, { passive: true });
      document.addEventListener("touchend", clickOutside, { passive: true });
      emit("update:modelValue", true);
      emit("open");
    };
    const hide2 = () => {
      state.shouldRender = false;
      state.trapActive = false;
      document.removeEventListener("mouseup", clickOutside);
      document.removeEventListener("touchend", clickOutside);
      emit("update:modelValue", false);
      emit("close");
    };
    const clickOutside = (e) => {
      const dropdown = (e == null ? void 0 : e.composedPath()[0]) || e.target;
      if (dropdown instanceof Node) {
        if (dropdownRef.value !== null && !dropdownRef.value.contains(dropdown) || props.closeOnClick) {
          state.shouldRender = false;
        }
      }
    };
    const mountEventBindings = async () => {
      await nextTick().then(() => {
        if (props.portalToBody) {
          state.targetEl = dropdownPortal.value.parentNode;
        }
        if (props.trigger) {
          state.targetEl = document.querySelector("#" + props.trigger);
          state.targetEl.addEventListener("click", SdThrottle(600, () => show()), { passive: true });
          state.targetEl.addEventListener("touch", SdThrottle(600, () => show()), { passive: true });
        }
      });
    };
    onMounted(() => {
      mountEventBindings();
      resetPopper();
    });
    onUnmounted(() => {
    });
    return {
      state,
      dropdownPortal,
      dropdownRef,
      dropdownContent,
      themeClass,
      hide: hide2
    };
  }
});
const _hoisted_1$c = {
  key: 0,
  ref: "dropdownRef",
  class: "sd--dropdown"
};
function _sfc_render$f(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_sd_focus_trap = resolveComponent("sd-focus-trap");
  return openBlock(), createBlock(Teleport, {
    ref: "dropdownPortal",
    to: "#app",
    disabled: !_ctx.portalToBody
  }, [
    createVNode(Transition, { name: "dropdown" }, {
      default: withCtx(() => [
        _ctx.state.shouldRender ? (openBlock(), createElementBlock("div", _hoisted_1$c, [
          createVNode(_component_sd_focus_trap, {
            target: _ctx.dropdownContent,
            modelValue: _ctx.state.shouldRender,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => _ctx.state.shouldRender = $event),
            "outside-click": true
          }, {
            default: withCtx(() => [
              createElementVNode("div", {
                ref: "dropdownContent",
                class: normalizeClass(["sd--dropdown__content", _ctx.themeClass])
              }, [
                renderSlot(_ctx.$slots, "default")
              ], 2)
            ]),
            _: 3
          }, 8, ["target", "modelValue"])
        ], 512)) : createCommentVNode("", true)
      ]),
      _: 3
    })
  ], 8, ["disabled"]);
}
var SdDropdown = /* @__PURE__ */ _export_sfc(_sfc_main$f, [["render", _sfc_render$f]]);
var SdDropdownHeader_vue_vue_type_style_index_0_lang = "";
const _sfc_main$e = {
  name: "SdDropdownHeader"
};
const _hoisted_1$b = { class: "sd--dropdown__header" };
function _sfc_render$e(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("div", _hoisted_1$b, [
    renderSlot(_ctx.$slots, "default")
  ]);
}
var SdDropdownHeader = /* @__PURE__ */ _export_sfc(_sfc_main$e, [["render", _sfc_render$e]]);
var SdDropdownMenu_vue_vue_type_style_index_0_lang = "";
const _sfc_main$d = {
  name: "SdDropdownMenu",
  props: {
    title: {
      type: String,
      default: ""
    }
  },
  components: { SdDropdownHeader }
};
const _hoisted_1$a = { class: "sd--dropdown__menu" };
function _sfc_render$d(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_sd_dropdown_header = resolveComponent("sd-dropdown-header");
  return openBlock(), createElementBlock("div", _hoisted_1$a, [
    $props.title ? (openBlock(), createBlock(_component_sd_dropdown_header, { key: 0 }, {
      default: withCtx(() => [
        createTextVNode(toDisplayString($props.title), 1)
      ]),
      _: 1
    })) : createCommentVNode("", true),
    renderSlot(_ctx.$slots, "default")
  ]);
}
var SdDropdownMenu = /* @__PURE__ */ _export_sfc(_sfc_main$d, [["render", _sfc_render$d]]);
var SdMenu_vue_vue_type_style_index_0_lang = "";
const _sfc_main$c = defineComponent({
  name: "SdMenu",
  props: {
    modelValue: {
      type: Boolean,
      default: false
    },
    keyboard: {
      type: Boolean,
      default: true
    },
    theme: {
      type: String,
      default: "dark"
    },
    id: {
      type: String,
      default: () => "sd--menu--" + sdUuid()
    }
  },
  emits: ["update:modelValue"],
  setup(props, { emit }) {
    const menuRef = ref(null);
    const triggerEl = ref(null);
    const activate = ref(false);
    watch(() => props.modelValue, (next) => {
      if (next) {
        activate.value = next;
      }
    });
    watch(() => activate.value, (next) => {
      if (next) {
        emit("update:modelValue", activate.value);
      }
    });
    const toggleMenu = () => {
      activate.value = !activate.value;
    };
    const themeClass = computed(() => {
      return {
        [`sd-menu__${props.theme}`]: !!props.theme
      };
    });
    const handleKeypress = (e) => {
      if (props.keyboard && (e.key === "Enter" || e.code === "Space")) {
        e.preventDefault();
        activate.value = !activate.value;
      }
    };
    watchPostEffect(() => {
      if (menuRef.value instanceof HTMLElement) {
        triggerEl.value = menuRef.value.querySelector("[trigger]");
        triggerEl.value.addEventListener("mouseup", toggleMenu, { passive: true });
        triggerEl.value.addEventListener("keydown", handleKeypress, { passive: false });
      }
    });
    onUnmounted(() => {
      if (triggerEl.value) {
        triggerEl.value.removeEventListener("mouseup", toggleMenu);
        triggerEl.value.removeEventListener("keydown", handleKeypress);
      }
    });
    provide("activate", activate);
    provide("menuEl", menuRef);
    provide("triggerEl", triggerEl);
    return {
      menuRef,
      themeClass
    };
  }
});
const _hoisted_1$9 = ["id"];
function _sfc_render$c(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("div", {
    id: _ctx.id,
    class: "sd--menu__wrapper",
    ref: "menuRef"
  }, [
    renderSlot(_ctx.$slots, "default")
  ], 8, _hoisted_1$9);
}
var SdMenu = /* @__PURE__ */ _export_sfc(_sfc_main$c, [["render", _sfc_render$c]]);
const SdContains = (parent, child) => {
  if (typeof Node.prototype.contains === "function") {
    return Node.prototype.contains.call(parent, child);
  } else {
    return (Node.prototype.compareDocumentPosition.call(child, parent) && Node.prototype.DOCUMENT_POSITION_CONTAINS) !== 0;
  }
};
var SdMenuContent_vue_vue_type_style_index_0_lang = "";
const _sfc_main$b = defineComponent({
  components: { SdFocusTrap },
  name: "SdMenuContent",
  props: {
    id: {
      type: String,
      default: () => "sd-menu-" + sdUuid()
    },
    theme: {
      type: String,
      default: ""
    },
    delay: {
      type: Number,
      default: 0
    },
    placement: {
      type: String,
      default: "bottom-start"
    },
    outsideClick: {
      type: Boolean,
      default: true
    },
    closeOnClick: {
      type: Boolean,
      default: true
    },
    portalTo: {
      type: String,
      default: "body"
    },
    portalDisabled: {
      type: Boolean,
      default: false
    },
    offset: {
      type: Array,
      default: () => [0, 0]
    },
    full: {
      type: Boolean,
      default: false
    }
  },
  emits: ["opened", "closed"],
  setup(props, { emit }) {
    const activate = inject("activate", false);
    const menuEl = inject("menuEl", null);
    const triggerEl = inject("triggerEl", null);
    const { shouldRender, targetRef, instanceRef } = usePopper(props, emit, activate);
    const state = reactive({
      parentWidth: 0
    });
    const computedStyles = computed(() => {
      if (props.full) {
        return {
          minWidth: `${state.parentWidth}px`
        };
      }
      return false;
    });
    const isTrigger = ({ target }) => {
      return SdContains(triggerEl.value, target);
    };
    const isMenu = ({ target }) => {
      return menuEl.value ? SdContains(menuEl.value, target) : false;
    };
    const isMenuContent = ({ target }) => {
      return instanceRef.value ? SdContains(instanceRef.value, target) : false;
    };
    const handleClickEvents = (event) => {
      if (document && activate.value && !isTrigger(event)) {
        const insideClick = isMenu(event) && (props.closeOnClick && isMenuContent(event));
        const outsideClick = !isMenu(event) && (props.outsideClick && !isMenuContent(event));
        if (insideClick || outsideClick) {
          activate.value = false;
          window.removeEventListener("resize", handleWindowResize);
          document.body.removeEventListener("mouseup", handleClickEvents);
          document.body.removeEventListener("keyup", onKeydown);
        }
      }
    };
    const onKeydown = (e) => {
      switch (e.key) {
        case "Escape":
          e.stopPropagation();
          activate.value = false;
          break;
      }
    };
    const createKeyboardObserver = () => {
      document.body.addEventListener("keyup", onKeydown, { passive: false });
    };
    const createClickObserver = () => {
      document.body.addEventListener("mouseup", handleClickEvents, { passive: true });
    };
    const createResizeObserver = () => {
      window.addEventListener("resize", handleWindowResize, { passive: true });
    };
    const handleWindowResize = () => {
      if (menuEl.value instanceof HTMLElement) {
        state.parentWidth = menuEl.value.getBoundingClientRect().width;
      }
    };
    watchEffect(() => {
      if (activate.value && instanceRef.value instanceof HTMLElement) {
        createClickObserver();
        handleWindowResize();
        createKeyboardObserver();
        createResizeObserver();
      }
    }, { flush: "post" });
    return {
      shouldRender,
      targetRef,
      instanceRef,
      computedStyles,
      state,
      triggerEl
    };
  }
});
const _hoisted_1$8 = ["id"];
function _sfc_render$b(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_sd_focus_trap = resolveComponent("sd-focus-trap");
  return openBlock(), createBlock(Teleport, {
    ref: "targetRef",
    to: _ctx.portalDisabled ? null : _ctx.portalTo,
    disabled: _ctx.portalDisabled
  }, [
    createVNode(Transition, { name: "menu" }, {
      default: withCtx(() => [
        _ctx.shouldRender ? (openBlock(), createElementBlock("div", {
          key: 0,
          id: _ctx.id,
          ref: "instanceRef",
          class: "sd--menu",
          style: normalizeStyle(_ctx.computedStyles)
        }, [
          createVNode(_component_sd_focus_trap, {
            target: _ctx.instanceRef,
            "set-return-focus": _ctx.triggerEl,
            modelValue: _ctx.shouldRender,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => _ctx.shouldRender = $event)
          }, {
            default: withCtx(() => [
              renderSlot(_ctx.$slots, "default")
            ]),
            _: 3
          }, 8, ["target", "set-return-focus", "modelValue"])
        ], 12, _hoisted_1$8)) : createCommentVNode("", true)
      ]),
      _: 3
    })
  ], 8, ["to", "disabled"]);
}
var SdMenuContent = /* @__PURE__ */ _export_sfc(_sfc_main$b, [["render", _sfc_render$b]]);
var SdChicklet_vue_vue_type_style_index_0_lang = "";
const _sfc_main$a = defineComponent({
  name: "SdChicklet",
  components: { SdIcon },
  props: {
    icon: {
      type: String,
      default: ""
    },
    theme: {
      type: String,
      default: "primary"
    },
    size: {
      type: String,
      default: "md"
    },
    dismissable: Boolean
  },
  setup(props) {
    const classes = computed(() => {
      return {
        [`sd--chicklet__${props.theme}`]: true,
        [`is--${props.size}`]: props.size,
        "is--dismissable": props.dismissable
      };
    });
    return {
      classes
    };
  }
});
const _hoisted_1$7 = { class: "sd--chicklet__content" };
function _sfc_render$a(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_sd_icon = resolveComponent("sd-icon");
  return openBlock(), createElementBlock("div", {
    class: normalizeClass(["sd--chicklet", _ctx.classes])
  }, [
    _ctx.icon ? (openBlock(), createBlock(_component_sd_icon, {
      key: 0,
      name: _ctx.icon,
      size: "sm"
    }, null, 8, ["name"])) : createCommentVNode("", true),
    createElementVNode("span", _hoisted_1$7, [
      renderSlot(_ctx.$slots, "default")
    ]),
    _ctx.dismissable ? (openBlock(), createBlock(_component_sd_icon, {
      key: 1,
      name: "close",
      size: "sm"
    })) : createCommentVNode("", true)
  ], 2);
}
var SdChicklet = /* @__PURE__ */ _export_sfc(_sfc_main$a, [["render", _sfc_render$a]]);
const deepIndexOf = (arr, obj) => {
  return arr.findIndex((cur) => {
    return Object.keys(obj).every(function(key) {
      return obj[key] === cur[key];
    });
  });
};
var SdChip_vue_vue_type_style_index_0_lang = "";
const _sfc_main$9 = defineComponent({
  name: "SdChip",
  components: { SdChicklet, SdField },
  props: {
    label: {
      type: String,
      default: ""
    },
    placeholder: {
      type: String,
      default: ""
    },
    theme: {
      type: String,
      default: "primary"
    },
    error: {
      type: String,
      default: ""
    },
    uppercase: Boolean,
    lowercase: Boolean,
    captialize: Boolean,
    checkDuplicated: {
      type: Boolean,
      default: true
    },
    modelValue: {
      type: Array,
      default: () => []
    }
  },
  emits: ["update:modelValue", "delete", "inset"],
  setup(props, { emit }) {
    const inputRef = ref(null);
    const state = reactive({
      value: "",
      chipList: [],
      duplicatedChip: null,
      focusInput: null
    });
    const handleEnter = () => {
      if (!state.duplicatedChip && state.value) {
        state.chipList = [
          ...state.chipList,
          formattedInputVal.value
        ];
        state.value = "";
        emit("update:modelValue", state.chipList);
        emit("inset", state.chipList);
      }
    };
    const removeChip = (chip) => {
      const index = deepIndexOf(props.modelValue, chip);
      state.chipList.splice(index, 1);
      emit("update:modelValue", state.chipList);
      emit("delete", chip, index);
      nextTick(() => {
        state.focusInput = true;
      });
    };
    const handleBlur = () => {
      if (state.focusInput) {
        state.focusInput = false;
      }
    };
    const formattedInputVal = computed(() => {
      if (props.captialize) {
        return state.value.charAt(0).toUpperCase() + state.value.slice(1);
      }
      if (props.uppercase) {
        return state.value.toUpperCase();
      }
      if (props.lowercase) {
        return state.value.toLowerCase();
      }
      return state.value;
    });
    const checkDuplicate = () => {
      if (!state.chipList.includes(formattedInputVal.value)) {
        state.duplicatedChip = null;
        return false;
      }
      if (!props.checkDuplicated) {
        return false;
      }
      state.duplicatedChip = formattedInputVal.value;
    };
    const handleBackspace = () => {
      if (!state.value) {
        removeChip(state.chipList[props.modelValue.length - 1]);
      }
    };
    watch(() => state.value, () => {
      checkDuplicate();
    });
    watchEffect(() => {
      state.chipList = props.modelValue;
    });
    return { state, handleEnter, handleBackspace, removeChip, inputRef, checkDuplicate, handleBlur };
  }
});
const _hoisted_1$6 = { class: "sd--chip" };
function _sfc_render$9(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_sd_chicklet = resolveComponent("sd-chicklet");
  const _component_sd_field = resolveComponent("sd-field");
  return openBlock(), createElementBlock("div", _hoisted_1$6, [
    createVNode(_component_sd_field, {
      ref: "inputRef",
      label: _ctx.label,
      "set-focus": _ctx.state.focusInput,
      placeholder: _ctx.placeholder,
      onKeyup: withKeys(_ctx.handleEnter, ["enter"]),
      onKeydown: withKeys(_ctx.handleBackspace, ["delete"]),
      onBlur: _ctx.handleBlur,
      modelValue: _ctx.state.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => _ctx.state.value = $event)
    }, {
      addon: withCtx(() => [
        createVNode(TransitionGroup, { name: "fade" }, {
          default: withCtx(() => [
            (openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.state.chipList, (chip, index) => {
              return openBlock(), createBlock(_component_sd_chicklet, {
                theme: _ctx.state.duplicatedChip === chip ? "danger" : _ctx.theme,
                onClick: ($event) => _ctx.removeChip(chip),
                dismissable: "",
                key: index
              }, {
                default: withCtx(() => [
                  createTextVNode(toDisplayString(chip), 1)
                ]),
                _: 2
              }, 1032, ["theme", "onClick"]);
            }), 128))
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["label", "set-focus", "placeholder", "onKeyup", "onKeydown", "onBlur", "modelValue"])
  ]);
}
var SdChip = /* @__PURE__ */ _export_sfc(_sfc_main$9, [["render", _sfc_render$9]]);
var SdSkeleton_vue_vue_type_style_index_0_lang = "";
const _sfc_main$8 = defineComponent({
  name: "SdSkeleton",
  props: {
    minWidth: {
      type: Number,
      default: 80
    },
    maxWidth: {
      type: Number,
      default: 100
    },
    maxHeight: {
      type: Number,
      default: null
    },
    width: {
      type: Number,
      default: null
    },
    height: {
      type: Number,
      default: 16
    }
  },
  setup(props) {
    const computedStyles = computed(() => {
      const randomWidth = Math.floor(Math.random() * (props.maxWidth - props.minWidth)) + props.minWidth + "%";
      return {
        width: props.width || randomWidth,
        height: props.height + "px"
      };
    });
    return {
      computedStyles
    };
  }
});
function _sfc_render$8(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("span", {
    class: "sd--text__skeleton",
    style: normalizeStyle([_ctx.computedStyles])
  }, null, 4);
}
var SdSkeleton = /* @__PURE__ */ _export_sfc(_sfc_main$8, [["render", _sfc_render$8]]);
var SdSheet_vue_vue_type_style_index_0_lang = "";
const _sfc_main$7 = defineComponent({
  name: "SdSheet",
  props: {
    theme: {
      type: String,
      default: "primary"
    },
    fullHeight: Boolean,
    padded: Boolean
  },
  setup(props) {
    const classes = computed(() => {
      const theme = "sd--sheet__" + props.theme;
      return {
        "sd--sheet": true,
        [theme]: true,
        "is--padded": props.padded,
        "is--full-height": props.fullHeight
      };
    });
    return { classes };
  }
});
function _sfc_render$7(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("div", {
    class: normalizeClass([_ctx.classes])
  }, [
    renderSlot(_ctx.$slots, "default")
  ], 2);
}
var SdSheet = /* @__PURE__ */ _export_sfc(_sfc_main$7, [["render", _sfc_render$7]]);
const useToaster = (currentToast, emit) => {
  let timeout = null;
  const promiseToast = (duration, persist) => {
    return new Promise((resolve) => {
      currentToast = {
        destroy: () => {
          currentToast.value = null;
          resolve();
        }
      };
      if (duration !== Infinity) {
        timeout = window.setTimeout(() => {
          if (!persist) {
            destroyToast();
            emit(`update:active`, false);
          }
        }, duration);
      }
    });
  };
  const destroyToast = () => {
    return new Promise((resolve) => {
      if (currentToast.value) {
        window.clearTimeout(timeout);
        currentToast.destroy();
        window.setTimeout(resolve, 400);
        emit("update:active", false);
        emit("closed");
      } else {
        resolve();
      }
    });
  };
  const makeToast = (duration, persist) => {
    if (currentToast.value) {
      return destroyToast().then(() => {
        return promiseToast(duration, persist);
      });
    }
    emit("opened");
    return promiseToast(duration, persist);
  };
  return { makeToast, promiseToast, destroyToast };
};
var SdToast_vue_vue_type_style_index_0_lang = "";
const _sfc_main$6 = defineComponent({
  name: "SdToast",
  components: { SdIcon },
  props: {
    portalDisabled: {
      type: Boolean,
      default: false
    },
    portalTo: {
      type: String,
      default: "#app"
    },
    active: Boolean,
    theme: {
      type: String,
      default: "dark"
    },
    placement: {
      type: String,
      default: "bottom"
    },
    duration: {
      type: Number,
      default: 3e3
    },
    dismissable: Boolean,
    persistant: Boolean
  },
  emits: ["opened", "closed", "update:active"],
  setup(props, { emit }) {
    const state = reactive({
      active: false,
      hover: false
    });
    const currentToast = ref(null);
    const { makeToast, destroyToast } = useToaster(currentToast, emit);
    const classes = computed(() => {
      const placementModifier = `sd--toast--${props.placement}`;
      const themeModifier = `sd--toast__${props.theme}`;
      return {
        [placementModifier]: true,
        [themeModifier]: true,
        "is--active": props.active
      };
    });
    const handleClose = () => {
      emit("update:active", false);
      emit("closed");
    };
    watchEffect(() => {
      if (props.active) {
        makeToast(props.duration, props.persistant);
      } else {
        destroyToast();
      }
    });
    return { state, classes, currentToast, handleClose };
  }
});
const _hoisted_1$5 = { class: "sd--toast__content" };
function _sfc_render$6(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_sd_icon = resolveComponent("sd-icon");
  return openBlock(), createBlock(Teleport, {
    to: _ctx.portalTo,
    disabled: _ctx.portalDisabled
  }, [
    createVNode(Transition, { name: "toast" }, {
      default: withCtx(() => [
        _ctx.active ? (openBlock(), createElementBlock("div", {
          key: 0,
          ref: "currentToast",
          class: normalizeClass(["sd--toast", _ctx.classes, "sd--elevation--12"])
        }, [
          _ctx.dismissable ? (openBlock(), createElementBlock("button", {
            key: 0,
            class: "sd--toast__close",
            onClick: _cache[0] || (_cache[0] = () => _ctx.handleClose())
          }, [
            createVNode(_component_sd_icon, { name: "close" })
          ])) : createCommentVNode("", true),
          createElementVNode("div", _hoisted_1$5, [
            renderSlot(_ctx.$slots, "default")
          ])
        ], 2)) : createCommentVNode("", true)
      ]),
      _: 3
    })
  ], 8, ["to", "disabled"]);
}
var SdToast = /* @__PURE__ */ _export_sfc(_sfc_main$6, [["render", _sfc_render$6]]);
var SdList_vue_vue_type_style_index_0_lang = "";
const _sfc_main$5 = defineComponent({
  name: "SdList"
});
const _hoisted_1$4 = { class: "sd--list" };
function _sfc_render$5(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("ul", _hoisted_1$4, [
    renderSlot(_ctx.$slots, "default")
  ]);
}
var SdList = /* @__PURE__ */ _export_sfc(_sfc_main$5, [["render", _sfc_render$5]]);
var SdListItem_vue_vue_type_style_index_0_lang = "";
const _sfc_main$4 = {
  name: "SdListItem",
  props: {
    active: Boolean,
    collapsed: Boolean,
    loading: Boolean,
    accordion: Boolean
  },
  setup(props) {
    const classes = computed(() => {
      return {
        "is--active": props.active
      };
    });
    return {
      classes
    };
  }
};
function _sfc_render$4(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("li", {
    class: normalizeClass(["sd--list__item", $setup.classes])
  }, [
    renderSlot(_ctx.$slots, "default"),
    renderSlot(_ctx.$slots, "expandable")
  ], 2);
}
var SdListItem = /* @__PURE__ */ _export_sfc(_sfc_main$4, [["render", _sfc_render$4]]);
var SdActionBar_vue_vue_type_style_index_0_lang = "";
const _sfc_main$3 = defineComponent({
  name: "SdActionBar",
  props: {
    title: {
      type: String,
      default: void 0
    }
  },
  setup() {
  }
});
const _hoisted_1$3 = { class: "sd--action-bar" };
const _hoisted_2$2 = { class: "sd--action-bar__header" };
const _hoisted_3$2 = {
  key: 0,
  class: "sd--action-bar__title"
};
const _hoisted_4$1 = { class: "sd--action-bar__body" };
const _hoisted_5$1 = { class: "sd--action-bar__start" };
const _hoisted_6 = { class: "sd--action-bar__end" };
function _sfc_render$3(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("div", _hoisted_1$3, [
    createElementVNode("div", _hoisted_2$2, [
      renderSlot(_ctx.$slots, "title"),
      _ctx.title ? (openBlock(), createElementBlock("h3", _hoisted_3$2, toDisplayString(_ctx.title), 1)) : createCommentVNode("", true)
    ]),
    createElementVNode("div", _hoisted_4$1, [
      createElementVNode("div", _hoisted_5$1, [
        renderSlot(_ctx.$slots, "start")
      ]),
      createElementVNode("div", _hoisted_6, [
        renderSlot(_ctx.$slots, "end")
      ])
    ])
  ]);
}
var SdActionBar = /* @__PURE__ */ _export_sfc(_sfc_main$3, [["render", _sfc_render$3]]);
var SdWidget_vue_vue_type_style_index_0_lang = "";
const _sfc_main$2 = defineComponent({
  name: "SdWidget",
  props: {
    metric: {
      type: String,
      default: void 0
    },
    theme: {
      type: String,
      default: void 0
    },
    caption: {
      type: String,
      default: void 0
    },
    footnote: {
      type: String,
      default: void 0
    },
    clickable: Boolean
  },
  setup(props) {
    const classes = computed(() => {
      const themeClass = `sd--widget__content--${props.theme}`;
      return {
        [themeClass]: !!props.theme,
        "is--clickable": props.clickable
      };
    });
    return {
      classes
    };
  }
});
const _hoisted_1$2 = { class: "sd--widget" };
function _sfc_render$2(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("div", _hoisted_1$2, [
    createElementVNode("div", {
      class: normalizeClass(["sd--widget__content", _ctx.classes])
    }, [
      renderSlot(_ctx.$slots, "default")
    ], 2)
  ]);
}
var SdWidget = /* @__PURE__ */ _export_sfc(_sfc_main$2, [["render", _sfc_render$2]]);
var SdWidgetFooter_vue_vue_type_style_index_0_lang = "";
const _sfc_main$1 = defineComponent({
  name: "SdWidgetFooter",
  components: { SdIcon },
  props: {
    caption: {
      type: String,
      default: void 0
    },
    footnote: {
      type: String,
      default: void 0
    },
    clickable: {
      type: Boolean,
      default: false
    }
  },
  setup() {
  }
});
const _hoisted_1$1 = { class: "sd--widget-footer" };
const _hoisted_2$1 = { class: "sd--widget__footer--start" };
const _hoisted_3$1 = { class: "sd--text__caption" };
const _hoisted_4 = { class: "sd--text__footnote" };
const _hoisted_5 = { class: "sd--widget__footer--end" };
function _sfc_render$1(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_sd_icon = resolveComponent("sd-icon");
  return openBlock(), createElementBlock("div", _hoisted_1$1, [
    createElementVNode("div", _hoisted_2$1, [
      createElementVNode("div", _hoisted_3$1, toDisplayString(_ctx.caption), 1),
      createElementVNode("div", _hoisted_4, toDisplayString(_ctx.footnote), 1)
    ]),
    createElementVNode("div", _hoisted_5, [
      _ctx.clickable ? (openBlock(), createBlock(_component_sd_icon, {
        key: 0,
        name: "chevron_right"
      })) : createCommentVNode("", true)
    ])
  ]);
}
var SdWidgetFooter = /* @__PURE__ */ _export_sfc(_sfc_main$1, [["render", _sfc_render$1]]);
var SdWidgetMetric_vue_vue_type_style_index_0_lang = "";
const _sfc_main = defineComponent({
  name: "SdWidgetMetric",
  props: {
    value: {
      type: [String, Number],
      default: void 0
    },
    note: {
      type: String,
      default: void 0
    }
  }
});
const _hoisted_1 = { class: "sd--widget-metric" };
const _hoisted_2 = {
  key: 0,
  class: "sd--widget-metric__value"
};
const _hoisted_3 = {
  key: 1,
  class: "sd--widget-metric__note"
};
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("div", _hoisted_1, [
    _ctx.value ? (openBlock(), createElementBlock("span", _hoisted_2, toDisplayString(_ctx.value), 1)) : createCommentVNode("", true),
    _ctx.note ? (openBlock(), createElementBlock("span", _hoisted_3, toDisplayString(_ctx.note), 1)) : createCommentVNode("", true),
    renderSlot(_ctx.$slots, "default")
  ]);
}
var SdWidgetMetric = /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render]]);
const components = {
  SdWidget,
  SdWidgetFooter,
  SdWidgetMetric,
  SdSkeleton,
  SdButton: _sfc_main$T,
  SdButtonGroup,
  SdRouterLink,
  SdCard,
  SdCardBody,
  SdCardHeader,
  SdCardFooter,
  SdCardMedia,
  SdFieldset,
  SdLabel,
  SdCheckbox,
  SdRadio,
  SdField,
  SdError,
  SdSimpleSelect,
  SdSelect,
  SdSlider,
  SdSwitch,
  SdChicklet,
  SdChip,
  SdDialog,
  SdDialogHeader,
  SdDialogContent,
  SdDialogFooter,
  SdOverlay,
  SdIcon,
  SdMouse,
  SdTooltip,
  SdHamburger,
  SdLayout,
  SdHeader,
  SdNav,
  SdNavLink,
  SdNavHeading,
  SdRow,
  SdCol,
  SdContainer: _sfc_main$k,
  SdGrid,
  SdCell,
  SdDropdown,
  SdDropdownMenu,
  SdDropdownHeader,
  SdMenu,
  SdMenuContent,
  SdProgress,
  SdSheet,
  SdMast,
  SdActionBar,
  SdToast,
  SdList,
  SdListItem
};
const sdComponentsDesc = Object.keys(components).map((item) => {
  const component = components[item];
  return {
    name: component.name || "sd-comp",
    component
  };
});
const sdInstall = (app) => {
  if (!app) {
    return;
  }
  sdComponentsDesc.forEach((item) => {
    const kebabCaseName = toKebab(item.name);
    const camelCaseName = toCamelCase(`-${kebabCaseName}`);
    const registerComponent = item.component;
    app.component(kebabCaseName, registerComponent);
    app.component(camelCaseName, registerComponent);
  });
  {
    console.info("%cSDUI Component Library", "color: #8F00F8; font-weight: 700; font-size: 12px;");
    console.info("%cGithub: https://github.com/strizich/sdui-vite", "font-size: 8px;");
    console.info("--");
  }
};
const version = version$1;
export { SdActionBar, _sfc_main$T as SdButton, SdCard, SdCardBody, SdCardFooter, SdCardHeader, SdCardMedia, SdCell, SdCheckbox, SdChicklet, SdChip, SdCol, _sfc_main$k as SdContainer, SdDialog, SdDialogContent, SdDialogFooter, SdDialogHeader, SdDropdown, SdDropdownHeader, SdDropdownMenu, SdError, SdField, SdFieldset, SdGrid, SdHamburger, SdHeader, SdIcon, SdLabel, SdLayout, SdList, SdListItem, SdMast, SdMenu, SdMenuContent, SdMouse, SdNav, SdNavHeading, SdNavLink, SdOverlay, SdProgress, SdRadio, SdRouterLink, SdRow, SdSelect, SdSheet, SdSimpleSelect, SdSkeleton, SdSlider, SdSwitch, SdToast, SdTooltip, SdWidget, SdWidgetFooter, SdWidgetMetric, sdInstall, useAlignment, useKeyboardFocus, usePopper, useScheme, useSlider, useToaster, useWindowWidth, version };
